<ion-content #ionContent class="bg-color ion-content integration-update">
  <div class="com-content">
    <div class="content-breadcrumb">
      <ul class="breadcrumb">
        <li *ngFor="let itemList of breadcrumbList" class="breadcrumb-item">
          <ng-container *ngIf="itemList.embedurl; else noRoute">
            <a href="javascript:void(0)" routerLink="{{ itemList.url }}">
              {{ itemList.label }}
            </a>
          </ng-container>
          <ng-template #noRoute>
            <a style="text-decoration: none;" href="javascript:void(0)">
              {{ itemList.label }}
            </a>
          </ng-template>
        </li>
      </ul>
    </div>
    <div class="content-grid" [ngClass]="{'no-about': noAbout == true}">
      <mat-stepper class="create-stepper" labelPosition="bottom" [@.disabled]="true"
        [orientation]="(stepperOrientation | async)!" (selectionChange)="selectionChange($event)">
        <mat-step [stepControl]="dataSource" [completed]="false">
          <form [formGroup]="dataSource">
            <ng-template matStepLabel>Data Source</ng-template>
            <mat-card class="m-card source">
              <mat-card-title class="m-title">
                <span class="m-header">Select Source Type</span>
              </mat-card-title>
              <div class="m-body">
                <mat-form-field class="data-column" appearance="outline">
                  <mat-label>Source Type</mat-label>
                  <!-- <input type="text" formControlName="bridge_source_type" matInput placeholder="Source Type" required> -->
                  <mat-select #sourceApiTypeDropdown formControlName="bridge_source_type"
                    (selectionChange)="OnChangeBridgeSourceType($event,'')" id="ib_update_source_type" 
                    panelClass="custom-overlay-panel" (openedChange)="onDropdownOpened($event, sourceApiTypeDropdown)">
                    <mat-option *ngFor="let obj of bridgeSourceType" [value]="obj" selected>{{obj.value}}
                    </mat-option>
                  </mat-select>

                </mat-form-field>

              </div>
            </mat-card>

            <mat-card class="m-card source" *ngIf="bridge_source_type == 1">
              <mat-card-title class="m-title">
                <span class="m-header">What is your Data Source?</span>
                <span class="sub-content">Please specify or select the Data Source from Catalog</span>
              </mat-card-title>
              <div class="m-body">
                <!-- <p *ngIf="bridgeSourceCatalogType.length == 0" style="margin: 30px 0">No source found. <a href="javascript:void(0)" [routerLink]="['/baseapp/api-catalog/create']"  >Please add your source</a></p> -->
                <mat-form-field class="data-column" appearance="outline" #formField (click)="onDropdownOpened(true, sourceProductNameDropdown)">
                  <mat-label>Search by product name</mat-label>
                  <input type="text" placeholder="Search by product name" formControlName="bridge_source" matInput
                    id="ib_update_source_search_product" [matAutocomplete]="autoGroup"
                    (keydown.enter)="$event.preventDefault()" #sourceProductNameDropdown="matAutocompleteTrigger" required />
                  <mat-autocomplete #autoGroup="matAutocomplete" (optionSelected)="OnChangeBridgeSource($event)"
                    id="ib_update_source_createNew">
                    <mat-option class="create-new" [value]="createNew">Create New</mat-option>
                    <mat-optgroup *ngFor="let brand of bridgeSourceProduct$ | async" [label]="brand.brand_name"
                      id="ib_update_source_brandProd">
                      <mat-option *ngFor="let product of brand.products" [value]="product">
                        {{product}}
                      </mat-option>
                    </mat-optgroup>
                  </mat-autocomplete>
                  <button type="button" mat-button matSuffix aria-label="Search"
                    id="ib_update_source_search_product_btn">
                    <mat-icon>search</mat-icon>
                  </button>
                  <button type="button" mat-button *ngIf="enableDataSourceClearIcon" matSuffix aria-label="Clear"
                    id="ib_update_source_clear_product_btn" (click)="clearDataSource()">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <!-- <mat-select formControlName="bridge_source" (selectionChange)="OnChangeBridgeSource($event)">
                    <mat-option *ngFor="let obj of bridgeSourceCatalogType" [value]="obj.product_name">{{obj.product_name}}</mat-option>
                  </mat-select> -->
                </mat-form-field>

                <div class="column-content">
                  <mat-icon matSuffix>info</mat-icon>
                  <p>
                    Not sure on Data Source? Please checkout the
                    <a style="text-decoration: none;" target="_blank" href="#/baseapp/marketplace"
                      id="ib_update_source_market">Marketplace</a> or
                    <a style="text-decoration: none;" href="javascript:void(0);" (click)="dataSourceModal('source')">
                      Add from Cart
                    </a>
                  </p>
                </div>

                <mat-form-field style="margin-top: 15px;" appearance="outline" *ngIf="isNewSource">
                  <mat-label>Enter Product Name</mat-label>
                  <input type="text" formControlName="new_bridge_source" matInput placeholder="Product name"
                    id="ib_update_source_enter_new_source" (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="isNewSource">
                  <mat-label>Enter Business Object</mat-label>
                  <input type="text" formControlName="new_bridge_source_business_object" matInput
                    id="ib_update_source_enter_new_businessObj" placeholder="Business object"
                    (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>

                <!-- <mat-form-field class="source-businessObj" appearance="fill" *ngIf="!isNewSource">
                  <mat-label>Select Business Object</mat-label>
                  <mat-select formControlName="bridge_source_business_object"
                    (selectionChange)="onChangeBusinessObjectSource($event)">
                    <mat-option *ngFor="let obj of bridgeSourceBusinessObject" [value]="obj">
                      {{ obj.business_obj }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->

                <mat-form-field class="data-column" appearance="outline" #formField *ngIf="!isNewSource">
                  <mat-label>Search by business object</mat-label>
                  <!-- <input type="text" matInput placeholder="Search by business object"
                    id="ib_update_source_search_businessObj" formControlName="bridge_source_business_object"
                    [matAutocomplete]="autoSBO" (keydown.enter)="$event.preventDefault()" required /> -->
                  <mat-select #sourceBusinessObjectDropdown formControlName="bridge_source_business_object"
                     id="ib_update_source_change_businessObj"
                    (selectionChange)="onChangeBusinessObjectSource($event)" panelClass="custom-overlay-panel"
                    (openedChange)="onDropdownOpened($event, sourceBusinessObjectDropdown)" [compareWith]="compareBusinessObjects">
                    <mat-option *ngFor="let sbo of bridgeSourceBusinessObject$ | async" [value]="sbo">
                      {{sbo.business_obj}}
                    </mat-option>
                  </mat-select>
                  <button type="button" mat-button *ngIf="enableSourceBusinessObjectClearIcon" matSuffix
                    id="ib_update_source_clear_businessObj_btn" aria-label="Clear"
                    (click)="clearSourceBusinessObject()">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </mat-card>
            <!-- <mat-card class="m-card system">
              <mat-card-title class="m-title">
                <span class="m-header">System details</span>
                <span class="sub-content">Please specify your domain name</span>
              </mat-card-title>
              <div class="m-body">
                <mat-form-field class="domain-dropdown" appearance="fill">
                  <mat-label>Domain Name</mat-label>
                  <mat-select required>
                    <mat-option *ngFor="let d of sourceColoumns" [value]="d.obj_name">
                      {{ d.obj_name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card> -->
            <!-- <mat-card class="m-card authentication">
              <mat-card-title class="m-title">
                <div class="flex-a">
                  <span class="m-header">Authentication</span>
                  <button mat-stroked-button class="btn-test">Test</button>
                </div>
              </mat-card-title>
              <div class="m-body">
                <mat-form-field class="authentication-type" appearance="fill">
                  <mat-label>Authentication</mat-label>
                  <mat-select (selectionChange)="loadAuthenticationType($event)" [value]="selectedAuthType" required>
                    <mat-option>--Select--</mat-option>
                    <mat-option *ngFor="let authentication of authType" [value]="authentication.id">
                      {{ authentication.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <ng-container *ngIf="selectedAuthType==='basic'">
                  <div class="basic-authentication">
                    <mat-form-field appearance="fill">
                      <mat-label>Username</mat-label>
                      <input type="text" matInput required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Password</mat-label>
                      <input type="password" matInput required />
                    </mat-form-field>
                  </div>
                </ng-container>
                <ng-container *ngIf="selectedAuthType==='oauth'">
                  <div class="oauth-authentication">
                    <mat-form-field appearance="fill">
                      <mat-label>OAuth Token</mat-label>
                      <input type="text" matInput required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>OAuth URL</mat-label>
                      <input type="text" matInput required />
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Body</mat-label>
                      <textarea matInput></textarea>
                      <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                    </mat-form-field>
                  </div>
                </ng-container>
              </div>
            </mat-card> -->

            <mat-card class="postman-integration-source-update" *ngIf="bridge_source_type == 1">
              <app-postmanui 
                [apiCatalogFormType]="'source'" [catalogueId]="sourceCatalogueId" 
                [updateIntBridgeData]="updateIntBridgeSourceData">
              </app-postmanui>
            </mat-card>

            <!-- <mat-card class="m-card data-source-postman" *ngIf="bridge_source_type == 1">
              <form [formGroup]="environmentSourceForm">
                <div class="views-content-env" style="grid-template-columns: 100%;">
                  <div class="views-content-env-data">
                    <div class="add-environment-button" style="text-align: right;">
                      <p>{{environmentSourceForm.value.selected_environment}}</p>
                    </div>
                    <div class="add-environment-button">
                      <mat-icon class="icon" (click)="openEnvironment(true)">
                        add
                      </mat-icon>
                    </div>
                    <div class="exit-environment">
                      <mat-icon class="icon" (click)="exitEnvironment()">
                        move_down
                      </mat-icon>
                    </div>
                    <div class="env-settings">
                      <div class="env-settings-wrapper" (click)="toggleSourceMenu()">
                        <mat-icon matTooltip="Environment Settings" matTooltipPosition="above">settings</mat-icon>
                        <mat-select class="env-settings-select"
                          formControlName="bridge_endpoint_selected_environments_name"
                          (selectionChange)="onSourceEnvironmentChange($event)">
                          <mat-option value="No Environment">No Environment</mat-option>
                          <mat-option *ngFor="let tab of selectedSourceEnvTabs" [value]="tab">
                            {{ tab }}
                          </mat-option>
                        </mat-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="m-body" *ngIf="showSourceEnvironmentTab">
                  <div class="env-container">
                    <div class="env-header">
                      <span class="env-header">Environment Setting</span>
                    </div>
                  </div>
                  <div class="environment-tab-group">
                    <div formArrayName="bridge_endpoint_environments_raw">
                      <div *ngFor="let environments of bridgeSourceEnvironments().controls; let i = index">
                        <div [formGroupName]="i">
                          <ng-container *ngIf="i === currentSourceDisplayedEnvIndex">
                            <div class="environment-tab" style="grid-template-columns: 600px auto;">
                              <div class="environment-name">
                                <mat-form-field class="environment-name-field" appearance="outline">
                                  <mat-label>Environment Name</mat-label>
                                  <input matInput placeholder="Environment Name" type="text" formControlName="env_name"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="environment-icon" style="margin-left: 10px;">
                                <span class="environment-icon-flotter">
                                  <mat-icon class="icon" (click)="confirmSourceSaveEnv(environments.value.env_name,i)">
                                    save
                                  </mat-icon>
                                  <mat-icon class="icon"
                                    (click)="confirmSourceDeleteEnv(environments.value.env_name,i)">
                                    delete
                                  </mat-icon>
                                </span>
                              </div>
                            </div>
                            <div class="environment-variable-container">
                              <div class="environment-variable-tabs">
                                <div formArrayName="env_vars">
                                  <ng-container *ngFor="let env of envSourceData(i).controls; let envIndex = index">
                                    <div [formGroupName]="envIndex">
                                      <div class="data-options-wrapper-environment">
                                        <mat-form-field appearance="outline">
                                          <mat-label>Variable</mat-label>
                                          <input type="text" placeholder="Variable" matInput formControlName="variable"
                                            required>
                                        </mat-form-field>
                                        <mat-form-field class="mat-dropdown" appearance="outline">
                                          <mat-label>Type</mat-label>
                                          <mat-select placeholder="Type" formControlName="type"
                                            (selectionChange)="sourceEnvChangeType($event,envIndex,i)">
                                            <mat-option *ngFor="let type of environmentType" [value]="type.value">{{
                                              type.viewValue }}</mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline">
                                          <mat-label>Value</mat-label>
                                          <input [type]="env.value.valueType" [id]="'environmentValue-' + envIndex"
                                            placeholder="Value" matInput formControlName="value">
                                          <mat-icon *ngIf="env.value.type === 'password'" matSuffix
                                            (click)="sourceTogglePassword(i, envIndex)">
                                            {{ env.value.valueType == 'password' ? 'visibility_off' : 'visibility'
                                            }}
                                          </mat-icon>
                                        </mat-form-field>
                                        <div class="btn-view">
                                          <mat-icon class="icon" (click)="addSourceEnvironmentsTab(i)">
                                            add
                                          </mat-icon>
                                        </div>
                                        <div class="btn-view">
                                          <mat-icon class="icon" (click)="removeSourceEnvironmentsTab(i, envIndex)">
                                            remove
                                          </mat-icon>
                                        </div>
                                      </div>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <div class="m-body" *ngIf="!showSourceEnvironmentTab">
                <div class="views-content-data">
                  <div class="data-options">
                    <mat-form-field class="data-options-dropdown" appearance="outline">
                      <mat-select formControlName="bridge_source_endpoint_method" id="ib_update_source_endpoint_method">
                        <mat-option *ngFor="let options of methodList" [value]="options" class="optionsList">
                          {{ options.method }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="data-url">
                    <mat-form-field class="data-url" appearance="outline" style="display: none;">
                      <input type="text" matInput placeholder="Request URL" id="ib_update_source_endpoint_url"
                        formControlName="bridge_source_endpoint_url" (keydown.enter)="$event.preventDefault()">
                    </mat-form-field>
                      <div class="contentDiv" id="contentDiv" contenteditable="true" placeholder="Request URL"
                      (keyup)="onKeyupSEPUrl($event)">{{endpoint_url}}</div>
                  </div>
                  <div class="data-btn" *ngIf="spinnerSourceShow == false">
                    <button mat-raised-button type="button" class="btn-test" id="ib_update_source_endpoint_test_api_btn"
                      *ngIf="spinnerSource == false" (click)="checkTokenSessionBeforeTestSourceApi()">Test</button>
                  </div>

                  <div class="data-btn" *ngIf="spinnerSourceShow == true">
                    <button mat-raised-button type="button" id="ib_update_source_endpoint_test_api_btn" class="btn-test"
                      (click)="cancelSourceSpinner()">Cancel</button>
                  </div>

                  <div class="loader-container" style="padding: 12px" *ngIf="spinnerSource == true">
                    <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                  </div>
                </div>

                <mat-tab-group animationDuration="0ms" class="views-options-data-group"
                  [(selectedIndex)]="indexSelection" (selectedTabChange)="sourcePostmanTabChange($event)">
                  <mat-tab label="Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_source_endpoint_params_raw"
                            *ngFor="let params of bridgeSourceParams?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="outline" style="display: none;">
                                <input type="text" formControlName="bridge_source_paramKey" matInput placeholder="Key"
                                  id="ib_update_source_endpoint_params_key{{i}}"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                              <div class="contentDivInputContParams">
                                <div class="contentParams" id="contentDiv_params_key{{i}}" placeholder="Key" contenteditable="true"
                                (keyup)="onKeyupSEPParamsKey($event,i)">{{params_key[i]}}</div>
                                </div>
                              <mat-form-field appearance="outline" style="display: none;">
                                <input type="text" formControlName="bridge_source_paramValue" matInput
                                  id="ib_update_source_endpoint_params_value{{i}}" placeholder="Value"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                              <div class="contentDivInputContParams">
                                <div class="contentParams" id="contentDiv_params_value{{i}}" placeholder="Value" contenteditable="true"
                                (keyup)="onKeyupSEPParamsValue($event,i)">{{params_value[i]}}</div>
                                </div>
                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_paramDescription" matInput
                                  id="ib_update_source_endpoint_params_desc{{i}}" placeholder="Description"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="addSourceParams(i)"
                                  id="ib_update_source_endpoint_params_add{{i}}">
                                  add
                                </mat-icon>
                              </div>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="removeSourceParams(i)"
                                  id="ib_update_source_endpoint_params_remove{{i}}">
                                  remove
                                </mat-icon>
                              </div>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Authorization">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="authentication-view">
                          <div class="view-options-drop">
                            <mat-form-field class="mat-dropdown" appearance="outline">
                              <mat-label>Select Type</mat-label>
                              <mat-select formControlName="bridge_source_endpoint_authentication_type"
                                id="ib_update_source_endpoint_authentication_type"
                                (selectionChange)="onChangeSourceAuthenticationtype($event)">
                                <mat-option *ngFor="let type of authenticationSourceTypeOptions" [value]="type">
                                  {{ type.type }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="view-body">
                            <ng-container *ngIf="selectSourceType == 3">
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Token</mat-label>
                                  <input type="text" matInput placeholder="Token"
                                    id="ib_update_source_endpoint_authentication_token"
                                    formControlName="bridge_source_authentication_token"
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectSourceType == 4">
                              <div class="view-options">
                                <mat-form-field appearance="outline" style="display: none;">
                                  <mat-label>Username</mat-label>
                                  <input [type]="username ? 'password' : 'text'" matInput placeholder="Username"
                                    id="ib_update_source_endpoint_authentication_username"
                                    formControlName="bridge_source_authentication_username"
                                    (keydown.enter)="$event.preventDefault()">
                                  <mat-icon matSuffix (click)="username = !username">{{username ? 'visibility_off' :
                                    'visibility'}}</mat-icon>
                                </mat-form-field>
                                <mat-label>Username *</mat-label>
                                <div class="contAiner">
                                  <div id="contentDevSourceAuthUser" placeholder="Username" contenteditable="true"
                                    (keyup)="onKeyupSEPAuthUser($event)"  (click)="onKeyupSEPAuthUser($event)">{{source_authUser}}</div>
                                  <mat-icon class="buttOn" matSuffix
                                    (click)="toggleAuthPassword('contentDevSourceAuthUser','source_user')">{{username ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                </div>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline" style="display: none;">
                                  <mat-label>Password</mat-label>
                                  <input [type]="password ? 'password' : 'text'" matInput placeholder="Password"
                                    id="ib_update_source_endpoint_authentication_password"
                                    formControlName="bridge_source_authentication_password"
                                    (keydown.enter)="$event.preventDefault()">
                                  <mat-icon matSuffix (click)="password = !password">{{password ? 'visibility_off' :
                                    'visibility'}}</mat-icon>
                                </mat-form-field>
                                <mat-label>Password *</mat-label>
                                <div class="contAiner">
                                  <div id="contentDevSourceAuthPassword" type="password ? 'password' : 'text'"
                                    placeholder="Password" contenteditable="true"
                                    (keyup)="onKeyupSEPAuthPassword($event)" (click)="onKeyupSEPAuthPassword($event)">{{source_authPassword}}</div>
                                  <mat-icon class="buttOn" matSuffix
                                    (click)="toggleAuthPassword('contentDevSourceAuthPassword','source_password')">{{password
                                    ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectSourceType == 6">
                              <div class="view-options-drop">
                                <mat-form-field appearance="outline">
                                  <mat-label>Refresh Token Method</mat-label>
                                  <mat-select formControlName="bridge_source_oauth_refresh_token_endpoint_method"
                                    id="ib_update_source_endpoint_authentication_method">
                                    <mat-option *ngFor="let options of methodList" [value]="options">
                                      {{ options.method }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline" style="display: none;">
                                  <mat-label>Refresh Token URL</mat-label>
                                  <input type="text" matInput placeholder="Refresh Token Endpoint URL"
                                    id="ib_update_source_endpoint_authentication_url"
                                    formControlName="bridge_source_oauth_refresh_token_endpoint_url">
                                </mat-form-field>
                                <div class="contentDivInputContParams" id="contentDivSourceAuth">
                                  <div class="contentParams" id="contentDevSourceAuth" placeholder="Refresh Token Endpoint URL*"
                                  contenteditable="true" (click)="onKeyupSEPAuth($event)" (keyup)="onKeyupSEPAuth($event)">{{source_auth}}</div>
                                  </div>
                              </div>
                              <div class="view-options-auth">
                                <mat-label>Refresh Token Endpoint Header</mat-label>
                                <ngx-codemirror class="codemirror-color" formControlName="bridge_source_oauth_refresh_token_endpoint_header"
                                  id="ib_update_source_endpoint_authentication_header"
                                  #sourcerefreshTokenHeaderScriptEditor [options]="authorizationScriptEditorOptions">
                                </ngx-codemirror>
                              </div>
                              <div class="view-options-auth">
                                <mat-label>Refresh Token Endpoint Params</mat-label>
                                <ngx-codemirror class="codemirror-color" formControlName="bridge_source_oauth_refresh_token_endpoint_params"
                                  id="ib_update_source_endpoint_authentication_params"
                                  #sourcerefreshTokenParamScriptEditor [options]="authorizationScriptEditorOptions">
                                </ngx-codemirror>
                              </div>
                              <div class="view-options-auth">
                                <mat-label>Refresh Token Endpoint Body</mat-label>
                                <ngx-codemirror class="codemirror-color" formControlName="bridge_source_oauth_refresh_token_endpoint_body"
                                  id="ib_update_source_endpoint_authentication_body" #sourcerefreshTokenBodyScriptEditor
                                  [options]="authorizationScriptEditorOptions">
                                </ngx-codemirror>
                              </div>
                            </ng-container>

                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Headers">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_source_endpoint_headers"
                            *ngFor="let headers of bridgeSourceHeaders?.controls;let i = index">
                            <ng-container [formGroupName]="i">

                              <mat-form-field appearance="outline" style="display: none;">
                                <input type="text" placeholder="Key" matInput formControlName="bridge_source_headerKey"
                                  [matAutocomplete]="autoPKH" (keydown.enter)="$event.preventDefault()"
                                  id="ib_update_source_endpoint_header_key{{i}}">
                                <mat-autocomplete #autoPKH="matAutocomplete" [displayWith]="displayFnSourceHeaderKey">
                                  <mat-option *ngFor="let key of sourceHeaderKeys$[i] | async" [value]="key">
                                    {{ key.header_key }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>

                                <div class="dataSourceheadersKey autocomplete-container">
                                  <div #contentEditableHeaderKey  id="contentDevHeaderKey{{i}}"   
                                    contenteditable="true" placeholder="Key"  class="contentEditable" (keyup)="onKeyupSEPHeaderKey($event,i)"
                                    (input)="onHeaderKeyInput($event, i)" (focus)="onHeaderKeyFocus(i)"
                                    (blur)="hideHeaderKeyAutocomplete(i)"><span *ngIf="headers_key[i]!=null && headers_key[i].length>0">{{headers_key[i]}}</span>
                                  </div>
                                  <div #autocompleteHeaderKey class="autocomplete-dropdown"
                                    *ngIf="filteredHeaderKey[i]?.length">
                                    <div class="autocomplete-item" *ngFor="let key of filteredHeaderKey[i]"
                                      (mousedown)="onHeaderKeyOptionSelected(key.header_key, i)">
                                      {{ key.header_key }}
                                    </div>
                                  </div>
                                </div>

                              <mat-form-field appearance="outline" style="display: none;">
                                <input type="text" placeholder="value" matInput
                                  formControlName="bridge_source_headerValue" [matAutocomplete]="autoPKV"
                                  (keydown.enter)="$event.preventDefault()"
                                  id="ib_update_source_endpoint_header_value{{i}}">
                                <mat-autocomplete #autoPKV="matAutocomplete" [displayWith]="displayFnSourceHeaderValue">
                                  <mat-option *ngFor="let value of sourceHeaderValues$[i] | async" [value]="value">
                                    {{ value.header_value }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>

                                <div class="dataSourceHeadersValue autocomplete-container">
                                  <div #contentEditableHeaderValue id="contentDevHeaderValue{{i}}"
                                    contenteditable="true" placeholder="Value" class="contentEditable" (keyup)="onKeyupSEPHeaderValue($event,i)"
                                    (input)="onHeaderValueInput($event, i)" (focus)="onHeaderValueFocus(i)"
                                    (blur)="hideHeaderValueAutocomplete(i)"><span *ngIf="headers_value[i]!=null && headers_value[i].length>0">{{headers_value[i]}}</span>
                                  </div>
                                  <div #autocompleteHeaderValue class="autocomplete-dropdown"
                                    *ngIf="filteredHeaderValue[i]?.length">
                                    <div class="autocomplete-item" *ngFor="let value of filteredHeaderValue[i]"
                                      (mousedown)="onHeaderValueOptionSelected(value.header_value, i)">
                                      {{ value.header_value }}
                                    </div>
                                  </div>
                                </div>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_headerDescription" matInput
                                  id="ib_update_source_endpoint_header_desc{{i}}" placeholder="Description"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <div class="btn-view">
                                <mat-icon class="icon" (click)="addSourceHeaders(i)"
                                  id="ib_update_source_endpoint_header_add{{i}}">
                                  add
                                </mat-icon>
                              </div>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="removeSourceheader(i)"
                                  id="ib_update_source_endpoint_header_remove{{i}}">
                                  remove
                                </mat-icon>
                              </div>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Body">
                    <div class="mat-section">
                      <div style="width: 25%;">
                        <mat-form-field class="mat-dropdown" appearance="outline">
                          <mat-label>Select Type</mat-label>
                          <mat-select formControlName="bridge_source_body_type"
                            id="ib_update_source_endpoint_body_type">
                            <mat-option *ngFor="let type of bodyTypeOptions" [value]="type.type">
                              {{ type.type }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="m-body">
                        <ngx-codemirror formControlName="bridge_source_endpoint_body_raw"
                          id="ib_update_source_endpoint_body_raw" #bodySourceEditor [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Pre-request Script">
                    <div class="mat-section">
                      <div class="m-body-script">

                        <ngx-codemirror class="codemirror-color" formControlName="pre_request_script"
                          id="ib_update_source_endpoint_pre_request_script" #sourcePreRequestScriptEditor
                          [options]="preRequestScriptEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Pagination">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="pagination-view">
                          <div class="view-options">
                            <mat-form-field class="mat-dropdown" appearance="outline">
                              <mat-label>Select Type</mat-label>
                              <mat-select formControlName="bridge_source_pagination_type"
                                id="ib_update_source_endpoint_pagination_type"
                                (selectionChange)="onChangeSourcePaginationtype($event)">
                                <mat-option *ngFor="let type of paginationTypeOptions" [value]="type">
                                  {{ type.type }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="view-body">
                            <ng-container *ngIf="selectPaginationType == 2">
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>User Key</mat-label>
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_2"
                                    id="ib_update_source_endpoint_user_key2" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Data Collection Key</mat-label>
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_update_source_endpoint_response_parameters2"
                                    formControlName="response_parameters_2" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Another Response Parameter</mat-label>
                                  <input type="text" matInput placeholder="Another Response Parameter"
                                    id="ib_update_source_endpoint_another_response_parameters2"
                                    formControlName="another_response_parameter_2"
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Pagination Retry (Seconds)</mat-label>
                                  <input type="number" matInput formControlName="pagination_retry_seconds"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectPaginationType == 3">
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>User Key</mat-label>
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_3"
                                    id="ib_update_source_endpoint_user_key3" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Key Name to Update</mat-label>
                                  <input type="text" matInput placeholder="Key Name to Update"
                                    id="ib_update_source_endpoint_key_name_update3"
                                    formControlName="key_name_to_update_3" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Data Collection Key</mat-label>
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_update_source_endpoint_response_parameters3"
                                    formControlName="response_parameters_3" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Pagination Retry (Seconds)</mat-label>
                                  <input type="number" matInput formControlName="pagination_retry_seconds"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectPaginationType == 4">
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>User Key</mat-label>
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_4"
                                    id="ib_update_source_endpoint_user_key4" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Key Name to Update</mat-label>
                                  <input type="text" matInput placeholder="Key Name to Update"
                                    id="ib_update_source_endpoint_key_name_update4"
                                    formControlName="key_name_to_update_4" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Data Collection Key</mat-label>
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_update_source_endpoint_response_parameters4"
                                    formControlName="response_parameters_4" (keydown.enter)="$event.preventDefault()"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Pagination Retry (Seconds)</mat-label>
                                  <input type="number" matInput formControlName="pagination_retry_seconds"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectPaginationType == 5">
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>User Key</mat-label>
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_5"
                                    id="ib_update_source_endpoint_user_key5" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Key Name to Update</mat-label>
                                  <input type="text" matInput placeholder="Key Name to Update"
                                    id="ib_update_source_endpoint_key_name_update5"
                                    formControlName="key_name_to_update_5" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Data Collection Key</mat-label>
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_update_source_endpoint_response_parameters5"
                                    formControlName="response_parameters_5" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Pagination Retry (Seconds)</mat-label>
                                  <input type="number" matInput formControlName="pagination_retry_seconds"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectPaginationType == 6">
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>User Key</mat-label>
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_6"
                                    id="ib_update_source_endpoint_user_key6" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>User Key URL</mat-label>
                                  <input type="text" matInput placeholder="User Key URL"
                                    id="ib_update_source_endpoint_user_keyUrl6" formControlName="user_key_url_6"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Data Collection Key</mat-label>
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_update_source_endpoint_response_parameters6"
                                    formControlName="response_parameters_6" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Pagination Retry (Seconds)</mat-label>
                                  <input type="number" matInput formControlName="pagination_retry_seconds"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="selectPaginationType == 7">
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>User Key</mat-label>
                                  <input type="text" matInput placeholder="User Key" formControlName="user_key_7"
                                    id="ib_update_source_endpoint_user_key7" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Data Collection Key</mat-label>
                                  <input type="text" matInput placeholder="['items']"
                                    id="ib_create_update_endpoint_response_parameters7"
                                    formControlName="response_parameters_7" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Pagination Retry (Seconds)</mat-label>
                                  <input type="number" matInput formControlName="pagination_retry_seconds"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                            </ng-container>
                            <ng-container *ngIf="selectPaginationType == 8">
                              <div class="view-options">
                                <p>Custom Pagination Script</p>
                                <div class="m-body-script" style="border:1px groove;border-radius: 5px;">
                                  <ngx-codemirror formControlName="custom_pagination_script"
                                    #updateSourceCustomPaginationScriptEditor [options]="codeMirrorEditorOptions">
                                  </ngx-codemirror>
                                </div>
                              </div>
                              <div class="view-options" style="margin-top: 20px;">
                                <mat-form-field appearance="outline">
                                  <mat-label>Pagination Retry (Seconds)</mat-label>
                                  <input type="number" matInput formControlName="pagination_retry_seconds"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                            </ng-container>

                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Numeric Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="pagination-view">
                          <div class="view-body">
                            <ng-container>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Minimun Number</mat-label>
                                  <input type="number" matInput placeholder="Enter min number"
                                    id="ib_update_source_numeric_params_min" formControlName="min_number"
                                    (keydown)="validateMinNum($event)" (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Maximum Number</mat-label>
                                  <input type="number" matInput placeholder="Enter max number"
                                    id="ib_update_source_numeric_params_max" formControlName="max_number"
                                    (keydown)="validateMaxNum($event)" (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Time Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="pagination-view">
                          <div class="view-body">
                            <ng-container>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Today Format</mat-label>
                                  <input type="text" matInput formControlName="today_str"
                                    id="ib_update_source_time_params_today" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Yesterday Format</mat-label>
                                  <input type="text" matInput formControlName="yesterday_str"
                                    id="ib_update_source_time_params_yesterday"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Rolling Time Format</mat-label>
                                  <input type="text" matInput formControlName="rolling_time_format"
                                    id="ib_update_source_time_params_rolling_time"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Rolling Frquency</mat-label>
                                  <input type="number" matInput formControlName="rolling_frequency"
                                    id="ib_update_source_time_params_rolling_frequency"
                                    (keydown)="validateMaxNum($event)" (keydown.enter)="$event.preventDefault()"
                                    required>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Time Offset Value</mat-label>
                                  <input type="number" matInput formControlName="offset_value"
                                    id="ib_update_source_time_params_offset_value"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>

                <div class="res-container">
                  <div class="res-header">
                    <h3 style="margin:0">Response Params</h3>
                    <span class="res-header">
                      <mat-radio-group formControlName="response_type">
                        <mat-radio-button value="text">Text</mat-radio-button>
                        <mat-radio-button value="content">Content</mat-radio-button>
                        <mat-radio-button value="json">JSON</mat-radio-button>
                      </mat-radio-group>
                    </span>
                  </div>
                  <div class="res-header">
                    <span class="res-header">Response</span>
                    <span *ngIf="bridgeSourceResponse?.bizdata_dataset">
                      <span class="res-status"
                        *ngIf="bridgeSourceResponse?.bizdata_dataset.bizdata_dataset_status">Status:
                        <strong>{{bridgeSourceResponse?.bizdata_dataset.bizdata_dataset_status}}</strong></span>
                    </span>
                  </div>
                  <div class="res-body">
                    <div class="error-block" *ngIf="bridgeSourceResponse?.error == 2; else sr">
                      <h5>Could not send request</h5>
                      <span>Error: {{bridgeSourceResponse.message}}</span>
                    </div>
                    <ng-template #sr>
                      <div style=" position: relative;">
                      <json-editor formControlName="bridge_source_response" [options]="editorSourceOptions"
                        id="ib_update_source_response">
                      </json-editor>
                      <mat-icon style="cursor: pointer; position: absolute; top: 5px; right: 5px;"
                      (click)="copyResponse(dataSource.controls.bridge_source_response.value)">
                      content_copy
                    </mat-icon>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </mat-card> -->

            <mat-card class="m-card system" *ngIf="bridge_source_type == 2">
              <div class="ops-form-body">
                <mat-card class="m-card data-source">
                  <div class="m-body">
                    <div class="data-btn">
                      <label class="ops-lab-data-target">Storage Details</label>
                    </div>
                    <mat-form-field appearance="fill">
                      <mat-label>Select Storage Name</mat-label>
                      <mat-select #sourceStorageNameDropdown formControlName="storage_name" id="ib_update_source_storage_name"
                        (selectionChange)="onChangeDataSourceStorageNameJDBCO($event)" panelClass="custom-overlay-panel" 
                        (openedChange)="onDropdownOpened($event, sourceStorageNameDropdown)" required>
                        <mat-option *ngFor="let obj of storageNameJDBCOList" [value]="obj">
                          {{ obj.storage_name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Select Version</mat-label>
                      <mat-select #sourceStorageVersionDropdown formControlName="db_version" id="ib_update_source_dbVersion"
                        (selectionChange)="onChangeDataSourceDlVersionJDBCO($event)" panelClass="custom-overlay-panel" 
                        (openedChange)="onDropdownOpened($event, sourceStorageVersionDropdown)" required>
                        <mat-option *ngFor="let obj of dataSource_db_version_list" [value]="obj">
                          {{ obj.dbversion }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Host IP</mat-label>
                      <input type="text" formControlName="host_ip" matInput id="ib_update_source_host"
                        placeholder="Host IP" (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Port Number</mat-label>
                      <input type="text" formControlName="port_number" id="ib_update_source_portNo" matInput
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Schema Name</mat-label>
                      <input type="text" formControlName="schema_name" id="ib_update_source_schema" matInput
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>User Name</mat-label>
                      <input type="text" formControlName="username" id="ib_update_source_db_username" matInput
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Password</mat-label>
                      <input type="password" formControlName="password" id="ib_update_source_db_password" matInput
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <!-- <mat-form-field appearance="outline">
                      <mat-label>Order Set of Values (Tuple Key)</mat-label>
                      <input type="text" formControlName="tuple_key" matInput>
                    </mat-form-field> -->
                    <!-- <mat-form-field appearance="outline">
                      <mat-label>Multiline</mat-label>
                    <mat-select formControlName="multiline">
                      <mat-option *ngFor="let obj of multilineObj" [value]="obj.value" selected>{{obj.value}}
                      </mat-option>
                    </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Unique key</mat-label>
                      <input type="text" formControlName="unique_key" matInput>
                    </mat-form-field> -->
                    <mat-form-field appearance="outline">
                      <mat-label>Chunks Size</mat-label>
                      <input type="number" formControlName="chunks_size" min="1" id="ib_update_source_db_chucks_size"
                        matInput (keyup)="chunkSizeChange($event)" (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Response Parameter</mat-label>
                      <input type="text" formControlName="response_parameter"
                        id="ib_update_source_db_response_parameters" matInput (keydown.enter)="$event.preventDefault()"
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <!-- <mat-form-field appearance="outline">
                      <mat-label>Batch Size</mat-label>
                      <input type="text" formControlName="batch_size" matInput>
                    </mat-form-field> -->
                    <mat-card class="mat-section1" style="border:1px groove;border-radius: 5px;">
                      <div class="res-header-sql">
                        <p class="res-status-sql" style="float: left;margin-top: 10px;">SQL Statement
                          <br>
                          <span style="font-weight: bold;font-size: small;">Write SELECT statement,you can apply
                            conditions,joins etc. as you need.
                          </span> &nbsp;
                          <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                            (click)="copySourceDescMessage(sqlhint_source,dataSource)">swap_vert</mat-icon>
                        </p>
                        <div class="res-status-sql" *ngIf="spinnerSourceDatabaseShow == false">
                          <button mat-raised-button type="button" id="ib_update_source_db_test_btn"
                            class="btn-test execute" *ngIf="spinnerSourceDatabase == false"
                            (click)="checkTokenSessionBeforeDataSourceJdbc()">Execute</button>
                        </div>

                        <div class="res-status" *ngIf="spinnerSourceDatabaseShow == true">
                          <button mat-raised-button type="button" id="ib_update_source_db_test_btn"
                            class="btn-test execute" (click)="cancelSourceDatabaseSpinner()">Cancel</button>
                        </div>

                        <div class="loader-container" style="padding: 4px 18px;" *ngIf="spinnerSourceDatabase == true">
                          <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                        </div>
                      </div>
                      <div class="m-body-script">
                        <!-- <ngx-monaco-editor formControlName="query" [options]="editorPycodeOption"
                                        (init)="pycodeResponseeditorInit($event)">
                                      </ngx-monaco-editor> -->
                        <ngx-codemirror formControlName="query" id="ib_update_source_db_query" #queryEditor
                          [options]="codeMirrorEditorOptions_sql_Source">
                        </ngx-codemirror>
                        <!-- <mat-hint align="start" class="hint-start">
                          <span class="hint-label"> Note: SQL Statement to be passed without any quotes, </span><br>
                          <span>e.g: select * from source_table</span>
                        </mat-hint> -->
                      </div>
                    </mat-card>
                    <div class="res-container">
                      <div class="res-header">
                        <span class="res-header">Response</span>
                        <span *ngIf="data_source_status">
                          <span class="res-status" *ngIf="data_source_status">Status:
                            <strong>{{data_source_status}}</strong></span>
                        </span>
                      </div>
                    </div>
                        <!-- <ngx-monaco-editor formControlName="response" [options]="editorPycodeOption"
                                        (init)="jdbcResponseeditorInit($event)">
                                      </ngx-monaco-editor> -->
                        <!-- <ngx-codemirror formControlName="response" id="ib_update_source_db_response"
                          [options]="editorSourceOptions">
                        </ngx-codemirror> -->
                        <div style=" position: relative;">
                          <json-editor formControlName="response" [options]="editorSourceOptions"
                            id="ib_create_source_db_response">
                          </json-editor>
                          <mat-icon style="cursor: pointer;  position: absolute; top: 5px; right: 5px;"
                            (click)="copyResponse(dataSource.controls.response.value)">
                            content_copy
                          </mat-icon>
                        </div>
                  </div>
                </mat-card>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_source_type == 3">
              <div class="ops-form-body">
                <mat-card class="m-card data-source">
                  <div class="m-body">
                    <mat-form-field class="target-businessObj" appearance="fill">
                      <mat-label>Data Lake Version</mat-label>
                      <mat-select #sourceDlVersionDropdown formControlName="version" id="ib_update_source_dl_version"
                        (selectionChange)="onChangeDSGetDlversion($event)" panelClass="custom-overlay-panel" 
                        (openedChange)="onDropdownOpened($event, sourceDlVersionDropdown)" required>
                        <mat-option *ngIf="sourceVerisonListDL.length == 0">
                          No record found
                        </mat-option>
                        <mat-option *ngFor="let version of sourceVerisonListDL" [value]="version">
                          {{ version.dlversion }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;">
                      <div>
                        <p style="margin-top:25px">
                          <span style="background: #ddd;">bizintel360-</span>
                        </p>
                      </div>
                      <div>
                        <mat-form-field appearance="outline" style="width: 55%;">
                          <mat-label class="bold-label">Index / Table Name</mat-label>
                          <input type="text" matInput formControlName="dlsource_index_name" [matAutocomplete]="auto"
                            id="ib_update_source_dl_index_name" (keydown)="bridgenameCheck($event)" required>
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayIndexName">
          
                                <mat-option *ngFor="let option of filteredOptions|async" [value]="option">
                                  {{ option }}
                                </mat-option>
                          
                            </mat-autocomplete> 
                        </mat-form-field>
                      </div>
                    </div>
                    <mat-form-field appearance="outline">
                      <mat-label class="bold-label">Pagination Wait Time</mat-label>
                      <input type="text" matInput formControlName="scroll" id="ib_update_source_dl_scroll"
                        (keydown.enter)="$event.preventDefault()">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label class="bold-label">Timeout</mat-label>
                      <input type="text" matInput formControlName="dlsource_timeout" id="ib_update_source_dl_timeout"
                        (keydown.enter)="$event.preventDefault()">
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label class="bold-label">Size</mat-label>
                      <input type="text" matInput formControlName="dlsource_batch_size"
                        id="ib_update_source_dl_batch_size" (keydown.enter)="$event.preventDefault()">
                    </mat-form-field>

                    <div class="data-btn-lake">
                      <div class="data-btn" *ngIf="spinnerSourceDatalakeShow == false">
                        <button mat-raised-button type="button" id="ib_create_source_dl_test_btn" class="btn-test"
                          *ngIf="spinnerSourceDatalake == false"
                          (click)="checkTokenSessionBeforeTestDataLakeSource()">Execute</button>
                      </div>

                      <div class="data-btn" *ngIf="spinnerSourceDatalakeShow == true">
                        <button mat-raised-button type="button" id="ib_create_source_dl_test_btn"
                          class="btn-test executeDL" (click)="cancelSourceDatalakeSpinner()">Cancel</button>
                        <!-- <span><mat-spinner class="btn-spinner" diameter="30"></mat-spinner></span> -->
                      </div>

                      <div class="loader-container" style="padding: 4px 18px" *ngIf="spinnerSourceDatalake == true">
                        <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                      </div>
                    </div>

                    <mat-card class="mat-section" style="border:1px groove;border-radius: 5px;">
                      <p style="margin-left: 10px;">Query</p>
                      <div class="m-body-script">
                        <ngx-codemirror formControlName="dlsource_body" #dlSearchSourceEditor
                          [options]="codeMirrorEditorOptions" (keydown.enter)="$event.preventDefault()">
                        </ngx-codemirror>
                      </div>

                    </mat-card>
                    <!-- <mat-form-field appearance="outline">
                      <mat-label class="bold-label">Query</mat-label>
                      <textarea type="text" matInput formControlName="dlsource_body" id="ib_update_source_dl_body"
                        (keydown.enter)="$event.preventDefault()"></textarea>
                        <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                    </mat-form-field> -->
                    <div class="res-container">
                      <div class="res-header">
                        <span class="res-header">Response</span>
                        <span *ngIf="bridgeSourceResponse?.bizdata_dataset">
                          <span class="res-status"
                            *ngIf="bridgeSourceResponse?.bizdata_dataset.bizdata_dataset_status">Status:
                            <strong>{{bridgeSourceResponse?.bizdata_dataset.bizdata_dataset_status}}</strong></span>
                        </span>
                        <span *ngIf="!bridgeSourceResponse?.bizdata_dataset">
                          <span class="res-status" *ngIf="bridgeSourceResponse?.bizdata_dataset_status">Status:
                            <strong>{{bridgeSourceResponse?.bizdata_dataset_status}}</strong></span>
                        </span>
                      </div>
                      <div class="res-body">
                        <div class="error-block" *ngIf="bridgeSourceResponse?.error == 2; else sr">
                          <h5>Could not send request</h5>
                          <span>Error: {{bridgeSourceResponse.message}}</span>
                        </div>
                        <ng-template #sr>
                          <div style=" position: relative;">
                          <json-editor formControlName="dlsource_body_response" id="ib_update_source_dl_response"
                            [options]="editorSourceOptions">
                          </json-editor>
                          <mat-icon style="cursor: pointer;  position: absolute; top: 5px; right: 5px;"
                          (click)="copyResponse(dataSource.controls.dlsource_body_response.value)">
                          content_copy
                        </mat-icon>
                        </div>
                        </ng-template>

                      </div>
                    </div>
                  </div>
                </mat-card>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_source_type == 4">
              <div class="m-body">
                <div class="views-content-data-ws">
                  <div class="data-url">
                    <mat-form-field class="data-url" appearance="outline">
                      <input type="text" matInput placeholder="Request URL" id="ib_update_source_ws_endpoint_url"
                        formControlName="bridge_source_ws_endpoint_url" (keydown.enter)="$event.preventDefault()"
                        required>
                    </mat-form-field>
                  </div>
                  <div class="data-btn" *ngIf="!wsconnect && !wsconnectSpinner">
                    <button mat-raised-button type="button" id="ib_update_source_ws_endpoint_test_api_btn"
                      class="btn-test" (click)="checkTokenSessionBeforeTestSourceWsApi()"
                      [disabled]="wsconnectSpinner">Connect</button>
                  </div>
                  <div class="data-btn" *ngIf="!wsconnect && wsconnectSpinner">
                    <button mat-raised-button type="button" class="btn-test btn-cancel"
                      (click)="disconnectTestSourceWsApi()">Cancel</button>
                  </div>
                  <div class="data-btn" *ngIf="wsconnect && !wsconnectSpinner">
                    <button mat-raised-button type="button" id="ib_update_source_ws_endpoint_test_api_btn"
                      class="btn-test" (click)="disconnectTestSourceWsApi()">Disconnect</button>
                  </div>
                  <div class="loader-container" style="padding: 12px" *ngIf="wsconnectSpinner">
                    <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                  </div>
                </div>
                <mat-tab-group animationDuration="0ms" class="views-options-data-group"
                  [(selectedIndex)]="indexSelectionWebsocket" (selectedTabChange)="sourcePostmanWsTabChange($event)">
                  <mat-tab label="Message">
                    <div class="mat-section">
                      <div class="m-body-script">
                        <ngx-codemirror formControlName="bridge_source_ws_message" #sourceMessageEditor
                          id="ib_update_source_ws_endpoint_message" [options]="messageEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_source_ws_endpoint_params_raw"
                            *ngFor="let params of bridgeSourceWsParams?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_paramKey"
                                  id="ib_update_source_ws_endpoint_params_key{{i}}" matInput placeholder="Key"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_paramValue"
                                  id="ib_update_source_ws_endpoint_params_value{{i}}" matInput placeholder="Value"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_paramDescription"
                                  id="ib_update_source_ws_endpoint_params_desc{{i}}" matInput placeholder="Description"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="addSourceWsParams(i)"
                                  id="ib_update_source_ws_endpoint_params_add{{i}}">
                                  add
                                </mat-icon>
                              </div>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="removeSourceWsParams(i)"
                                  id="ib_update_source_ws_endpoint_params_remove{{i}}">
                                  remove
                                </mat-icon>
                              </div>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Headers">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_source_ws_endpoint_headers"
                            *ngFor="let headers of bridgeSourceWsHeaders?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_headerKey" matInput
                                  id="ib_update_source_ws_endpoint_header_key{{i}}" placeholder="Key" (keyup)="onKeyupSEPHeaderKey($event,i)"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_headerValue" matInput
                                  id="ib_update_source_ws_endpoint_header_value{{i}}" placeholder="Value" (keyup)="onKeyupSEPHeaderValue($event,i)"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_source_ws_headerDescription" matInput
                                  id="ib_update_source_ws_endpoint_header_desc{{i}}" placeholder="Description"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <div class="btn-view">
                                <mat-icon class="icon" (click)="addSourceWsHeaders(i)"
                                  id="ib_update_source_ws_endpoint_header_add{{i}}">
                                  add
                                </mat-icon>
                              </div>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="removeSourceWsheader(i)"
                                  id="ib_update_source_ws_endpoint_header_remove{{i}}">
                                  remove
                                </mat-icon>
                              </div>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>
                <div class="res-container">
                  <div class="res-header">
                    <span class="res-header">Response</span>
                    <span *ngIf="bridgeSourceResponse?.bizdata_dataset">
                      <span class="res-status"
                        *ngIf="bridgeSourceResponse?.bizdata_dataset.bizdata_dataset_status">Status:
                        <strong>{{bridgeSourceResponse?.bizdata_dataset.bizdata_dataset_status}}</strong></span>
                    </span>

                    <span *ngIf="!bridgeSourceResponse?.bizdata_dataset">
                      <span class="res-status" *ngIf="bridgeSourceResponse?.bizdata_dataset_status">Status:
                        <strong>{{bridgeSourceResponse?.bizdata_dataset_status}}</strong></span>
                    </span>
                  </div>
                  <div class="res-body">
                    <div class="error-block" *ngIf="bridgeSourceResponse?.error == 2; else sr">
                      <h5>Could not send request</h5>
                      <span>Error: {{bridgeSourceResponse.message}}</span>
                    </div>
                    <ng-template #sr>
                      <div style=" position: relative;">
                      <json-editor formControlName="bridge_source_response" id="ib_update_source_ws_response"
                        [options]="editorSourceOptions">
                      </json-editor>
                      <mat-icon style="cursor: pointer;  position: absolute; top: 5px; right: 5px;"
                      (click)="copyResponse(dataSource.controls.bridge_source_response.value)">content_copy
                      </mat-icon>
                      </div>
                    </ng-template>

                  </div>
                </div>
              </div>

            </mat-card>
            <mat-card class="m-card data-source" *ngIf="bridge_source_type == 5">
              <div class="m-body">
                <div class="data-btn">
                  <button mat-raised-button type="button" class="btn-test"
                    (click)="checkTokenSessionBeforeTestSourceEmailApi(dataSource.value)">Test</button>
                </div>
                <p>Provide the email address which we want to connect and get the data. Example:Provide the email
                  username@gmail.com. Refer <a href="https://help.bizdata360.com/books/ezintegrations/page/data-source-email#bkmrk-step-2%3A-email" target="_blank">here</a>
                </p>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Email</mat-label>
                  <input type="text" matInput formControlName="user_email" id="ib_update_source_user_email"
                    (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>
                <p>Provide the password for the email provided in Email. Example:Provide the password password@123.
                  Refer <a href="https://help.bizdata360.com/books/ezintegrations/page/data-source-email#bkmrk-step-3%3A-password">here</a></p>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Password</mat-label>
                  <input type="password" matInput formControlName="email_password" id="ib_update_source_email_password"
                    (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>
                <p>Provide your mail server name. Example:mail.bizdata360.com. Refer <a
                    href="https://help.bizdata360.com/books/ezintegrations/page/data-source-email#bkmrk-step-4%3A-mail-server">here</a></p>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Mail Server</mat-label>
                  <input type="text" matInput formControlName="mail_server" id="ib_update_source_email_mailServer"
                    (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>
                <P>Provide the port number of your mail server. Example:993. Refer <a
                    href="https://help.bizdata360.com/books/ezintegrations/page/data-source-email#bkmrk-step-5%3A-port-number">here</a></P>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Port Number</mat-label>
                  <input type="number" (keypress)="portEmailChange($event)" matInput formControlName="email_port_number" id="ib_update_source_email_port"
                    (keydown.enter)="$event.preventDefault()" pattern="^[0-9]+$">
                </mat-form-field>
                <p>Provide the output type as preferred. Refer <a
                    href="https://help.bizdata360.com/books/ezintegrations/page/data-source-email#bkmrk-step-6%3A-output-type">here</a></p>
                <mat-form-field appearance="outline">
                  <mat-label class="bold-label">Output Type</mat-label>
                  <mat-select #sourceEmailOutputTypeDropdown formControlName="out_type" id="ib_update_source_out_type" 
                    panelClass="custom-overlay-panel" (openedChange)="onDropdownOpened($event, sourceEmailOutputTypeDropdown)">
                    <mat-option *ngFor="let obj of email_out_types" [value]="obj.value" selected>{{obj.label}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card>
            <div class="action-btn-section">
              <button mat-stroked-button class="next" id="ib_update_source_dl_cancel"
                routerLink="/baseapp/integration">Cancel</button>
              <!-- <button mat-stroked-button matStepperPrevious class="previous">
                <mat-icon matSuffix>west</mat-icon>Previous
              </button> -->
              <button mat-stroked-button matStepperNext class="next" id="ib_update_source_dl_next">
                Next<mat-icon matSuffix>east</mat-icon>
              </button>
            </div>
          </form>
        </mat-step>

        <!-- <mat-step [stepControl]="dataOperations" [completed]="false">
          <form [formGroup]="dataOperations">
            <ng-template matStepLabel>Data Operations</ng-template>
            <mat-card class="m-card operations">
              <mat-card-title class="m-title">
                <span class="m-header">Operations</span>
                <span class="sub-content">Please answer the following question to process
                  further.</span>
              </mat-card-title>
              <mat-card-content class="m-body">
                <div class="operations-sec">
                  <span class="operations-sec-header">You want to Apply Coversions on the Field to Integer, Float,
                    Date Etc. ?</span>
                  <mat-slide-toggle class="example-margin" [color]="color" [checked]="checked" [disabled]="disabled">
                  </mat-slide-toggle>
                </div>
                <div class="operations-sec">
                  <span class="operations-sec-header">You want to convert String to JSON or XML to JSON ?</span>
                  <mat-slide-toggle class="example-margin" [color]="color" [checked]="checked" [disabled]="disabled">
                  </mat-slide-toggle>
                </div>
                <div class="operations-sec">
                  <span class="operations-sec-header">You want to add New Field</span>
                  <mat-slide-toggle class="example-margin" [color]="color" [checked]="checked" [disabled]="disabled">
                  </mat-slide-toggle>
                </div>

                <div class="operations-sec">
                  <mat-divider></mat-divider>
                  <div class="operations-type">
                    <div class="op-type">
                      <mat-form-field class="op-type-select" appearance="fill">
                        <mat-label>Select Operation Type</mat-label>
                        <mat-select>
                          <mat-option *ngFor="let d of sourceColoumns" [value]="d.obj_name">
                            {{ d.obj_name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="op-params-bx">
                      <div class="op-params" id="param-{{i}}" *ngFor="let parms of operationParam;let i = index;">
                        <mat-form-field appearance="fill">
                          <mat-label>Parameter</mat-label>
                          <input type="text" matInput />
                          <mat-icon matSuffix (click)="deleteParam(i)">clear</mat-icon>
                        </mat-form-field>
                      </div>
                      <button mat-raised-button (click)="addOpParam()">Add</button>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
            <div class="action-btn-section">
              <button mat-stroked-button matStepperPrevious class="previous">
                <mat-icon matSuffix>west</mat-icon>Previous
              </button>
              <button mat-stroked-button matStepperNext class="next">
                Next<mat-icon matSuffix>east</mat-icon>
              </button>
            </div>
          </form>
        </mat-step> -->
        <mat-step [stepControl]="dataOperations" [completed]="false">
          <!-- <form [formGroup]="dataOperations"> -->
          <ng-template matStepLabel>Data Operations</ng-template>
          <mat-card class="m-card operations" cdkDropListGroup>
            <!-- <mat-card-title class="m-title">
                <span class="m-header">Operations</span>
                <span class="sub-content">Please answer the following question to process
                  further.</span>
              </mat-card-title> -->

            <div class="ops-nav">
              <mat-form-field appearance="fill" class="non-fill">
                <mat-label>Search</mat-label>
                <input matInput type="text" placeholder="Search by operations" [(ngModel)]="search"
                  (ngModelChange)="getSearchOnChange($event)" (keydown.enter)="$event.preventDefault()">
                <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <h4>Operations</h4>
              <div class="ops-overflow-scroll">
                <div *ngIf="!searchFilter">
                  <div class="ops-inner" cdkDropList #operationsList="cdkDropList" [cdkDropListData]="operations"
                    cdkDropListSortingDisabled [cdkDropListEnterPredicate]="noReturnPredicate"
                    (cdkDropListEntered)="onSourceListEntered($event)">
                    <ng-container *ngFor="let row of operationsArr; let i = index">
                      <div class="ops-main" [style.color]='row.color'>
                        <label>{{row.label}}</label>
                        <span
                          style="cursor: pointer; display: grid; grid-template-columns: 30px auto; grid-column-gap: 15px; margin: 8px 0;"
                          class="title-col" *ngFor="let col of row.blocks" cdkDrag [cdkDragData]="row"
                          id="{{col.element_id}}">
                          <img style="width: 30px; margin: 0px 8px;"
                            src='{{ "assets/images/operations_icons/" + col.icon + ".svg" }}'>
                          <p style=" display: inline; margin: 0; padding: 0; line-height: 30px; transition: all 0.3s">
                            {{col.title}}</p>
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
                <div *ngIf="searchFilter">
                  <div class="ops-inner" cdkDropList #operationsList="cdkDropList" [cdkDropListData]="operationsSearch"
                    cdkDropListSortingDisabled [cdkDropListEnterPredicate]="noReturnPredicate"
                    (cdkDropListEntered)="onSourceListEnteredSearch($event)">
                    <ng-container *ngFor="let row of operationsArrSearch; let i = index">
                      <div class="ops-main" [style.color]='row.color'>
                        <label>{{row.label}}</label>
                        <span
                          style="cursor: pointer; display: grid; grid-template-columns: 30px auto; grid-column-gap: 15px; margin: 8px 0;"
                          class="title-col" *ngFor="let col of row.blocks" cdkDrag [cdkDragData]="row"
                          id="{{col.element_id}}">
                          <img style="width: 30px; margin: 0px 8px;"
                            src='{{ "assets/images/operations_icons/" + col.icon + ".svg" }}'>
                          <p style=" display: inline; margin: 0; padding: 0; line-height: 30px; transition: all 0.3s">
                            {{col.title}}</p>
                        </span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <mat-card-content class="m-body">
              <!-- <div cdkDropList cdkDropListOrientation="horizontal" class="example-list" (cdkDropListDropped)="drop($event)">
                  <div class="example-box" *ngFor="let block of blocks; let i = index" cdkDrag>{{block.title}}</div>
                </div> -->

              <!-- <div class="example-list" cdkDropList
                  #operationsList="cdkDropList"
                  [cdkDropListData]="operations"
                  cdkDropListSortingDisabled
                  [cdkDropListEnterPredicate]="noReturnPredicate"
                  (cdkDropListEntered)="onSourceListEntered($event)">
                  <div class="example-box" *ngFor="let item of operations" cdkDrag [cdkDragData]="item">{{item.title}}</div>
                </div> -->

              <!-- <div #contenedor class="categories">
                  <ng-container *ngFor="let item of blocks;let i=index">
                    <div class="categories-item"  cdkDropList #blocksList="cdkDropList" cdkDropListOrientation="horizontal"
                    [cdkDropListData]="{blockArr: blocks, block:item,index:i}" (cdkDropListDropped)="drop($event)">
                      <div class="inner" cdkDrag [cdkDragData]="item">
                        <div class="example-custom-placeholder" *cdkDragPlaceholder></div>
                        {{item.title}}
                      </div>
                    </div>
                  </ng-container>
                </div> -->
              <div class="ops-tools">
                <div class="ops-tools-grid">
                  <button matTooltip="Mute/unMute Operation" matTooltipPosition="above"
                    (click)="confirmMuteOperation()">
                    <div class="mute-operation"></div>
                  </button>
                  <button matTooltip="Clear All Operation" matTooltipPosition="above" (click)="confirmClearOperation()">
                    <div class="clear-operation"></div>
                  </button>
                  <!-- <button>Import</button>
                    <button>Export</button> -->
                  <!-- <button (click)="addNewRow()"><mat-icon> clear_all</mat-icon>Add row</button> -->
                </div>
              </div>
              <ng-container *ngIf="blocks.length  == 0">
                <div class="timeline" cdkDropList #blocksList="cdkDropList" [cdkDropListData]="{blockArr: blocks}"
                  (cdkDropListDropped)="drop($event)">
                  <p class="drop-ops-text">Drop your operations here</p>
                </div>
              </ng-container>

              <ng-container *ngIf="blocks.length  > 0">
                <div class="timeline">
                  <ng-container *ngFor="let row of newBlocks; let i=index">
                    <div class="row" [ngClass]='i%2? "row-reverse": ""'>
                      <ng-container *ngFor="let col of newBlocks[i]; let j = index">
                        <div class="operations" cdkDropList #blocksList="cdkDropList" id="{{col.element_id}}"
                          [cdkDropListData]=" {blockArr: blocks, block:col}" (cdkDropListDropped)="drop($event)">
                          <!-- <div *ngIf="i%2 != 0 && j == 2 && j > 0 && splitValue == 3" class="left-u-bend"></div>
                          <div *ngIf="i%2 == 0 && j == 2 && j > 0 && splitValue == 3" class="right-u-bend"></div>
                          <div *ngIf="i%2 != 0 && j == 3 && j > 0 && splitValue == 4" class="left-u-bend"></div>
                          <div *ngIf="i%2 == 0 && j == 3 && j > 0 && splitValue == 4" class="right-u-bend"></div> -->
                          <div (click)="generateConfig(col.id, col.title,i,'left')"
                              *ngIf="i%2 != 0 && j == 2 && j > 0 && splitValue == 3" class="left-u-bend"></div>
                          <div (click)="generateConfig(col.id, col.title,i,'right')"
                              *ngIf="i%2 == 0 && j == 2 && j > 0 && splitValue == 3" class="right-u-bend"></div>
                          <div (click)="generateConfig(col.id, col.title,i,'right')"
                              *ngIf="i%2 == 0 && (j == 0 || j == 1)" class="gear-pipe"></div>
                          <div (click)="generateConfig(col.id, col.title,i,'')" *ngIf="i == 0 || (i%2 !=0 && j!=2)"
                              class="gear-pipe2"></div>
                          <!-- <div *ngIf="(i+1) == 1 && i > 0" class="bend-2"></div>
                            <div *ngIf="(i+1) == 2 || (i+1) == 3 && i > 0" class="bend"></div> -->
                          <div class="circle" *ngIf="col.isValid  && !col?.isMute" id="{{col.element_id}}"
                            [class.active]='selectedOperationId === col.id' (click)=" openForm(col.title, col.id, col)"
                            cdkDrag>
                            <span class="ops-title-up" *ngIf="col.title == 'Generate Array Sequence Number'" matTooltip="Generate Array Sequence Number">GENERATE ARRAY SEQ. NO</span>
                              <span class="ops-title-up" *ngIf="col.title != 'Generate Array Sequence Number'">{{ col.title | uppercase }}</span>
                            <span class="ops-title-count">{{ col?.count }}</span>
                            <button style="margin-left: 3px; width: 22px; height: 22px; border-radius: 50%"
                              (click)="removeItem(col.id, col.title)">X</button>
                          </div>
                          <div class="circle" *ngIf="!col.isValid && !col?.isMute" id="{{col.element_id}}"
                            [class.inValid]="!col.isValid" (click)="openForm(col.title, col.id)" cdkDrag>
                            <span class="ops-title-up">{{ col.title | uppercase }}</span>
                            <span class="ops-title-count">{{ col?.count }}</span>
                            <button style="margin-left: 3px; width: 22px; height: 22px; border-radius: 50%"
                              (click)="removeItem(col.id, col.title)">X</button>
                          </div>
                          <div class="circle" *ngIf="col?.isMute && selectedOperationId !== col.id"
                            id="{{col.element_id}}" [class.isMute]="col.isMute && selectedOperationId !== col.id"
                            (click)="openForm(col.title, col.id)" cdkDrag>
                            <span class="ops-title-up">{{ col.title | uppercase }}</span>
                            <span class="ops-title-count">{{ col?.count }}</span>
                            <button style="margin-left: 3px; width: 22px; height: 22px; border-radius: 50%"
                              (click)="removeItem(col.id, col.title)">X</button>
                          </div>
                          <div class="circle" *ngIf="col?.isMute && selectedOperationId === col.id"
                            id="{{col.element_id}}" [class.isMuteActive]="col?.isMute && selectedOperationId === col.id"
                            (click)="openForm(col.title, col.id)" cdkDrag>
                            <span class="ops-title-up">{{ col.title | uppercase }}</span>
                            <span class="ops-title-count">{{ col?.count }}</span>
                            <button style="margin-left: 3px; width: 22px; height: 22px; border-radius: 50%"
                              (click)="removeItem(col.id, col.title)">X</button>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <!-- <button style="padding: 10px; display: inline-block; width: 150px;" (click)="transformOpsJson()">Test Ops</button> -->


              <!-- <div class="timeline">
                  <ng-container *ngFor="let row of newBlocks;let i=index">
                    <div class="row" cdkDropList #blocksList="cdkDropList" [cdkDropListData]="{blocks}" (cdkDropListDropped)="destinationDropped($event)" [ngClass]="{right: i % 2 === 0, left: i % 2 !== 0}">
                      <div class="operations" *ngFor="let col of newBlocks[i]; let j = index" cdkDrag>{{ col.title }}
                        <button (click)="removeItem(col.id, col.title)">Remove</button>
                      </div>
                    </div>
                  </ng-container>
                </div> -->


              <form [formGroup]="bizdata_ops_datatypes_fb" *ngIf="isDataTypeFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/7HZ5OZ2IL9M?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="datatypesRows">
                  <div class="ops-form" *ngFor="let fo of datatypesRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Data Types</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_datatypes_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'boolean_operator'">
                                <p>
                                  Converts string type Boolean value into Boolean Datatype.
                                  <br>
                                  User can enter multiple key name enclosed in double quotes separated by comma
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"test_passed"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-data-type">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.datatypesRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'float_operator'">
                                <p>
                                  Converts string type Float value into Float Datatype.
                                  <br>
                                  User can enter multiple key name enclosed in double quotes separated by comma
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"Amount"</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-data-type">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.datatypesRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'integer_operator'">
                                <p>
                                  Converts string type Integer value into Integer Datatype.
                                  <br>
                                  User can enter multiple key name enclosed in double quotes separated by comma
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"Quantity"</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-data-type">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.datatypesRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'datetime_operator'">
                                <p>
                                  Converts string type Datetime value into Datetime Datatype and changes the format of
                                  the Date.
                                  <br>
                                  User can enter multiple key name enclosed in double quotes separated by comma
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"created_date","%Y-%m-%d %H:%M:%S","%d-%m-%Y
                                    %H:%M:%S"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-data-type">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.datatypesRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_append_fb" *ngIf="isAppendFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/B18pPXoILVU?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="appendRows">
                  <div class="ops-form" *ngFor="let fo of appendRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Append</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_append_obj">
                          <div class="column-operation">
                            <p>
                              Adds a new key value pair in our dataset
                              <br>
                              Comma Seperated list of key-value pair in double quotes
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"export_flag_y":"Y","export_flag_p":"P"</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-append">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.appendRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                          <div class="operation-border" style="display: grid;grid-template-columns: 95% 5%;">
                            <ngx-codemirror [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              (keydown.enter)="$event.preventDefault()" #appendScriptEditor
                              [options]="appendEditorOption">
                            </ngx-codemirror>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix
                              style="margin-top: 10px;color:#000; cursor: pointer;">content_copy</mat-icon>
                          </div>
                          <!-- <json-editor [formControlName]="operation" id="copy1_{{i}}_{{operation}}" [options]="appendoptions">
                            </json-editor> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_uppercase_fb" *ngIf="isUppercaseFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/6NAw_ZOUgTE?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="uppercaseRows">
                  <div class="ops-form" *ngFor="let fo of uppercaseRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Uppercase</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_uppercase_obj">
                          <div class="column-operation">
                            <p>
                              Converts defined key's value in Upper Case.
                              <br>
                              Comma Seperated list of keys in double quotes
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"first_name","last_name"</span> &nbsp;<br>
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-help-tip">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.uppercaseRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_titlecase_fb" *ngIf="isTitlecaseFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/G_anQVhUaf4?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="titlecaseRows">
                  <div class="ops-form" *ngFor="let fo of titlecaseRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Titlecase</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_titlecase_obj">
                          <div class="column-operation">
                            <p>
                              Converts a given key's value into Title case
                              <br>
                              Comma separated key names in double quotes
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"email","avatar"</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-title-case">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.titlecaseRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_lowercase_fb" *ngIf="isLowercaseFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/ytFs2OIHXRU?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="lowercaseRows">
                  <div class="ops-form" *ngFor="let fo of lowercaseRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Lowercase</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_lowercase_obj">
                          <div class="column-operation">
                            <p>
                              Converts a given key's value into Lower case
                              <br>
                              Comma separated list of keys in double quotes
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"first_name","last_name"</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-lower-case">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.lowercaseRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dataextractor_fb" *ngIf="isData_extractorFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/jO5sY5u3OIg?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="dataextractorRows">
                  <div class="ops-form" *ngFor="let fo of dataextractorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Data Extractor</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dataextractor_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'data_extractor'">
                                <p>
                                  Extract Key's and its value's from a JSON Response
                                  <br>
                                  Comma separated list of keys in double quotes
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"['access_token']","['feedDocumentId']","['delimiter_data']","['url']"</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-data-extractor">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dataextractorRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'data_extractor_keys'">
                                <p>
                                  This helps to provide user defined keynames, if left blank it will auto generate
                                  keynames
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-data-extractor">
                                    here</a>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                            *ngIf="operation != 'data_extractor_keys'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea cols="100" rows="8" matInput [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                            *ngIf="operation == 'data_extractor_keys'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea cols="100" rows="8" matInput [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_trim_fb" *ngIf="isTrimFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/N4_5aRGTXRU?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="trimRows">
                  <div class="ops-form" *ngFor="let fo of trimRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Trim</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_trim_obj">
                          <div class="column-operation">
                            <p>
                              Trims removes extra space from the given key's value
                              <br>
                              Give the key name comma separated in double quotes
                              <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"first_name"</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-trim%C2%A0">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.trimRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_json2string_fb" *ngIf="isJson2stringFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/SIFnC5Ba0kI?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="json2stringRows">
                  <div class="ops-form" *ngFor="let fo of json2stringRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON to String</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_json2string_obj">
                          <div class="column-operation">
                            <p>
                              Converts JSON into String for the given key's value
                              <br>
                              Give the key name comma separated in double quotes
                              <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"key1","key2"</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-json-to-string">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.json2stringRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_string2json_fb" *ngIf="isString2jsonFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/rS4Rp0_qx5M?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="string2jsonRows">
                  <div class="ops-form" *ngFor="let fo of string2jsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - String to JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_string2json_obj">
                          <div class="column-operation">
                            <p>
                              Converts String into JSON for the given key's value
                              <br>
                              Give the key name comma separated in double quotes
                              <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"key1","key2"</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-string-to-json">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.string2jsonRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_base64decoding_fb" *ngIf="isBase64decodingFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/-rST2yiY8Q4?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="base64decodingRows">
                  <div class="ops-form" *ngFor="let fo of base64decodingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Base64 decoding</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_base64decoding_obj">
                          <div class="column-operation">
                            <p>
                              Decodes the base64 value of a given key into string.
                              <br>
                              Comma separated list of keys in double quotes
                              <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"email"</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-base64-decoding">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.base64decodingRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_base64encoding_fb" *ngIf="isBase64encodingFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/a_sg-8rjag8?si=GYjQhl_yZ_KCmTOO%22?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="base64encodingRows">
                  <div class="ops-form" *ngFor="let fo of base64encodingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Base64 encoding</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_base64encoding_obj">
                          <div [ngSwitch]="operation">
                            <div *ngSwitchCase="'input_type'">
                              <div class="column-operation" style="display: flow-root;">

                                <p style="float: left;margin-top: 15px;">Input Type - (Select File if there is a file
                                  link)</p>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                  formControlName="input_type"
                                  [value]="base64encodingRows().controls[i].value.input_type"
                                  (change)="isbase64encodeToggle($event,i)">
                                  <mat-button-toggle value="string">String</mat-button-toggle>
                                  <mat-button-toggle value="file">File</mat-button-toggle>
                                </mat-button-toggle-group>
                              </div>
                            </div>
                            <div *ngSwitchCase="'base64_encode'">
                              <div class="column-operation">
                                <p>
                                  Encodes the value of given key into base64.
                                  <br>
                                  Comma separated list of keys in double quotes
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"email"</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-base64-encoding">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.base64encodingRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                            *ngIf="operation == 'base64_encode'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_generatesequence_fb" *ngIf="isGeneratesequenceFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/pTbocQWidI8?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="generatesequenceRows">
                  <div class="ops-form" *ngFor="let fo of generatesequenceRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Generate Array Sequence Number</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_generatesequence_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'sequence_key'">
                                <p>
                                  The keyname in which the singleline data is present whose sequence we need to provide.
                                  <br>
                                  Enter the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">rows</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-generate-array-seque">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.generatesequenceRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'sequence_number_key'">
                                <p>
                                  Name of new key which will hold value of sequence
                                  <br>
                                  Enter the keyname
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">sequence_no.</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-generate-array-seque">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.generatesequenceRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_repeatfirstrow_fb" *ngIf="isRepeatfirstrowFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/_I0CVYb0jNg?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="repeatfirstrowRows">
                  <div class="ops-form" *ngFor="let fo of repeatfirstrowRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Repeat First Row Values</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_repeatfirstrow_obj">
                          <div [ngSwitch]="operation">
                            <div *ngSwitchCase="'source_key'">
                              <p>
                                Reads the dataset from a single line ( example a key with a array having multiple
                                records)
                                <br>
                                Keys inside brackets and single quotes
                                <span style="background-color: #ddd;"
                                  id="copy_{{i}}_{{operation}}">['bizdata_dataset_response']['data']</span> &nbsp;
                                <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-repeat-first-row-val">
                                  here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.repeatfirstrowRows())">swap_vert</mat-icon>
                              </p>
                            </div>
                            <div *ngSwitchCase="'fields_to_repeat_value'">
                              <p>
                                An array of column name's whose first row value we want to repeat.
                                <br>
                                Comma separated list of keys in double quotes
                                <span style="background-color: #ddd;"
                                  id="copy_{{i}}_{{operation}}">"month","customer_site"</span> &nbsp;
                                <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-repeat-first-row-val">
                                  here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.repeatfirstrowRows())">swap_vert</mat-icon>
                              </p>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_toplevel_fb" *ngIf="isToplevelFromEnabled" style="margin-bottom:120px;">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/nAFgrWlIQvo" frameborder="0" allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="toplevelRows">
                  <div class="ops-form" *ngFor="let fo of toplevelRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Send Keys Top of Root</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_toplevel_obj">
                          <div class="column-operation">
                            <p>
                              Column to root is the given key's value.
                              <br>
                              Give the key name comma separated in double quotes
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"key_name1","key_name2","['key_name3']['key_name4']","key_name5"</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-send-keys-top-of-roo">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.toplevelRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_datetimestamp_fb" *ngIf="isDatetimestampFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/KfE54-1j59U?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="datetimestampRows">
                  <div class="ops-form" *ngFor="let fo of datetimestampRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Today Timestamp</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_datetimestamp_obj;">
                          <div [ngSwitch]="operation">
                            <div *ngSwitchCase="'date_format'">
                              <p>
                                Converts the now timestamp to region based instance into ISO Date Format
                                <br>
                                Provide the format of datetime
                                <span style="background-color: #ddd;"
                                  id="copy_{{i}}_{{operation}}">%Y-%m-%dT%H:%M:%S.%f%z</span> &nbsp;
                                <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-today-timestamp">
                                  here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.datetimestampRows())">swap_vert</mat-icon>
                              </p>
                            </div>
                            <div *ngSwitchCase="'datetime_key'">
                              <p>
                                Give the name of key in which you want to save your date
                                <br>
                                Give the key name in double quotes
                                <span style="background-color: #ddd;"
                                  id="copy_{{i}}_{{operation}}">dl_insert_date</span> &nbsp;
                                <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-today-timestamp">
                                  here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.datetimestampRows())">swap_vert</mat-icon>
                              </p>
                            </div>
                          </div>
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_jsontoxml_fb" *ngIf="isJSON_to_XMLFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/VjlLI73kNGc?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="jsontoxmlRows">
                  <div class="ops-form" *ngFor="let fo of jsontoxmlRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON to XML</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_jsontoxml_obj">
                          <div [ngSwitch]="operation">
                            <div *ngSwitchCase="'key_data'">
                              <p>
                                Convert's JSON into XML for given key's value
                                <br>
                                Enter key name
                                <span style="background-color: #ddd;"
                                  id="copy_{{i}}_{{operation}}">bizdata_dataset_response</span> &nbsp;
                                <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-json-to-xml">
                                  here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.jsontoxmlRows())">swap_vert</mat-icon>
                              </p>
                            </div>
                            <div *ngSwitchCase="'response_key'">
                              <p>
                                Collects the converted XML value in the given keyname
                                <br>
                                Enter key name
                                <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">data_response</span>
                                &nbsp;
                                <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-json-to-xml">
                                  here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.jsontoxmlRows())">swap_vert</mat-icon>
                              </p>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required />
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_xmltojson_fb" *ngIf="isXML_to_JSONFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/tNmZjoYpu3g?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="xmltojsonRows">
                  <div class="ops-form" *ngFor="let fo of xmltojsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - XML TO JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_xmltojson_obj">
                          <div [ngSwitch]="operation">
                            <div *ngSwitchCase="'get_key'">
                              <p>
                                Convert's XML into JSON for given key's value
                                <br>
                                Enter key name
                                <span style="background-color: #ddd;"
                                  id="copy_{{i}}_{{operation}}">bizdata_dataset_response</span> &nbsp;
                                <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-xml-to-json">
                                  here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.xmltojsonRows())">swap_vert</mat-icon>
                              </p>
                            </div>
                            <div *ngSwitchCase="'response_key'">
                              <p>
                                Collects the converted JSON value in the given keyname
                                <br>
                                Enter key name
                                <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">data_response</span>
                                &nbsp;
                                <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-xml-to-json">
                                  here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.xmltojsonRows())">swap_vert</mat-icon>
                              </p>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required />
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_json2dl_fb" *ngIf="isJSON2dlFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/TUZI4vRpldQ?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="json2dlRows">
                  <div class="ops-form" *ngFor="let fo of json2dlRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON to delimiter</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_json2dl_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'key_data'">
                                <p>
                                  Adds a new key on the fly with its value as a static value or dynamic value. This will
                                  add key and its value for each record
                                  <br>
                                  Key name inside bracket and single quotes
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">['items']</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-json-to-delimiter">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.json2dlRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'delimiter'">
                                <p>
                                  Delimiter in flat file depends on the user.
                                  <br>
                                  Passing the delimiter
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">\t</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-json-to-delimiter">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.json2dlRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'fields'">
                                <p>
                                  By default it will be empty, If user wants to specify fieldnames they can specify.
                                  <br>
                                  Comma separated keys in double quotes
                                  <br>
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"column1","column2"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-json-to-delimiter">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.json2dlRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'autodetect_column_names'">
                                <p>
                                  For same header of flat file "true" otherwise false
                                  <br>
                                  By default it will be
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">true</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-json-to-delimiter">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'skip_header'">
                                <p>
                                  If we want keyname of our data as headers then "false" else "true"
                                  <br>
                                  By default it will be
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">false</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-json-to-delimiter">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'response_key'">
                                <p>
                                  Key in which our delimiter data will be stored
                                  <br>
                                  Enter key name to store the data
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">delimiter_data</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-json-to-delimiter">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.json2dlRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline"
                            *ngIf="operation != 'fields' && operation != 'autodetect_column_names' && operation != 'skip_header'"
                            class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required />
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline"
                            *ngIf="operation != 'fields' && operation == 'autodetect_column_names' && operation != 'skip_header'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <mat-slide-toggle [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              [checked]="json2dlRows().controls[i].value.isCheckedAuto" style="float:right"
                              (change)="isJson2DlAutoDetectColumnNameToggle($event,i)"></mat-slide-toggle>
                            <textarea matInput hidden></textarea>
                          </mat-form-field>
                          <mat-form-field appearance="outline"
                            *ngIf="operation != 'fields' && operation != 'autodetect_column_names' && operation == 'skip_header'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <mat-slide-toggle [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              [checked]="json2dlRows().controls[i].value.isCheckedSkip" style="float:right"
                              (change)="isJson2DlSkipHeaderToggle($event,i)"></mat-slide-toggle>
                            <textarea matInput hidden></textarea>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                            *ngIf="operation == 'fields' && operation != 'autodetect_column_names' && operation != 'skip_header'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dl2json_fb" *ngIf="isDl2jsonFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/u3cBoCXGG4Y?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="dl2jsonRows">
                  <div class="ops-form" *ngFor="let fo of dl2jsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Delimiter to JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dl2json_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'key_data'">
                                <p>
                                  Adds a new key on the fly with its value as a static value or dynamic value. This will
                                  add key
                                  and its value for each record
                                  <br>
                                  Keyname inside brackets and single quotes
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">['TableData']</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-delimiter-to-json">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dl2jsonRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'delimiter'">
                                <p>
                                  Delimiter value depending upon the delimited file/delimited data we are passing.
                                  <br>
                                  Pass the delimiter
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">\t</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-delimiter-to-json">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dl2jsonRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'fields'">
                                <p>
                                  By default it will be empty, If user wants to specify fieldnames they can specify.
                                  <br>
                                  Comma separated list of keys in double quotes
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"Customer
                                    Site","Organization"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-delimiter-to-json">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dl2jsonRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'autodetect_column_names'">
                                <p>
                                  For same header is flat file "true" otherwise false
                                  <br>
                                  By default it will be
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">true</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-delimiter-to-json">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'skip_header'">
                                <p>
                                  "false" if we want firstline of flatfile as headers
                                  <br>
                                  By default it will be
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">false</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-delimiter-to-json">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'response_key'">
                                <p>
                                  Keyname in which converted JSON data will be stored
                                  <br>
                                  Enter the keyname to store the data
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">tabledata</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-delimiter-to-json">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dl2jsonRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix"
                            *ngIf="operation != 'fields' && operation != 'autodetect_column_names' && operation != 'skip_header'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required />
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline"
                            *ngIf="operation != 'fields' && operation == 'autodetect_column_names' && operation != 'skip_header'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <mat-slide-toggle [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              [checked]="dl2jsonRows().controls[i].value.isCheckedAuto" style="float:right"
                              (change)="isDl2JsonAutoDetectColumnNameToggle($event,i)"></mat-slide-toggle>
                            <textarea matInput hidden></textarea>
                          </mat-form-field>
                          <mat-form-field appearance="outline"
                            *ngIf="operation != 'fields' && operation != 'autodetect_column_names' && operation == 'skip_header'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <mat-slide-toggle [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              [checked]="dl2jsonRows().controls[i].value.isCheckedSkip" style="float:right"
                              (change)="isDl2JsonSkipHeaderToggle($event,i)"></mat-slide-toggle>
                            <textarea matInput hidden></textarea>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                            *ngIf="operation == 'fields' && operation != 'autodetect_column_names' && operation != 'skip_header'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dl2array_fb" *ngIf="isDl2arrayFormEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/D3oy2eP4Hio?si=YMGhHx2l_HFiMvZv" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="dl2arrayRows">
                  <div class="ops-form" *ngFor="let fo of dl2arrayRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Delimiter to Array</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dl2array_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'dl_key'">
                                <p>
                                  Converts a given key's delimited value into array.
                                  <br>
                                  Pass the keyname like this
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">Email</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-delimeter-to-arrayno">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dl2arrayRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'delimiter'">
                                <p>
                                  Give the delimiter used to seperate the delimited values.
                                  <br>
                                  Pass the delimiter
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">\t</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-delimeter-to-arrayno">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dl2arrayRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dataaggregation_fb" *ngIf="isDataaggregationFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/M75SBzkL-Wk?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="dataaggregationRows">
                  <div class="ops-form" *ngFor="let fo of dataaggregationRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Data aggregation</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dataaggregation_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'agg_data_key'">
                                <p>
                                  It will be empty for multiline data and will have data key in case of singleline data
                                  <br>
                                  By default it will be empty.
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-data-aggregation">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'groupby_key'">
                                <p>
                                  Give the key name that you want to group by. Typically this is a unique identifier in
                                  your dataset. For example Order and Order Line Items in a single dataset will have
                                  unique identifier as Order. For one Order you can have multiple line items
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">ORDERNUMBER</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-data-aggregation">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dataaggregationRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'array_key'">
                                <p>
                                  Give the key name wherein you want to hold the common keys. One can provide any key
                                  name.
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">orderLines</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-data-aggregation">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dataaggregationRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'array_key_nested_columns'">
                                <p>
                                  Give the key name as comma separated keys that should be available inside the Array
                                  Key.
                                  <br>
                                  Provide comma separated keys in double quotes
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"ORDER_TYPE","MODE_OF_TRANSPORT"</span>
                                  This field if kept empty, it will add all the keys from previous operation in array.
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-data-aggregation">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dataaggregationRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix" *ngIf="operation == 'agg_data_key'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()">
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="input-suffix"
                            *ngIf="operation != 'array_key_nested_columns' && operation != 'agg_data_key'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                            *ngIf="operation == 'array_key_nested_columns'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_pivot_fb" *ngIf="isPivotFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/AlEK444EYzw" frameborder="0" allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="pivotRows">
                  <div class="ops-form" *ngFor="let fo of pivotRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Pivot</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_pivot_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'get_key'">
                                <p>
                                  Provide the keyname which holds the array data.
                                  <br>
                                  For Example:
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">Order_line</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-pivot">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.pivotRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'transposed_key_name'">
                                <p>
                                  Name of key which need to be transposed as keyname
                                  <br>
                                  Keyname in double quotes. Example:
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"bucket_type"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-pivot">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.pivotRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'transposed_value'">
                                <p>
                                  Name of key which need to be transposed as value
                                  <br>
                                  Keyname in double quotes. Example:
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"bucket_value"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-pivot">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.pivotRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix" *ngIf="operation == 'get_key'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="input-suffix" *ngIf="operation != 'get_key'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_htmlextractor_fb" *ngIf="isHtmlExtractorFormEnabled">
                <!-- <mat-card-content class="m-body-append-video">
                                <div class="about-views-video">
                                  <iframe src="https://www.youtube.com/embed/AlEK444EYzw" frameborder="0"
                                    allowfullscreen></iframe>
                                </div>
                              </mat-card-content> -->
                <div formArrayName="htmlExtractorRows">
                  <div class="ops-form" *ngFor="let fo of htmlExtractorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - HTML Extractor</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_htmlextractor_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'input_html_key'">
                                <p>
                                  Provide key name which is holding the HTML data.
                                  <br>
                                  Example:
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">bizdata_dataset_response</span>.
                                  &nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.htmlExtractorRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'output_data_key'">
                                <p>
                                  Provide the keyname which will store the generated text response from HTML
                                  data.<br>Example:
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">html_text_data</span>. &nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.htmlExtractorRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <!-- ********************* -->
              <!-- END of Transformation-->

              <form [formGroup]="bizdata_ops_unpivot_fb" *ngIf="isUnPivotFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/JUOpoA2VaKo?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="unpivotRows">
                  <div class="ops-form" *ngFor="let fo of unpivotRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Unpivot</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_unpivot_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'transpose_key_name'">
                                <p>
                                  Name of key which need to be transposed
                                  <br>
                                  Comma separated list of keys in double quotes
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"bucket_type",
                                    "bucket_value"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-unpivot-0">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.unpivotRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'transpose_value'">
                                <p>
                                  Values which need to be transposed
                                  <br>
                                  Comma separated list of values in double quotes
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"on_hand",
                                    "purchase_orders"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-unpivot-0">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.unpivotRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_singleline2tuple_fb" *ngIf="singleline2tupleFormEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/02_V6mdkAgQ?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="singleline2tupleRows">
                  <div class="ops-form" *ngFor="let fo of singleline2tupleRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Single Line to Tuple</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_singleline2tuple_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'singleline_key'">
                                <p>
                                  Reads the dataset from a single line ( example a key with a array having multiple
                                  records)
                                  <br>
                                  Key name inside brackets and single quote
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">['TableData']</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-single-line-to-tuple">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.singleline2tupleRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'table_headers'">
                                <p>
                                  The key name that is available inside the arrays
                                  <br>
                                  Comma separated keys in double quotes
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"Customer_Site","Organization"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-single-line-to-tuple">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.singleline2tupleRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'tuple_key'">
                                <p>
                                  Key in which tuple data will be stored
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">tabledata</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-single-line-to-tuple">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.singleline2tupleRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix"
                            *ngIf="operation != 'table_headers'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required />
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                            <!-- <json-editor [formControlName]="operation" id="copy1_{{i}}_{{operation}}" [options]="singletomultioptions" required>
                            </json-editor> -->
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                            *ngIf="operation == 'table_headers'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                            <!-- <json-editor [formControlName]="operation" id="copy1_{{i}}_{{operation}}" [options]="singletomultioptions" required>
                            </json-editor> -->
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_tuple2singleline_fb" *ngIf="tuple2singlelineFormEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/n_tdcBoF9p0?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="tuple2singlelineRows">
                  <div class="ops-form" *ngFor="let fo of tuple2singlelineRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Tuple to Single Line</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_tuple2singleline_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'tuple_key'">
                                <p>
                                  Keyname whose value is the tuple data we want to convert.
                                  <br>
                                  Key name inside brackets and single quote
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">['TableData']</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-tuple-to-singleline">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.tuple2singlelineRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'headers'">
                                <p>
                                  Headers or key name of new json
                                  <br>
                                  Comma separated keyname in double quotes
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"Customer_Site","Organization"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-tuple-to-singleline">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.tuple2singlelineRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'singleline_key'">
                                <p>
                                  Keyname to save new converted JSON data
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">tabledata</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-tuple-to-singleline">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.tuple2singlelineRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix" *ngIf="i == 0 || i == 2">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required />
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                            <!-- <json-editor [formControlName]="operation" id="copy1_{{i}}_{{operation}}" [options]="singletomultioptions" required>
                            </json-editor> -->
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="textarea-suffix" *ngIf="i == 1">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                            <!-- <json-editor [formControlName]="operation" id="copy1_{{i}}_{{operation}}" [options]="singletomultioptions" required>
                            </json-editor> -->
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_singletomultiline_fb" *ngIf="chopFormEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/8hOXtUsWMkU?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="chopRows">
                  <div class="ops-form" *ngFor="let fo of chopRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Single Line to Multiline</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_singletomultiline_obj">
                          <div class="column-operation">
                            <p>
                              Converts single line JSON data to multiline JSON data
                              <br>
                              Key in double quotes
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">['bizdata_dataset_response']['data']</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk-data-type">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.chopRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <p><Strong>Note:</Strong> Common Keys at same level will be denormalized rest of the keys will be dropped. 
                            If nested keys are there then use <em style="font-weight: 500;">`Send Keys Top of Root`</em> Operation first. 
                          </p> 
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <!-- <form [formGroup]="bizdata_ops_file_fb" *ngIf="isfileFromEnabled">
                <div formArrayName="fileRows">
                  <div class="ops-form" *ngFor="let fo of fileRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - File</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_file_obj">
                          <mat-form-field appearance="outline">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation" id="copy1_{{i}}_{{operation}}">
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form> -->
              <form [formGroup]="bizdata_ops_email_fb" *ngIf="isemailFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/XJKbegfOQzo?si=YyZRC3-CvzBRbRz-" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="emailRows">
                  <div class="ops-form" *ngFor="let fo of emailRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Email</label>
                        <div class="ops-form-body">
                          <mat-tab-group class="views-options-data-group-email" fitInkBarToContent
                            mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                            [(selectedIndex)]="indexSelectionEmail">
                            <mat-tab label="Compose">
                              <div class="ops-form-body">
                                <div class="m-body">
                                  <mat-card class="m-card data-target">
                                    <div class="m-body">

                                      <div>
                                        <p>
                                          Provide the email address to whom we want to send the Email.<br>
                                          Provide complete email address, we can provide more than 1 email address
                                          also. Comma seperated email address in double
                                          quotes.&nbsp;
                                          <span
                                            style="background-color: #ddd;">"testing@gmail.com","testexample@gmail.com"</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-description-%3A">
                                            here</a>
                                        </p>
                                      </div>
                                      <!-- <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">To</mat-label>
                                        <input type="text" matInput formControlName="to"
                                          (keydown.enter)="$event.preventDefault()">
                                      </mat-form-field> -->
                                      <mat-form-field class="email-list">
                                        <mat-label>To</mat-label>
                                        <mat-chip-grid #chipGridOpsTo aria-label="Enter emails">
                                          <mat-chip-row *ngFor="let email of emailsOpsTo[i]"
                                            (removed)="removeEmailOpsTo(email,i)" [editable]="true"
                                            (edited)="editEmailOpsTo(email, $event,i)"
                                            [aria-description]="'press enter to edit ' + email">
                                            {{email}}
                                            <button matChipRemove [attr.aria-label]="'removeEmail ' + email">
                                              <mat-icon>cancel</mat-icon>
                                            </button>
                                          </mat-chip-row>
                                          <input type="text" style="display: none;" formControlName="to">
                                          <input placeholder="New email..." [matChipInputFor]="chipGridOpsTo"
                                            [matChipInputSeparatorKeyCodes]="separatorKeysCodesOpsTo"
                                            [matChipInputAddOnBlur]="addOnBlur"
                                            (matChipInputTokenEnd)="addEmailOpsTo($event,i)">
                                        </mat-chip-grid>
                                      </mat-form-field>

                                      <div>
                                        <p>
                                          Provide the email address of user whom we want to keep in Cc.<br>
                                          Example:Provide complete email address, we can provide more than 1 email
                                          address also. Comma seperated email address in double
                                          quotes.&nbsp;
                                          <span
                                            style="background-color: #ddd;">"testing@gmail.com","testexample@gmail.com"</span>.
                                          &nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-description-%3A">
                                            here</a>
                                        </p>
                                      </div>
                                      <!-- <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">Cc</mat-label>
                                        <input type="text" matInput formControlName="cc"
                                          (keydown.enter)="$event.preventDefault()">
                                      </mat-form-field> -->
                                      <mat-form-field class="email-list">
                                        <mat-label>Cc</mat-label>
                                        <mat-chip-grid #chipGridOpsCc aria-label="Enter emails">
                                          <mat-chip-row *ngFor="let email of emailsOpsCc[i]"
                                            (removed)="removeEmailOpsCc(email,i)" [editable]="true"
                                            (edited)="editEmailOpsCc(email, $event,i)"
                                            [aria-description]="'press enter to edit ' + email">
                                            {{email}}
                                            <button matChipRemove [attr.aria-label]="'removeEmail ' + email">
                                              <mat-icon>cancel</mat-icon>
                                            </button>
                                          </mat-chip-row>
                                          <input type="text" style="display: none;" formControlName="cc">
                                          <input placeholder="New email..." [matChipInputFor]="chipGridOpsCc"
                                            [matChipInputSeparatorKeyCodes]="separatorKeysCodesOpsCc"
                                            [matChipInputAddOnBlur]="addOnBlur"
                                            (matChipInputTokenEnd)="addEmailOpsCc($event,i)">
                                        </mat-chip-grid>
                                      </mat-form-field>
                                      <div>
                                        <p>
                                          Provide the email address of user whom we want to keep in Bcc.<br>
                                          Example:Provide complete email address, we can provide more than 1 email
                                          address also. Comma seperated email address in double
                                          quotes.&nbsp;
                                          <span
                                            style="background-color: #ddd;">"testing@gmail.com","testexample@gmail.com"</span>.
                                          &nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                            here</a>
                                        </p>
                                      </div>
                                      <!-- <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">Bcc</mat-label>
                                        <input type="text" matInput formControlName="bcc"
                                          (keydown.enter)="$event.preventDefault()">
                                      </mat-form-field> -->
                                      <mat-form-field class="email-list">
                                        <mat-label>Bcc</mat-label>
                                        <mat-chip-grid #chipGridOpsBcc aria-label="Enter emails">
                                          <mat-chip-row *ngFor="let email of emailsOpsBcc[i]"
                                            (removed)="removeEmailOpsBcc(email,i)" [editable]="true"
                                            (edited)="editEmailOpsBcc(email, $event,i)"
                                            [aria-description]="'press enter to edit ' + email">
                                            {{email}}
                                            <button matChipRemove [attr.aria-label]="'removeEmail ' + email">
                                              <mat-icon>cancel</mat-icon>
                                            </button>
                                          </mat-chip-row>
                                          <input type="text" style="display: none;" formControlName="bcc">
                                          <input placeholder="New email..." [matChipInputFor]="chipGridOpsBcc"
                                            [matChipInputSeparatorKeyCodes]="separatorKeysCodesOpsBcc"
                                            [matChipInputAddOnBlur]="addOnBlur"
                                            (matChipInputTokenEnd)="addEmailOpsBcc($event,i)">
                                        </mat-chip-grid>
                                      </mat-form-field>

                                      <div>
                                        <p>
                                          Provide the Subject for your email.<br>
                                          Example:This Email is for testing
                                          <span style="background-color: #ddd;"> Password@123</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                            here</a>
                                        </p>
                                      </div>
                                      <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">Subject</mat-label>
                                        <input type="text" matInput formControlName="subject"
                                          (keydown.enter)="$event.preventDefault()">
                                      </mat-form-field>

                                      <div>
                                        <p>
                                          Provide the singleline data keyname if the upcoming data is in single line.
                                          If the data is in multiline then leave it
                                          blank.<br>
                                          Example:Provide the Singleline data's Keyname&nbsp;
                                          <span style="background-color: #ddd;">items</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                            here</a>
                                        </p>
                                      </div>
                                      <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">Source Key</mat-label>
                                        <input type="text" matInput formControlName="source_key"
                                          (keydown.enter)="$event.preventDefault()">
                                      </mat-form-field>

                                      <div>
                                        <p>
                                          Provide the Body for your email.<br>
                                          Example:Email Body can be Simple Plain text or HTML templates.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                            here</a>
                                        </p>
                                      </div>
                                      <div class="mat-form-field">
                                        <ckeditor formControlName="body" [config]="ckEditorConfig"></ckeditor>
                                      </div>
                                    </div>
                                  </mat-card>
                                </div>
                              </div>
                            </mat-tab>
                            <mat-tab label="Attachment" style="margin-left:5px">
                              <div class="ops-form-body">
                                <div class="m-body">
                                  <mat-card class="m-card data-target">
                                    <div class="m-body">
                                      <div>
                                        <p>
                                          If we want to provide the attachment then make the Toggle as&nbsp;
                                          <span style="background-color: #ddd;">Yes</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                            here</a>
                                        </p>
                                      </div>
                                      <div class="image-xe profile-image">
                                        <div class="file-upload">
                                          <p style="color: #000000; padding: 10px 0;">
                                            <span>
                                              Is Attachment ?
                                            </span>
                                            <mat-slide-toggle style="text-align:right;" formControlName="isCheked"
                                              (change)="isAttachmentToggle($event,i)"></mat-slide-toggle>
                                          </p>
                                        </div>
                                      </div>

                                      <div *ngIf="emailRows().controls[i].value.attachment == 'yes'">
                                        <p>
                                          Provide the filename if we are sending an attachment.<br>
                                          Example:Provide the filename with extension &nbsp;
                                          <span style="background-color: #ddd;">test_file.csv</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                            here</a>
                                        </p>
                                      </div>
                                      <mat-form-field appearance="outline"
                                        *ngIf="emailRows().controls[i].value.attachment == 'yes'">
                                        <mat-label class="bold-label">File Name</mat-label>
                                        <input type="text" matInput formControlName="file_name"
                                          (keydown.enter)="$event.preventDefault()">
                                      </mat-form-field>
                                    </div>
                                  </mat-card>
                                </div>
                              </div>
                            </mat-tab>
                            <mat-tab label="Settings" style="margin-right:5px">
                              <div class="ops-form-body">
                                <div class="m-body">
                                  <mat-card class="m-card data-target">
                                    <div class="m-body">
                                      <div class="data-btn">
                                        <button mat-raised-button type="button" class="btn-test"
                                          (click)="checkTokenSessionBeforeTestEmailApi(emailRows().controls[i])">Test</button>
                                      </div>
                                      <div>
                                        <p>
                                          Provide the email address with which we want to send the Email.<br>
                                          Example:Provide the Email
                                          <span style="background-color: #ddd;"> username@gmail.com</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-description-%3A">
                                            here</a>
                                        </p>
                                      </div>
                                      <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">From</mat-label>
                                        <input type="text" matInput formControlName="From"
                                          (keydown.enter)="$event.preventDefault()" required>
                                      </mat-form-field>

                                      <div>
                                        <p>
                                          Provide the Password of the email provided in From section.<br>
                                          Example:Provide the Password
                                          <span style="background-color: #ddd;"> Password@123</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-description-%3A">
                                            here</a>
                                        </p>
                                      </div>
                                      <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">Password</mat-label>
                                        <input type="password" matInput formControlName="password"
                                          (keydown.enter)="$event.preventDefault()" required>
                                      </mat-form-field>

                                      <div>
                                        <p>
                                          Provide your mail server name.<br>
                                          Example:
                                          <span style="background-color: #ddd;"> mail.bizdata360.com</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-description-%3A">
                                            here</a>
                                        </p>
                                      </div>
                                      <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">Mail Server</mat-label>
                                        <input type="email" matInput formControlName="mailserver"
                                          (keydown.enter)="$event.preventDefault()" required>
                                      </mat-form-field>

                                      <div>
                                        <p>
                                          Provide your port number of the mail server.<br>
                                          Example:
                                          <span style="background-color: #ddd;"> 465</span>.&nbsp;
                                          <span style="font-style: italic;">Refer</span>
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                            href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-description-%3A">
                                            here</a>
                                        </p>
                                      </div>
                                      <mat-form-field appearance="outline">
                                        <mat-label class="bold-label">Port Number</mat-label>
                                        <input type="number" (keypress)="portEmailChange($event)" matInput formControlName="port_number"
                                          (keydown.enter)="$event.preventDefault()">
                                      </mat-form-field>
                                    </div>
                                  </mat-card>
                                </div>
                              </div>
                            </mat-tab>
                          </mat-tab-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_restapi_fb" *ngIf="isrestapiFormEnabled">
                <div formArrayName="restapiRows">
                  <div class="ops-form" *ngFor="let fo of restapiRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - API</label>
                        <div class="ops-form-body-ops">
                          <mat-tab-group class="views-options-data-group-email" fitInkBarToContent
                            mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms"
                            [(selectedIndex)]="indexSelectionEmail"
                            (selectedTabChange)="postmanTabChangeROA($event,fo.value.id,i)">
                            <mat-tab label="System">
                              <div class="ops-form-body-ops">
                                <mat-card class="m-card data-target">
                                  <ng-template matStepLabel>Data Target</ng-template>
                                  <mat-card class="m-card data-target">
                                    <mat-card-title class="m-title">
                                      <span class="m-header">What is your Data Target?</span>
                                      <span class="sub-content">Please specify or select the Data Target from
                                        Catalog</span>
                                    </mat-card-title>
                                    <div class="m-body">
                                      <mat-form-field class="data-column" appearance="outline" #formFieldTarget
                                        *ngIf="bridgeTargetListRAO.length > 0" (click)="onDropdownOpened(true, opsProductNameDropdown)">
                                        <mat-label>Search by target name</mat-label>
                                        <input type="text" placeholder="Search by target name"
                                          formControlName="bridge_target" matInput [matAutocomplete]="auto"
                                          (keydown.enter)="$event.preventDefault()" #opsProductNameDropdown="matAutocompleteTrigger" required />
                                        <mat-autocomplete #auto="matAutocomplete"
                                          (optionSelected)="OnChangeBridgeTargetRAO($event,i)">
                                          <mat-option class="create-new" [value]="createNew">Create New</mat-option>
                                          <mat-optgroup *ngFor="let brand of bridgeTargetRAO$ | async"
                                            [label]="brand.brand_name">
                                            <mat-option *ngFor="let product of brand.products" [value]="product">
                                              {{product}}
                                            </mat-option>
                                          </mat-optgroup>
                                        </mat-autocomplete>
                                        <button type="button" mat-button matSuffix aria-label="Search">
                                          <mat-icon>search</mat-icon>
                                        </button>
                                        <button type="button" mat-button
                                          *ngIf="fo.value.bridge_target != '' && fo.value.bridge_target != undefined"
                                          matSuffix aria-label="Clear" (click)="clearRAODataTarget(i)">
                                          <mat-icon>clear</mat-icon>
                                        </button>
                                      </mat-form-field>

                                      <div class="column-content">
                                        <mat-icon matSuffix>info</mat-icon>
                                        <p>
                                          Not sure on Data Target? Please checkout the
                                          <a style="text-decoration: none;" target="_blank"
                                            href="#/baseapp/marketplace">Marketplace</a> or
                                          <a style="text-decoration: none;" href="javascript:void(0);"
                                            (click)="dataSourceModal('operations', fo.value.id)">
                                            Add from Cart
                                          </a>
                                        </p>
                                      </div>
                                      <mat-form-field style="margin-top: 15px;" appearance="outline"
                                        *ngIf="fo.value.is_new_target">
                                        <mat-label>Enter Target Name</mat-label>
                                        <input type="text" formControlName="new_bridge_target" matInput
                                          placeholder="Target name" (keydown.enter)="$event.preventDefault()" required>
                                      </mat-form-field>

                                      <mat-form-field appearance="outline" *ngIf="fo.value.is_new_target">
                                        <mat-label>Enter Business Object</mat-label>
                                        <input type="text" formControlName="new_bridge_target_business_object" matInput
                                          placeholder="Business object" (keydown.enter)="$event.preventDefault()"
                                          required>
                                      </mat-form-field>
                                      <mat-form-field class="target-businessObj" appearance="fill"
                                        *ngIf="fo.value.is_new_target == false">
                                        <mat-label>Select Business Object</mat-label>
                                        <mat-select #opsBusinessObjectDropdown formControlName="bridge_target_business_object"
                                          (selectionChange)="onChangeBusinessObjectTargetRAO($event,i )" 
                                          panelClass="custom-overlay-panel" 
                                          (openedChange)="onDropdownOpened($event, opsBusinessObjectDropdown)">
                                          <mat-option *ngFor="let obj of fo.value.bridgeTargetBusinessObjectRAO"
                                            [value]="obj">
                                            {{ obj.business_obj }}
                                          </mat-option>
                                        </mat-select>
                                        <button type="button" mat-button *ngIf="fo.value.bridge_target_business_object"
                                        id="ib_create_target_clear_businessObj_btn" matSuffix aria-label="Clear"
                                        (click)="clearTargetBusinessObjectRAO(i)">
                                        <mat-icon>clear</mat-icon>
                                      </button>
                                      </mat-form-field>
                                    </div>
                                  </mat-card>
                                </mat-card>
                              </div>
                            </mat-tab>
                            <mat-tab label="Test">
                              <app-postmanui 
                                [apiCatalogFormType]="'operation'" [catalogueId]="operationCatalogId" [operationIndex]="i" [opsData]="opsData[i]" [updateIntBridgeData]="updateIntBridgeOperationData[i]" (uiUpdateComplete)="onChildUiUpdate(i)">
                              </app-postmanui>
                              <!-- <mat-card id="rest_api">
                                <div class="views-content-env-ops">
                                  <div class="views-content-env-data">
                                    <div class="add-environment-button" style="text-align: right;">
                                      <p>{{fo.value.selected_environment}}</p>
                                    </div>
                                    <div class="add-environment-button">
                                      <mat-icon class="icon" (click)="openEnvironmentRAO(true,i)">
                                        add
                                      </mat-icon>
                                    </div>
                                    <div class="exit-environment">
                                      <mat-icon class="icon"
                                        (click)="exitEnvironmentRAO(fo.value.selected_environment,i)">
                                        move_down
                                      </mat-icon>
                                    </div>
                                    <div class="env-settings">
                                      <div class="env-settings-wrapper" (click)="toggleMenuRAO()">
                                        <mat-icon matTooltip="Environment Settings"
                                          matTooltipPosition="above">settings</mat-icon>
                                        <mat-select class="env-settings-select"
                                          formControlName="bridge_endpoint_selected_environments_name"
                                          (selectionChange)="onEnvironmentChangeRAO($event,i)">
                                          <mat-option value="No Environment">No Environment</mat-option>
                                          <mat-option *ngFor="let tab of selectedEnvTabsRAO" [value]="tab">
                                            {{ tab }}
                                          </mat-option>
                                        </mat-select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="m-body" *ngIf="showEnvironmentTabRAO">
                                  <div class="env-container">
                                    <div class="env-header">
                                      <span class="env-header">Environment Setting</span>
                                    </div>
                                  </div>
                                  <div formArrayName="bridge_endpoint_environments_raw">
                                    <div *ngFor="let environments of bridgeRAOEnvironments(i).controls; let j = index">
                                      <div [formGroupName]="j">
                                        <ng-container *ngIf="j === currentDisplayedEnvIndexRAO">
                                          <div class="m-body">
                                            <div class="data-options-grid ng-star-inserted">
                                              <mat-form-field style="margin-top: 15px;" appearance="outline">
                                                <mat-label>Environment Name</mat-label>
                                                <input type="text" formControlName="env_name" matInput
                                                  placeholder="Environment Name"
                                                  (keydown.enter)="$event.preventDefault()" required>
                                              </mat-form-field>
                                              <mat-icon class="icon"
                                                (click)="confirmSaveEnvRAO(environments.value.env_name,j,fo.value.selected_environment,i)">
                                                save
                                              </mat-icon>
                                              <mat-icon class="icon"
                                                (click)="confirmDeleteEnvRAO(environments.value.env_name,j)">
                                                delete
                                              </mat-icon>
                                            </div>
                                          </div>
                                          <div class="mat-section-restAPI">
                                            <div class="m-body">
                                              <div class="data-options-wrapper">
                                                <div formArrayName="env_vars">
                                                  <div class="data-options-grid"
                                                    *ngFor="let env of envRAOData(i,j).controls; let envIndex = index">
                                                    <ng-container [formGroupName]="envIndex">
                                                      <mat-form-field style="margin-top: 15px;" appearance="outline">
                                                        <mat-label>Variable</mat-label>
                                                        <input type="text" placeholder="Variable" matInput
                                                          formControlName="variable" required>
                                                      </mat-form-field>
                                                      <mat-form-field class="mat-dropdown" appearance="outline">
                                                        <mat-label>Type</mat-label>
                                                        <mat-select placeholder="Type" formControlName="type"
                                                          (selectionChange)="envRAOChangeType($event,i,j)">
                                                          <mat-option *ngFor="let type of environmentType"
                                                            [value]="type.value">{{
                                                            type.viewValue }}</mat-option>
                                                        </mat-select>
                                                      </mat-form-field>
                                                      <mat-form-field appearance="outline">
                                                        <mat-label>Value</mat-label>
                                                        <input [type]="env.value.valueType"
                                                          [id]="'environmentValue-' + envIndex" placeholder="Value"
                                                          matInput formControlName="value">
                                                        <mat-icon *ngIf="env.value.type === 'password'" matSuffix
                                                          (click)="toggleRAOPassword(i,j,envIndex)">
                                                          {{ env.value.valueType == 'password' ?
                                                          'visibility_off' : 'visibility'
                                                          }}
                                                        </mat-icon>
                                                      </mat-form-field>

                                                      <div class="btn-view">
                                                        <mat-icon class="icon" (click)="addRAOEnvironmentsTab(i,j)">
                                                          add
                                                        </mat-icon>
                                                      </div>
                                                      <div class="btn-view">
                                                        <mat-icon class="icon" (click)="removeRAOEnvironmentsTab(i, j, envIndex)">
                                                          remove
                                                        </mat-icon>
                                                      </div>
                                                    </ng-container>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </ng-container>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="m-body" *ngIf="!showEnvironmentTabRAO">
                                  <div class="views-content-data-restApi">
                                    <div class="data-options">
                                      <mat-form-field class="data-options-dropdown" appearance="outline">
                                        <mat-select formControlName="bridge_target_endpoint_method">
                                          <mat-option *ngFor="let options of methodList" [value]="options" class="optionsList">
                                            {{ options.method }}
                                          </mat-option>
                                        </mat-select>
                                      </mat-form-field>
                                    </div>
                                    <div class="data-url">
                                      <mat-form-field class="data-url" appearance="outline" style="display: none;">
                                        <textarea rows="1" matInput placeholder="Request URL"
                                          formControlName="bridge_target_endpoint_url"
                                          (keydown.enter)="$event.preventDefault()" id="rest_api_url{{i}}"></textarea>
                                      </mat-form-field>
                                      <div class="contentDiv" id="contentDivOps{{i}}" placeholder="Request URL" contenteditable="true"
                          (keyup)="onKeyupOpsEPUrl($event,i)">{{endpoint_ops_url[i]}}</div>
                                    </div>
                                    <div class="data-btn" *ngIf="spinnerTargetRAOShow == false">
                                      <button mat-raised-button type="button" class="btn-test"
                                        *ngIf="spinnerTargetRAO == false"
                                        (click)="checkTokenSessionBeforeTestTargetRAO(fo,i)">Test</button>
                                    </div>

                                    <div class="data-btn" *ngIf="spinnerTargetRAOShow == true">
                                      <button mat-raised-button type="button" class="btn-test btn-cancel"
                                        (click)="cancelTargetRAOSpinner()">Cancel</button>
                                    </div>

                                    <div class="loader-container" style="padding: 12px"
                                      *ngIf="spinnerTargetRAO == true">
                                      <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                                    </div>

                                  </div>
                                  <mat-tab-group animationDuration="0ms"
                                    class="views-options-data-group-postman-restapi"
                                    (selectedTabChange)="postmanTabChangeROA($event,fo.value.id,i)">
                                    <mat-tab label="Params">
                                      <div class="mat-section-restAPI">
                                        <div class="m-body">
                                          <div class="data-options-wrapper">
                                            <div formArrayName="bridge_target_endpoint_params_raw">
                                              <div class="data-options-grid-ops"
                                                *ngFor="let params of bridgeTargetParamsRAO(i).controls;let j = index">
                                                <ng-container [formGroupName]="j">
                                                  <mat-form-field appearance="outline" style="display: none;">
                                                    <input type="text" formControlName="bridge_target_paramKey" matInput
                                                      placeholder="Key" (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  <div class="contentDivInputContParams">
                                                    <div class="contentParams" id="contentDiv_ops_params_key{{j}}" placeholder="Key" contenteditable="true"
                                                    (keyup)="onKeyupOpsParamsKey($event,j,i)">{{params_ops_key[i][j]}}</div>
                                                    </div>
                                                  <mat-form-field appearance="outline" style="display: none;">
                                                    <input type="text" formControlName="bridge_target_paramValue"
                                                      matInput placeholder="Value"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  <div class="contentDivInputContParams">
                                                    <div class="contentParams" id="contentDiv_ops_params_value{{j}}" placeholder="Value" contenteditable="true"
                                                    (keyup)="onKeyupOpsParamsValue($event,j,i)">{{params_ops_value[i][j]}}</div>
                                                    </div>
                                                  <mat-form-field appearance="outline">
                                                    <input type="text" formControlName="bridge_target_paramDescription"
                                                      matInput placeholder="Description"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  <div class="btn-view">
                                                    <mat-icon class="icon" (click)="addTargetParamsRAO(i)">
                                                      add
                                                    </mat-icon>
                                                  </div>
                                                  <div class="btn-view">
                                                    <mat-icon class="icon" (click)="removeTargetParamsRAO(i,j)">
                                                      remove
                                                    </mat-icon>
                                                  </div>
                                                </ng-container>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Authorization">
                                      <div class="mat-section-restAPI">
                                        <div class="m-body">
                                          <div class="authentication-view">
                                            <div class="view-options-drop">
                                              <mat-form-field class="mat-dropdown" appearance="outline">
                                                <mat-label>Select Type</mat-label>
                                                <mat-select formControlName="bridge_target_endpoint_authentication_type"
                                                  (selectionChange)="onChangeRestApiAuthenticationtype($event,i)">
                                                  <mat-option *ngFor="let type of authenticationTargetTypeOptions"
                                                    [value]="type">
                                                    {{ type.type }}
                                                  </mat-option>
                                                </mat-select>
                                              </mat-form-field>
                                            </div>

                                            <div class="view-body">
                                              <ng-container
                                                *ngIf="fo.value.bridge_target_endpoint_authentication_type.id == 3">
                                                <div class="view-options">
                                                  <mat-form-field appearance="outline">
                                                    <mat-label>Token</mat-label>
                                                    <input type="text" matInput placeholder="Token"
                                                      formControlName="bridge_target_authentication_token"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                </div>
                                              </ng-container>

                                              <ng-container
                                              *ngIf="fo.value.bridge_target_endpoint_authentication_type.id == 4">
                                              <div class="view-options">
                                                <mat-form-field appearance="outline" style="display: none;">
                                                  <mat-label>Username</mat-label>
                                                  <input [type]="targetusername ? 'password' : 'text'" matInput
                                                    placeholder="Username"
                                                    formControlName="bridge_target_authentication_username"
                                                    (keydown.enter)="$event.preventDefault()">
                                                  <mat-icon matSuffix
                                                    (click)="targetusername = !targetusername">{{targetusername ?
                                                    'visibility_off' : 'visibility'}}</mat-icon>
                                                </mat-form-field>
                                                <mat-label>Username *</mat-label>
                                                <div class="contAiner">
                                                  <div id="contentDevOpsAuthUser{{i}}" class="contentDevOpsAuth" placeholder="Username" contenteditable="true"
                                                    (keyup)="onKeyupOpsEPAuthUser($event,i)">{{ops_authUser[i]}}</div>
                                                  <mat-icon class="buttOn" matSuffix
                                                    (click)="toggleAuthPassword('contentDevOpsAuthUser'+i,'ops_user',i)">{{targetusername
                                                    ?
                                                    'visibility_off' : 'visibility'}}</mat-icon>
                                                </div>
                                              </div>
                                              <div class="view-options">
                                                <mat-form-field appearance="outline" style="display: none;">
                                                  <mat-label>Password</mat-label>
                                                  <input [type]="targetpassword ? 'password' : 'text'" matInput
                                                    placeholder="Password"
                                                    formControlName="bridge_target_authentication_password"
                                                    (keydown.enter)="$event.preventDefault()">
                                                  <mat-icon matSuffix
                                                    (click)="targetpassword = !targetpassword">{{targetpassword ?
                                                    'visibility_off' : 'visibility'}}</mat-icon>
                                                </mat-form-field>
                                                <mat-label>Password *</mat-label>
                                                    <div class="contAiner">
                                                      <div id="contentDevOpsAuthPassword{{i}}" class="contentDevOpsAuth" placeholder="Password" contenteditable="true"
                                                        (keyup)="onKeyupOpsEPAuthPassword($event,i)">{{ops_authPassword[i]}}</div>
                                                      <mat-icon class="buttOn" matSuffix
                                                        (click)="toggleAuthPassword('contentDevOpsAuthPassword'+i,'ops_password', i)">{{targetpassword
                                                        ?
                                                        'visibility_off' : 'visibility'}}</mat-icon>
                                                    </div>
                                              </div>
                                            </ng-container>
                                              <ng-container
                                                *ngIf="fo.value.bridge_target_endpoint_authentication_type.id == 6">
                                                <div class="view-options-drop">
                                                  <mat-form-field appearance="outline">
                                                    <mat-label>Refresh Token Endpoint Method</mat-label>
                                                    <mat-select
                                                      formControlName="bridge_target_oauth_refresh_token_endpoint_method">
                                                      <mat-option *ngFor="let options of methodList" [value]="options">
                                                        {{ options.method }}
                                                      </mat-option>
                                                    </mat-select>
                                                  </mat-form-field>
                                                </div>
                                                <div class="view-options">
                                                  <mat-form-field appearance="outline" style="display: none;">
                                                    <mat-label>Refresh Token Endpoint URL</mat-label>
                                                    <input type="text" matInput placeholder="Refresh Token Endpoint URL"
                                                      formControlName="bridge_target_oauth_refresh_token_endpoint_url"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  <div class="contentDivInputContParams" id="contentDevOpsAuthContainer{{i}}">
                                                    <div class="contentParams" id="contentDevOpsAuth{{i}}" placeholder="Refresh Token Endpoint URL*"
                                                    contenteditable="true" (click)="onKeyupOpsEPAuth($event,i)" (keyup)="onKeyupOpsEPAuth($event,i)">{{ops_auth[i]}}</div>
                                                    </div>
                                                </div>
                                                <div class="view-options-auth">
                                                  <mat-label>Refresh Token Endpoint Header</mat-label>
                                                  <ngx-codemirror class="codemirror-color"
                                                    formControlName="bridge_target_oauth_refresh_token_endpoint_header"
                                                    #refreshTokenHeaderScriptEditorROA
                                                    [options]="authorizationScriptEditorOptions">
                                                  </ngx-codemirror>
                                                </div>
                                                <div class="view-options-auth">
                                                  <mat-label>Refresh Token Endpoint Params</mat-label>
                                                  <ngx-codemirror class="codemirror-color"
                                                    formControlName="bridge_target_oauth_refresh_token_endpoint_params"
                                                    #refreshTokenParamScriptEditorROA
                                                    [options]="authorizationScriptEditorOptions">
                                                  </ngx-codemirror>
                                                </div>
                                                <div class="view-options-auth">
                                                  <mat-label>Refresh Token Endpoint Body</mat-label>
                                                  <ngx-codemirror class="codemirror-color"
                                                    formControlName="bridge_target_oauth_refresh_token_endpoint_body"
                                                    #refreshTokenBodyScriptEditorROA
                                                    [options]="authorizationScriptEditorOptions">
                                                  </ngx-codemirror>
                                                </div>
                                              </ng-container>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Headers">
                                      <div class="mat-section-restAPI">
                                        <div class="m-body">
                                          <div class="data-options-wrapper">
                                            <div formArrayName="bridge_target_endpoint_headers">
                                              <div class="data-options-grid-ops"
                                                *ngFor="let headers of bridgeTargetHeadersRAO(i).controls;let j = index">
                                                <ng-container [formGroupName]="j">
                                                  <mat-form-field appearance="outline" style="display: none;">
                                                    <input type="text" placeholder="Key"
                                                      formControlName="bridge_target_headerKey" matInput
                                                      placeholder="Key"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  <div class="contentDivInputContParams">
                                                    <div class="contentParams" id="contentDiv_ops_header_key{{j}}" placeholder="Key" contenteditable="true"
                                                    (keyup)="onKeyupOpsEPHeaderKey($event,j,i)">{{headers_ops_key[i][j]}}</div>
                                                    </div>
                                                  <mat-form-field appearance="outline" style="display: none;">
                                                    <input type="text" formControlName="bridge_target_headerValue"
                                                      matInput placeholder="Value"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>
                                                  <div class="contentDivInputContParams">
                                                    <div class="contentParams" id="contentDiv_ops_header_value{{j}}" placeholder="Value" contenteditable="true"
                                                    (keyup)="onKeyupOpsEPHeaderValue($event,j,i)">{{headers_ops_value[i][j]}}</div>
                                                    </div>

                                                  <mat-form-field appearance="outline" style="display: none;">
                                                    <input type="text" placeholder="value" matInput
                                                      formControlName="bridge_target_headerValue"
                                                      [matAutocomplete]="autoPOKV"
                                                      (keydown.enter)="$event.preventDefault()"
                                                      id="ib_update_target_endpoint_header_value{{i}}">
                                                    <mat-autocomplete #autoPOKV="matAutocomplete"
                                                      [displayWith]="displayFnAPIOperationHeaderValue">
                                                      <mat-option
                                                        *ngFor="let value of apiOperationHeaderValues$[j] | async"
                                                        [value]="value">
                                                        {{ value.header_value }}
                                                      </mat-option>
                                                    </mat-autocomplete>
                                                  </mat-form-field>

                                                  <mat-form-field appearance="outline">
                                                    <input type="text" formControlName="bridge_target_headerDescription"
                                                      matInput placeholder="Description"
                                                      (keydown.enter)="$event.preventDefault()">
                                                  </mat-form-field>

                                                  <div class="btn-view">
                                                    <mat-icon class="icon" (click)="addTargetHeadersRAO(i)">
                                                      add
                                                    </mat-icon>
                                                  </div>
                                                  <div class="btn-view">
                                                    <mat-icon class="icon" (click)="removeTargetHeaderRestApi(i,j)">
                                                      remove
                                                    </mat-icon>
                                                  </div>
                                                </ng-container>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Body">
                                      <div class="mat-section-restAPI">
                                        <div style="width: 25%;">
                                          <mat-form-field class="mat-dropdown" appearance="outline">
                                            <mat-label>Select Type</mat-label>
                                            <mat-select formControlName="bridge_target_body_type">
                                              <mat-option *ngFor="let type of bodyTypeOptions" [value]="type.type">
                                                {{ type.type }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                        </div>
                                        <div class="m-body">
                                          <ngx-codemirror formControlName="bridge_target_endpoint_body_raw"
                                            #bodyRestAPIEditor [options]="codeMirrorEditorOptions">
                                          </ngx-codemirror>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Pre-request Script">
                                      <div class="mat-section-restAPI">
                                        <div class="m-body-script">
                                          <ngx-codemirror class="codemirror-color" formControlName="pre_request_script"
                                            #preRequestScriptEditorROA [options]="preRequestScriptEditorOptions">
                                          </ngx-codemirror>
                                        </div>
                                      </div>
                                    </mat-tab>
                                    
                                  </mat-tab-group>

                                  <div class="res-container">
                                    <div class="res-header">
                                      <h3 style="margin:0">Response Params</h3>
                                      <span class="res-header">
                                        <mat-radio-group formControlName="response_type">
                                          <mat-radio-button value="text">Text</mat-radio-button>
                                          <mat-radio-button value="content">Content</mat-radio-button>
                                          <mat-radio-button value="json">JSON</mat-radio-button>
                                        </mat-radio-group>
                                      </span>
                                    </div>


                                  <mat-tab-group class="views-options-data-group-email" fitInkBarToContent
                                    mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
                                    <mat-tab id="tab-response" class="res-container" label="Response">
                                      <div class="res-header">
                                        <span class="res-header">Response</span>
                                        <span *ngIf="bridgeTargetResponse?.bizdata_dataset">
                                          <span class="res-status" *ngIf="fo.value.bizdata_dataset_status"
                                            style="float: right;">Status:
                                            <strong>{{fo.value.bizdata_dataset_status}}</strong></span>
                                        </span>
                                      </div>
                                      <div class="res-body">
                                        <div class="error-block" *ngIf="bridgeTargetResponse?.error == 2; else tr">
                                          <h5>Could not send request</h5>
                                          <span>Error: {{bridgeTargetResponse.message}}</span>
                                        </div>
                                        <ng-template #tr>
                                          <div style=" position: relative;">
                                          <json-editor formControlName="bridge_target_response"
                                            [options]="editorTargetOptions">
                                          </json-editor>
                                          <mat-icon style="cursor: pointer;  position: absolute; top: 5px; right: 5px;"
                                          (click)="copyResponse(fo.value.bridge_target_response)">
                                          content_copy
                                        </mat-icon>
                                        </div>
                                        </ng-template>
                                      </div>
                                    </mat-tab>
                                    <mat-tab label="Preview Request">
                                      <div style="margin-top: 20px" id="postman-preview">
                                        <mat-card class="preview-card">
                                          <mat-card-title class="preview-title">
                                            <div class="res-header">
                                              <span class="res-header preview-header">Preview Request</span>
                                              <span class="res-status">
                                                <mat-icon style="cursor: pointer;"
                                                  (click)="copyResponse(copyPreviewData)">
                                                  content_copy
                                                </mat-icon>
                                              </span>
                                            </div>
                                          </mat-card-title>
                                          <mat-card-content class="preview-body">
                                            <p>Method : {{fo.value.preview_postman_data[4]?.requestMethod}}</p>
                                            <p>Request URL : <span
                                                style="color: rgb(62, 62, 250);">{{fo.value.preview_postman_data[4]?.requestUrl}}</span>
                                            </p>
                                            <div *ngFor="let item of fo.value.preview_postman_data;let index = index">
                                              <ng-container *ngIf="index<4">
                                                <div class="column-content" (click)="showSubItem(index)">
                                                  <mat-icon *ngIf="visibleIndex !== index"
                                                    matSuffix>arrow_forward</mat-icon>
                                                  <mat-icon *ngIf="visibleIndex === index"
                                                    matSuffix>arrow_downward</mat-icon>
                                                  <p>
                                                    {{item.name}}
                                                  </p>
                                                </div>
                                                <div *ngIf="visibleIndex === index" class="preview-subheader"
                                                  style="margin-left:35px;">
                                                  <span *ngFor="let subItem of item.subItems" let index=index>
                                                    <span *ngIf="item?.name == 'Request Header'">
                                                      <p>{{subItem.headerKey}} : <span
                                                          style="color: rgb(62, 62, 250);">{{subItem.headerValue}}</span>
                                                      </p>
                                                    </span>
                                                    <span *ngIf="item?.name == 'Request Params'">
                                                      <p>{{subItem.paramKey}} : <span
                                                          style="color: rgb(62, 62, 250);">{{subItem.paramValue}}</span>
                                                      </p>
                                                    </span>
                                                    <span *ngIf="item?.name == 'Request Body'">
                                                      <div class="preview-script-border">
                                                        <ngx-codemirror [(ngModel)]="subItem.requestBody"
                                                          [ngModelOptions]="{standalone: true}"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          #previewPostmanEditor
                                                          [options]="previewPostmanCodeMirrorEditor">
                                                        </ngx-codemirror>
                                                      </div>
                                                    </span>
                                                    <span *ngIf="item?.name == 'Pre Request Script'">
                                                      <div class="preview-script-border">
                                                        <ngx-codemirror [(ngModel)]="subItem.preRequestScript"
                                                          [ngModelOptions]="{standalone: true}"
                                                          (keydown.enter)="$event.preventDefault()"
                                                          #previewPostmanEditor
                                                          [options]="previewPostmanCodeMirrorEditor">
                                                        </ngx-codemirror>
                                                      </div>
                                                    </span>
                                                  </span>
                                                </div>
                                              </ng-container>
                                            </div>
                                          </mat-card-content>
                                        </mat-card>
                                      </div>
                                    </mat-tab>
                                  </mat-tab-group>
                                </div>
                                </div>
                              </mat-card> -->
                            </mat-tab>
                          </mat-tab-group>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dlakeingestion_fb" *ngIf="isDLIngestionFormEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/fs8L8zlPa-c?si=-kGfA7VgrZi9-Gpd" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="dlIngestionRows">
                  <div class="ops-form" *ngFor="let fo of dlIngestionRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Bizintel360 DataLake Ingestion</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dlakeingestion_obj">
                          <div class="column-operation" *ngIf="(operation != 'refresh_type' && operation != 'request_timeout_sec')">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'ca_certs_path'">
                                <p>
                                  Select the Data Lake Version from the dropdown
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'index_name'">
                                <p>
                                  Provide the Index / Table Name for sending your data
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">table_name</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dlIngestionRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'fields'">
                                <p>
                                  By default it will be empty, If user wants to specify fieldnames they can specify.
                                  <br>
                                  Comma separated list of keys in double quotes
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"Customer
                                    Site","Organization"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dlIngestionRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'action_type'">
                                <p>
                                  Select the Action Type from the dropdown
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'primary_key'">
                                <p *ngIf="(fo.value.action_type == 'upsert' || fo.value.action_type == 'update' || fo.value.action_type == 'delete')">
                                  Pass the Primary Key which you want to make for the Index / Table Name provided
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">id</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dlIngestionRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'indexing_type'">
                                <p>
                                  Select the Ingestion Type from the dropdown
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0">
                                    here</a>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field class="target-businessObj" appearance="fill"
                            *ngIf="operation == 'ca_certs_path'">
                            <mat-label>Data Lake Version</mat-label>
                            <mat-select formControlName="version" (selectionChange)="onChangeGetDlversion($event,i)">
                              <mat-option *ngIf="verisonListDLO.length == 0">
                                No record found
                              </mat-option>
                              <mat-option *ngFor="let version of verisonListDLO" [value]="version">
                                {{ version.dlversion }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;"
                            *ngIf="operation == 'index_name'">
                            <div>
                              <p style="margin-top:25px">
                                <span style="background: #ddd;">bizintel360-</span>
                              </p>
                            </div>
                            <div>
                              <mat-form-field appearance="outline" class="input-suffix">
                                <mat-label class="bold-label">Index / Table Name</mat-label>
                                <input type="text" matInput formControlName="index_name" [matAutocomplete]="autoDlIngestion" id="copy1_{{i}}_index_name"
                                  (keydown)="bridgenameCheck($event)" required>
                                  <mat-autocomplete #autoDlIngestion="matAutocomplete" [displayWith]="displayIndexName">
                                    <mat-option *ngFor="let option of filteredDlIngestionOptions|async" [value]="option">
                                      {{ option }}
                                    </mat-option>
                                </mat-autocomplete> 
                                <mat-icon (click)="copyInputMessage('index_name',i)" matSuffix>content_copy</mat-icon>
                              </mat-form-field>
                            </div>
                          </div>
                          <mat-form-field class="target-businessObj" appearance="fill"
                            *ngIf="operation == 'action_type'">
                            <mat-label>Action Type</mat-label>
                            <mat-select formControlName="action_type">
                              <mat-option *ngFor="let type of actionTypeListDLO" [value]="type.actionTypevalue">
                                {{ type.actionTypeTitle }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="input-suffix"
                            *ngIf="(fo.value.action_type == 'upsert' || fo.value.action_type == 'update' || fo.value.action_type == 'delete') && operation == 'primary_key'">
                            <mat-label class="bold-label">Primary Key</mat-label>
                            <input type="text" matInput formControlName="primary_key" id="copy1_{{i}}_primary_key"
                              (keydown.enter)="$event.preventDefault()">
                            <mat-icon (click)="copyInputMessage('index_name',i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field class="target-businessObj" appearance="fill"
                            *ngIf="operation == 'indexing_type'">
                            <mat-label>Ingestion Type</mat-label>
                            <mat-select formControlName="indexing_type">
                              <mat-option *ngFor="let type of indexingTypeListDLO" [value]="type.indexTypevalue">
                                {{ type.indexTypeTitle }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dlsearch_fb" *ngIf="isDlsearchFormEnabled">
                <div formArrayName="dlsearchRows">
                  <div class="ops-form" *ngFor="let fo of dlsearchRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Bizintel360 DataLake Search</label>
                        <div class="ops-form-body">
                          <mat-card class="m-card data-source">
                            <div class="m-body">
                              <mat-form-field class="target-businessObj" appearance="fill">
                                <mat-label>Data Lake Version</mat-label>
                                <mat-select formControlName="version"
                                  (selectionChange)="onChangeGetDlversionDLS($event,i)">
                                  <mat-option *ngFor="let version of verisonListDLS" [value]="version">
                                    {{ version.dlversion }}
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                              <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;">
                                <div>
                                  <p style="margin-top:25px">
                                    <span style="background: #ddd;">bizintel360-</span>
                                  </p>
                                </div>
                                <div>
                                  <mat-form-field appearance="outline" class="input-suffix">
                                    <mat-label class="bold-label">Index / Table Name</mat-label>
                                    <input type="text" matInput formControlName="dlsearch_index_name"
                                      id="copy1_{{i}}_dlsearch_index_name" [matAutocomplete]="autoDL" (keydown)="bridgenameCheck($event)"
                                      (keydown.enter)="$event.preventDefault()" required>
                                      <mat-autocomplete #autoDL="matAutocomplete" [displayWith]="displayIndexName">
                                        <!-- <ng-container *ngIf="helperService.indexNames|async as indexName"> -->
                                          <mat-option *ngFor="let option of filteredDlSearchOptions|async" [value]="option">
                                            {{ option }}
                                          </mat-option>
                                        <!-- </ng-container> -->
                                      </mat-autocomplete>
                                    <mat-icon (click)="copyInputMessage('dlsearch_index_name',i)"
                                      matSuffix>content_copy</mat-icon>
                                  </mat-form-field>
                                </div>
                              </div>
                              <div style="display: grid;grid-template-columns: 50%;grid-column-gap: 2px;">
                                <mat-form-field appearance="outline" class="input-suffix">
                                  <mat-label class="bold-label">Pagination Wait Time</mat-label>
                                  <input type="text" matInput formControlName="dlsearch_scroll"
                                    id="copy1_{{i}}_dlsearch_scroll" (keydown.enter)="$event.preventDefault()">
                                  <mat-icon (click)="copyInputMessage('dlsearch_scroll',i)"
                                    matSuffix>content_copy</mat-icon>
                                </mat-form-field>
                              </div>
                              <div style="display: grid;grid-template-columns: 50%;grid-column-gap: 2px;">
                                <mat-form-field appearance="outline" class="input-suffix">
                                  <mat-label class="bold-label">Timeout</mat-label>
                                  <input type="text" matInput formControlName="dlsearch_timeout"
                                    id="copy1_{{i}}_dlsearch_timeout" (keydown.enter)="$event.preventDefault()">
                                  <mat-icon (click)="copyInputMessage('dlsearch_timeout',i)"
                                    matSuffix>content_copy</mat-icon>
                                </mat-form-field>
                              </div>
                              <div style="display: grid;grid-template-columns: 50%;grid-column-gap: 2px;">
                                <mat-form-field appearance="outline" class="input-suffix">
                                  <mat-label class="bold-label">Size</mat-label>
                                  <input type="text" matInput formControlName="dlsearch_batch_size"
                                    id="copy1_{{i}}_dlsearch_batch_size" (keydown.enter)="$event.preventDefault()">
                                  <mat-icon (click)="copyInputMessage('dlsearch_batch_size',i)"
                                    matSuffix>content_copy</mat-icon>
                                </mat-form-field>
                              </div>
                              <div class="data-btn-lake">
                                <div class="data-btn" *ngIf="spinnerSearchDatalakeShow == false">
                                  <button mat-raised-button type="button" id="ib_create_search_dl_test_btn" class="btn-test-2 executeDL"
                                    *ngIf="spinnerSearchDatalake == false"
                                    (click)="checkTokenSessionBeforeTestDataLakeSearch()">Execute</button>
                                </div>
        
                                <div class="data-btn" *ngIf="spinnerSearchDatalakeShow == true">
                                  <button mat-raised-button type="button" id="ib_create_search_dl_test_btn"
                                    class="btn-test-2 executeDL" (click)="cancelSearchDatalakeSpinner()">Cancel</button>
                                </div>
        
                                <div class="loader-container" style="padding: 4px 18px" *ngIf="spinnerSearchDatalake == true">
                                  <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                                </div>
                              </div>
                              <div class="mat-section" style="padding: 0;">
                                <mat-card class="mat-section" style="border:1px groove;border-radius: 5px;">
                                  <p style="margin-left: 10px;">Query</p>
                                  <div class="m-body-script">
                                    <ngx-codemirror formControlName="dlsearch_body" #dlSearchEditor
                                      [options]="codeMirrorEditorOptions" (keydown.enter)="$event.preventDefault()">
                                    </ngx-codemirror>
                                  </div>
          
                                </mat-card>
                                <div class="res-container">
                                  <div class="res-header">
                                    <span class="res-header">Response</span>
                                    <span *ngIf="bridgeResponse?.bizdata_dataset">
                                      <span class="res-status"
                                        *ngIf="bridgeResponse?.bizdata_dataset.bizdata_dataset_status">Status:
                                        <strong>{{bridgeResponse?.bizdata_dataset.bizdata_dataset_status}}</strong></span>
                                        <mat-icon style="cursor: pointer; float:right"
                                        (click)="copyResponse(dlsearchRows().controls[0].get('dlsearch_body_response').value)">
                                        content_copy
                                      </mat-icon>
                                    </span>
                                    <span *ngIf="!bridgeResponse?.bizdata_dataset">
                                      <span class="res-status" *ngIf="bridgeResponse?.bizdata_dataset_status">Status:
                                        <strong>{{bridgeResponse?.bizdata_dataset_status}}</strong></span>
                                        <mat-icon style="cursor: pointer; float:right"
                                        (click)="copyResponse(dlsearchRows().controls[0].get('dlsearch_body_response').value)">
                                        content_copy
                                      </mat-icon>
                                    </span>
                                  </div>
                                  <div class="res-body">
                                    <div class="error-block" *ngIf="bridgeResponse?.error == 2; else sr">
                                      <h5>Could not send request</h5>
                                      <span>Error: {{bridgeResponse.message}}</span>
                                    </div>
                                    <ng-template #sr>
                                      <json-editor formControlName="dlsearch_body_response" id="ib_create_search_dl_response"
                                        [options]="editorSourceOptions">
                                      </json-editor>
                                    </ng-template>
                                  </div>
                                </div>
                              </div>
                              <!-- <div class="mat-section" style="padding: 0;">
                                <div class="m-body-script" style="border:1px groove;border-radius: 5px;">
                                  <ngx-monaco-editor formControlName="dlsearch_body" [options]="editorTargetOptions2"
                                    (init)="editorInit($event)">
                                  </ngx-monaco-editor>
                                  <ngx-codemirror formControlName="dlsearch_body" #dlSearchEditor
                                    [options]="codeMirrorEditorOptions">
                                  </ngx-codemirror>

                                </div>
                              </div> -->
                            </div>
                          </mat-card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_json_fb" *ngIf="isjsonFormEnabled">
                <div formArrayName="jsonRows">
                  <div class="ops-form" *ngFor="let fo of jsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_json_obj">
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dropeventsstartswith_fb" *ngIf="isdropeventsstartswithFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/hDofXZ92FKs?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="dropeventsstartswithRows">
                  <div class="ops-form" *ngFor="let fo of dropeventsstartswithRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Drop all events to start with</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dropeventsstartswith_obj">
                          <div class="column-operation">
                            <p>
                              Give value which one needs to drop starting with this string
                              <br>
                              Comma separated keys in double quotes
                              <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"https"</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-cleaning#bkmrk-drop-all-events-to-s">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.dropeventsstartswithRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ")| titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dropalleventvalues_fb" *ngIf="isdropalleventvaluesFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/lnsmSF5KJ4c?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="dropalleventvaluesRows">
                  <div class="ops-form" *ngFor="let fo of dropalleventvaluesRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Drop all events for value</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dropalleventvalues_obj">
                          <div class="column-operation">
                            <p>
                              For this particular value all event will be dropped
                              <br>
                              Comma separated keys in double quotes
                              <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"Rachel"</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-cleaning#bkmrk-drop-all-event-for-v">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.dropalleventvaluesRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_eliminate_fb" *ngIf="iseliminateFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/Cy9Y0Q12b9Q?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="eliminateRows">
                  <div class="ops-form" *ngFor="let fo of eliminateRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Eliminate</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_eliminate_obj">
                          <div class="column-operation">
                            <p>
                              Pass the keyname which you want to eliminate.
                              <br>
                              Comma separated keys in double quotes
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"bizdata_dataset_status","bizdata_dataset_response_time","today","yesterday","bizdata_dataset_request_data","bizdata_dataset_headers"</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-cleaning#bkmrk-eliminate">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.eliminateRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_calculater_fb" *ngIf="iscalculaterFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/6cTA6tMHSjg?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="calculaterRows">
                  <div class="ops-form" *ngFor="let fo of calculaterRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Calculator</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_calculater_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'calculation_keys'">
                                <p>
                                  Calculation_keys holds the calculated formula based on the column names of the
                                  provided data.
                                  <br>
                                  Comma separated list of keys with calculating formula in double quotes
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"PRIMARYKEY*LINE","QUANTITY-LINE"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-calculator">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.calculaterRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'new_calculation_keys'">
                                <p>
                                  Keys in which we the calculated values are getting stored.
                                  <br>
                                  Keyname for storing values
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"Calculation1","Calculation2"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-calculator">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.calculaterRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_dateanalytics_fb" *ngIf="isdateanalyticsFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/ZgviFUFXFsM?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="dateanalyticsRows">
                  <div class="ops-form" *ngFor="let fo of dateanalyticsRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Date Analytics</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_dateanalytics_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'date_field_key'">
                                <p>
                                  Keyname which hold the value of the date.
                                  <br>
                                  Enter the keyname
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">createdDateTime</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-date-analytics">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dateanalyticsRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'fiscal_month_start'">
                                <p>
                                  Fiscal month of the company, range should be 1-12
                                  <br>
                                  Enter the value
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">4</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-date-analytics">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dateanalyticsRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'date_column'">
                                <p>
                                  New date column key name for saving data By default it will be empty
                                  <br>
                                  Comma separated list of keys in double quotes
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"Created
                                    Month","Created Month Num"</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-date-analytics">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dateanalyticsRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'weekday'">
                                <p>
                                  Weekday is used to specify the starting of the week.
                                  <br>
                                  Pass the value
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">%W</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-date-analytics">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.dateanalyticsRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <ng-container [ngSwitch]="operation">
                          <mat-form-field appearance="outline" class="textarea-suffix" *ngSwitchCase="'date_column'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>

                          <mat-form-field appearance="outline" class="input-suffix" *ngSwitchDefault>
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                               (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>

                          <mat-form-field appearance="outline" class="input-suffix" *ngSwitchCase="'fiscal_month_start'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              (keydown)="validateDateAnalytics($event)" (keydown.enter)="$event.preventDefault()"
                              required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_arraycount_fb" *ngIf="isArraycountFromEnabled"
                style="margin-bottom: 120px;">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/ExMooh722qw?si=ZIg49-w-vl2e-slB" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="arraycountRows">
                  <div class="ops-form" *ngFor="let fo of arraycountRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Array Count</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_arraycount_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'array_key_name'">
                                <p>
                                  Gives the length of data of the keyname with array as its value.
                                  <br>
                                  Pass the keyname like this
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">['bizdata_dataset_response']['items']</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-array-countdescripti">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.arraycountRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_pdfextractor_fb" *ngIf="isPdfextractorFormEnabled"
                style="margin-bottom: 120px;">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/hG1tBejDLZI?si=AnTICXI5uNR8d41s" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="pdfextractorRows">
                  <div class="ops-form" *ngFor="let fo of pdfextractorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - PDF Extractor</label>
                        <div class="ops-form-body">
                          <div>
                            <p style="float: left;margin-top: 15px;">PDF Location -</p>
                            <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                              [value]="pdfextractorRows().controls[i].value.pdfLocationToggle"
                              (change)="onChangeToggleButton($event,i)">
                              <mat-button-toggle value="file_url">File URL Key</mat-button-toggle>
                              <mat-button-toggle value="base64_key">Base64 Key</mat-button-toggle>
                            </mat-button-toggle-group>
                          </div>

                          <div style="display:-webkit-inline-box;"
                            *ngIf="pdfextractorRows().controls[i].value.pdfLocationToggle == 'file_url'">
                            <p>
                              Pass key name which is having file url. In case of base64 data this will be empty.
                              <br>
                              Pass the keyname like this
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_file_url">@microsoft.graph.downloadUrl</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-pdf-extractor">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage('file_url', i, this.pdfextractorRows())">swap_vert</mat-icon>
                            </p>
                          </div>

                          <mat-form-field appearance="outline" class="input-suffix"
                            *ngIf="pdfextractorRows().controls[i].value.pdfLocationToggle == 'file_url'">
                            <mat-label class="bold-label">File URL Key</mat-label>
                            <input matInput cols="100" rows="8" formControlName="file_url" id="copy1_{{i}}_file_url"
                              (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage('file_url',i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>

                          <div style="display: -webkit-inline-box;"
                            *ngIf="pdfextractorRows().controls[i].value.pdfLocationToggle == 'base64_key'">
                            <p>
                              Pass key name which is having base64 encoded data. In case of file_url this will be empty.
                              <br>
                              Pass the keyname like this
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_base64_key">base64_encoded_text</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-pdf-extractor">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage('base64_key', i, this.pdfextractorRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix"
                            *ngIf="pdfextractorRows().controls[i].value.pdfLocationToggle == 'base64_key'">
                            <mat-label class="bold-label">Base64 Key</mat-label>
                            <input matInput cols="100" rows="8" formControlName="base64_key" id="copy1_{{i}}_base64_key"
                              (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage('base64_key',i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_fileextractor_fb" *ngIf="isFileextractorFormEnabled"
                style="margin-bottom: 200px;">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <!-- <iframe src="https://www.youtube.com/embed/hG1tBejDLZI?si=AnTICXI5uNR8d41s" frameborder="0"
                    allowfullscreen></iframe> -->
                  </div>
                </mat-card-content>
                <div formArrayName="fileextractorRows">
                  <div class="ops-form" *ngFor="let fo of fileextractorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - File Extractor</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_fileextractor_obj">
                          <div class="column-operation">
                            <p>
                              Pass key name which is having base64 encoded data of file .
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()">
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_grokpattern_fb" *ngIf="isGorkPatternFormEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/Yj2u56nRK0o?si=n-UnGCOpuGVU5zVe" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="grokpatternRows">
                  <div class="ops-form" *ngFor="let fo of grokpatternRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Grok Pattern</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_grokpattern_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'input_key'">
                                <p>
                                  Extract Data From given key name.&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-grok-pattern">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'grok_pattern'">
                                <p>
                                  Extract Data based on given pattern.&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-grok-pattern">
                                    here</a>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_rawsentencegenerator_fb" *ngIf="isRawSentenceGeneratorFormEnabled">
                <!-- <mat-card-content class="m-body-append-video">
                                    <div class="about-views-video">
                                      <iframe src="https://www.youtube.com/embed/Yj2u56nRK0o?si=n-UnGCOpuGVU5zVe" frameborder="0"
                                        allowfullscreen></iframe>
                                    </div>
                                  </mat-card-content> -->
                <div formArrayName="rawsentencegeneratorRows">
                  <div class="ops-form" *ngFor="let fo of rawsentencegeneratorRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Raw Sentence Generator</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_rawsentencegenerator_obj;">
                          <!-- <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'include_keys'">
                                <p>
                                  Provide kye name to form a raw sentence else keep blank to include all keys in raw
                                  sentence generation.&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-grok-pattern">
                                    here</a>
                                </p>
                              </div>
                              <div *ngSwitchCase="'raw_response_key'">
                                <p>
                                  Provide the keyname which will store the Generated Sentence Response.&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-grok-pattern">
                                    here</a>
                                </p>
                              </div>
                            </div>
                          </div> -->
                        <ng-container  *ngIf="operation == 'include_keys'">
                          <p>
                            Provide keyname to form a raw sentence else keep blank to include all keys in raw sentence generation. For Example
                              <span id="copy_{{i}}_{{operation}}" style="background-color: #ddd;">"Name","Commands"</span>
                              <span style="font-style: italic;"> Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-parameter-%3A-include-">
                                here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.rawsentencegeneratorRows())">swap_vert</mat-icon>
                          </p>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                           >
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </ng-container>
                        <ng-container  *ngIf="operation == 'raw_response_key'">
                          <p>
                            Provide the keyname which will store the Generated Sentence Response. For Example: 
                              <span id="copy_{{i}}_{{operation}}" style="background-color: #ddd;">Response</span>
                              <span style="font-style: italic;"> Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-parameter%3A-raw-respo">
                                here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.rawsentencegeneratorRows())">swap_vert</mat-icon>
                          </p>
                            <mat-form-field appearance="outline" class="input-suffix"
                             >
                              <mat-label class="bold-label">Raw Response Key</mat-label>
                              <input matInput [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                                (keydown.enter)="$event.preventDefault()" required>
                              <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                            </mat-form-field>
                        </ng-container>
                        <ng-container  *ngIf="operation == 'singleline_key'">
                          <p>
                            Provide keyname which holds the Singleline Data whose Raw Sentence we want to create. For Example:
                              <span id="copy_{{i}}_{{operation}}" style="background-color: #ddd;">data</span>
                              <span style="font-style: italic;"> Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-number-of-parameters-20">
                                here</a>
                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.rawsentencegeneratorRows())">swap_vert</mat-icon>
                          </p>
                            <mat-form-field appearance="outline" class="input-suffix"
                             >
                              <mat-label class="bold-label">Singleline Key</mat-label>
                              <input matInput [formControlName]="operation" (keydown.enter)="$event.preventDefault()"
                                id="copy1_{{i}}_{{operation}}">
                              <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                            </mat-form-field>
                        </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_timeunits_fb" *ngIf="isTimeUnitsFormEnabled">
                <!-- <mat-card-content class="m-body-append-video">
                                                  <div class="about-views-video">
                                                    <iframe src="https://www.youtube.com/embed/Yj2u56nRK0o?si=n-UnGCOpuGVU5zVe" frameborder="0"
                                                      allowfullscreen></iframe>
                                                  </div>
                                                </mat-card-content> -->
                <div formArrayName="timeunitsRows">
                  <div class="ops-form" *ngFor="let fo of timeunitsRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Time Units</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_timeunits_obj;">
                          <!-- <div class="column-operation">
                                                            <div [ngSwitch]="operation">
                                                              <div *ngSwitchCase="'timestamp_column'">
                                                                <p>
                                                                  Provide kye name to form a raw sentence else keep blank to include all keys in raw
                                                                  sentence generation.&nbsp;
                                                                  <span style="font-style: italic;">Refer</span>
                                                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-grok-pattern">
                                                                    here</a>
                                                                </p>
                                                              </div>
                                                              <div *ngSwitchCase="'timestamp_key'">
                                                                <p>
                                                                  Provide the keyname which will store the Generated Sentence Response.&nbsp;
                                                                  <span style="font-style: italic;">Refer</span>
                                                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-grok-pattern">
                                                                    here</a>
                                                                </p>
                                                              </div>
                                                            </div>
                                                          </div> -->
                                                          <ng-container  *ngIf="operation == 'timestamp_key'">
                                                            <p>
                                                              Key Name which holds the timestamp value.Enter the key 
                                                                <span id="copy_{{i}}_{{operation}}" style="background-color: #ddd;">timestamp</span>
                                                                <span style="font-style: italic;"> Refer</span>
                                                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-number-of-parameters-21">
                                                                  here</a>
                                                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                                                  (click)="copyDescMessage(operation, i, this.timeunitsRows())">swap_vert</mat-icon>
                                                            </p>                                 
                            <mat-form-field appearance="outline" class="input-suffix"
                             >
                              <mat-label class="bold-label">Date Timestamp Key</mat-label>
                              <input matInput [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                                (keydown.enter)="$event.preventDefault()">
                              <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                            </mat-form-field>
                                                          </ng-container>

                                                         <ng-container *ngIf="operation == 'timestamp_column'">
                                                          <p>
                                                            New Timestamp column key name for saving data(can be empty)Comma separated list of keys in double quotes
                                                              <span id="copy_{{i}}_{{operation}}" style="background-color: #ddd;">"year", "month", "day", "hour", "minute", "second", "microsecond"</span>
                                                              <span style="font-style: italic;"> Refer</span>
                                                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                                                href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-parameter%3A-time-unit">
                                                                here</a>
                                                                <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                                                (click)="copyDescMessage(operation, i, this.timeunitsRows())">swap_vert</mat-icon>
                                                          </p>                                
                          <mat-form-field appearance="outline" class="textarea-suffix"
>
                            <mat-label class="bold-label">Time Units</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                                                         </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_datachunking_fb" *ngIf="isDataChunkingFormEnabled">
                <div formArrayName="datachunkingRows">
                  <div class="ops-form" *ngFor="let fo of datachunkingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Data Chunking</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_datachunking_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'process_key'">
                                <p>
                                  Provide the keyname which hold's the data for which we need to create the chunks.<br>
                                  For Example: <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">['processed_text']</span>&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/link/94#bkmrk-description%3Athe-data">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.datachunkingRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'chunk_key'">
                                <p>
                                  Provide the keyname which will hold the chunked data.<br>
                                  For example: <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">chunked_data</span>.&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/link/94#bkmrk-parameter%3A-chunk-key">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.datachunkingRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'token_size'">
                                <p>
                                  Provide the size of your chunk. For Example: <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">1000</span>.&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/link/94#bkmrk-parameter%3A-token-siz">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.datachunkingRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'group_by_chunk'">
                                <p>
                                  Provide the keyname which will hold all the chunks which are made from the data.<br>
                                  For Example: <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">bizdata_dataset_chunks</span>.&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/link/94#bkmrk-parameter%3A-group-by-">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.datachunkingRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" *ngIf="operation != 'token_size'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput [formControlName]="operation" (keydown.enter)="$event.preventDefault()"
                              id="copy1_{{i}}_{{operation}}" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" *ngIf="operation == 'token_size'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput type="number" min="1" [formControlName]="operation"
                              (change)="dataChunkChange(i, $event)" (keydown.enter)="$event.preventDefault()"
                              id="copy1_{{i}}_{{operation}}" required>
                            <!-- <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon> -->
                          </mat-form-field>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>



              <form [formGroup]="bizdata_ops_jason2avro_fb" *ngIf="isJson2avroFormEnabled">
                <div formArrayName="jason2avroRows">
                  <div class="ops-form" *ngFor="let fo of jason2avroRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - JSON to AVRO</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_json2avro_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'jsondata_key'">
                                <p>
                                  Provide the keyname ,converts given key's value from JSON to AVRO.<br>
                                  Example:Enter key name <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">bizdata_dataset_response</span>&nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.jason2avroRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'avro_schema'">
                                <p>
                                  Provide the schema which will be in the structure of the JSON data which we are trying
                                  to convert into AVRO format.<br>
                                  Example:Enter AVRO Schema <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"schema_key":{{'{"key":"value"}'}}</span>.&nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.jason2avroRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'response_key'">
                                <p>
                                  Provide the keyname it will collect the converted AVRO value in the given keyname <br>
                                  For Example:Enter key name <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">avro_data_key</span>..&nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.jason2avroRows())">swap_vert</mat-icon>
                                </p>
                              </div>

                            </div>
                          </div>
                          <mat-form-field appearance="outline" *ngIf="operation == 'jsondata_key'" class="input-suffix">
                            <mat-label class="bold-label">JSON Data Key</mat-label>
                            <input matInput type="text" [formControlName]="operation"
                              (keydown.enter)="$event.preventDefault()" required id="copy1_{{i}}_{{operation}}">
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" *ngIf="operation == 'avro_schema'"
                            class="textarea-suffix">
                            <mat-label class="bold-label">AVRO Schema</mat-label>
                            <textarea cols="100" rows="8" matInput [formControlName]="operation"  class="txtAlign"
                              (keydown.enter)="$event.preventDefault()" required id="copy1_{{i}}_{{operation}}">
                            </textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" *ngIf="operation == 'response_key'" class="input-suffix">
                            <mat-label class="bold-label">AVRO Data Key</mat-label>
                            <input matInput type="text" [formControlName]="operation"
                              (keydown.enter)="$event.preventDefault()" required id="copy1_{{i}}_{{operation}}">
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_avro2json_fb" *ngIf="isAvro2jsonFormEnabled">
                <div formArrayName="avro2jsonRows">
                  <div class="ops-form" *ngFor="let fo of avro2jsonRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - AVRO to JSON</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_avro2json_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'avro_data'">
                                <p>
                                  Provide the keyname ,converts given key's value from AVRO to JSON.<br>
                                  Example:Enter key name <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">avro_data_key</span>&nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.avro2jsonRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'json_data_key'">
                                <p>
                                  Provide the keyname it will collect the converted JSON value in the given keyname.<br>
                                  Example:Enter key name <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">my_data_response</span>.&nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.avro2jsonRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" *ngIf="operation == 'avro_data'" class="input-suffix">
                            <mat-label class="bold-label">AVRO Data Key</mat-label>
                            <input cols="100" rows="8" matInput [formControlName]="operation"
                              (keydown.enter)="$event.preventDefault()" required id="copy1_{{i}}_{{operation}}">

                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" *ngIf="operation == 'json_data_key'"
                            class="input-suffix">
                            <mat-label class="bold-label">JSON Data Key</mat-label>
                            <input cols="100" rows="8" matInput [formControlName]="operation"
                              (keydown.enter)="$event.preventDefault()" required id="copy1_{{i}}_{{operation}}">

                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_extract2array_fb" *ngIf="isExtract2ArrayFormEnabled">
                <div formArrayName="extract2ArrayRows">
                  <div class="ops-form" *ngFor="let fo of extract2ArrayRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Extract to Array</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_extract2array_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'list_object_key'">
                                <p>
                                  Provide the key that holds the list of objects to be processed. For example:  
                                  <span style="background-color: #ddd;"id="copy_{{i}}_{{operation}}">data</span>.&nbsp;
                                  <!-- <span style="font-style: italic;">Refer</span> -->
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.extract2ArrayRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'extraction_key'">
                                <p>
                                  Provide the keys you want to extract from each object. For example: 
                                    <span style="background-color: #ddd;"
                                   id="copy_{{i}}_{{operation}}">["id", "content"]</span>.&nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.extract2ArrayRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'array_collection_key'">
                                <p>
                                  Provide the keys that will hold the new collections. For example: 
                                   <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">["ids", "documents"]</span>.&nbsp;
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.extract2ArrayRows())">swap_vert</mat-icon> 
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" *ngIf="operation =='list_object_key'" class="input-suffix">
                            <mat-label class="bold-label">List object Key </mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              (keydown.enter)="$event.preventDefault()" id="copy1_{{i}}_{{operation}}" required>

                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" *ngIf="operation =='extraction_key'"
                            class="input-suffix">
                            <mat-label class="bold-label">Extraction Key</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              (keydown.enter)="$event.preventDefault()" id="copy1_{{i}}_{{operation}}" required>

                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" *ngIf="operation =='array_collection_key'"
                            class="input-suffix">
                            <mat-label class="bold-label">Array Collection Key</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              (keydown.enter)="$event.preventDefault()" id="copy1_{{i}}_{{operation}}" required>

                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form [formGroup]="bizdata_ops_encodedecode_fb" *ngIf="isEncodedecodeFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/xZniNWBbAug?si=advHZc_ex2O3GuI-" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="encodedecodeRows">
                  <div class="ops-form" *ngFor="let fo of encodedecodeRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Encode Decode</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_encodedecode_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'response_key'">
                                <p>
                                  Pass the keyname which holds the data that we want to encode or decode.
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">delimiter_data</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0-0">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.encodedecodeRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'process'">
                                <p>
                                  Pass the process type based on the requirement.
                                  <br>
                                  Possible value for this key is
                                  <span style="background-color: #ddd;">encode</span>
                                  <span style="font-style: italic;">or</span>&nbsp;
                                  <span style="background-color: #ddd;">decode</span>&nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0-0">
                                    here</a>
                                  <!-- <mat-icon name="swap_vert" class="autfill-icon"  matTooltip="Copy Description" (click)="copyDescMessage(operation, i, this.encodedecodeRows())">swap_vert</mat-icon> -->
                                </p>
                              </div>
                              <div *ngSwitchCase="'method_type'">
                                <p>
                                  Give the type in which you want to encode/decode your data.
                                  <br>
                                  Pass the type
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">utf-8</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0%C2%A0-0">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.encodedecodeRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" *ngIf="operation != 'process'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="fill" *ngIf="operation == 'process'">
                            <mat-label>Select Process</mat-label>
                            <mat-select formControlName="process" (selectionChange)="onChangeProcessEDO($event,i )"
                              required>
                              <mat-option *ngFor="let obj of processEDOList" [value]="obj.process">
                                {{ obj.process }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_zipfileinbase64_fb" *ngIf="isZipfileinbase64FromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/CsFE4gYmHA0?si=KH2-3fBu7EVUo_Lq" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="zipfileinbase64Rows">
                  <div class="ops-form" *ngFor="let fo of zipfileinbase64Rows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId" id="{{fo.value.id}}">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Zipfile in Base64</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_zipfileinbase64_obj;">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'source_key'">
                                <p>
                                  Pass the keyname which holds the data.
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">items</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk--16">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.zipfileinbase64Rows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'file_name_key'">
                                <p>
                                  Pass the file name key which hold the file name.
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">file_name</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk--16">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.zipfileinbase64Rows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'file_extension_key'">
                                <p>
                                  Pass the file extension key which holds the extension of files.
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">extension</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk--16">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.zipfileinbase64Rows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'file_data_key'">
                                <p>
                                  Pass the file data key which holds the data of the files.
                                  <br>
                                  Pass the keyname
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">file_data</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk--16">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.zipfileinbase64Rows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'base64_response_key'">
                                <p>
                                  Pass the keyname which will hold the base64 response.
                                  <br>
                                  Pass the number
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">file_string</span>
                                  &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-wrangling#bkmrk--16">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.zipfileinbase64Rows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_substitute_fb" *ngIf="issubstituteFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/Y67Q_QLvELQ?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="substituteRows">
                  <div class="ops-form" *ngFor="let fo of substituteRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Substitute</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_substitute_obj">
                          <div class="column-operation">
                            <p>
                              Substitute/replace a value or a word or a character to a new value
                              <br>
                              Comma separated keys in double quotes
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"email-id",".in",".com"</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-cleaning#bkmrk-substitute">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.substituteRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_rename_fb" *ngIf="isrenameFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/Hkrx8IXUPTY?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="renameRows">
                  <div class="ops-form" *ngFor="let fo of renameRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Rename</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_rename_obj">
                          <div class="column-operation">
                            <p>
                              To rename columns
                              <br>
                              Give comma separated key-value pair name where key is the existing column name and value
                              is the new column name
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"id":"pk","email":"email-id"</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-cleaning#bkmrk-rename">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.renameRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea cols="100" rows="8" matInput [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                            <!-- <json-editor [formControlName]="operation" id="copy1_{{i}}_{{operation}}" [options]="renameoptions">
                            </json-editor> -->
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_strip_fb" *ngIf="isstripFromEnabled" style="margin-bottom:120px;">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/_hHBpSeFPJw?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="stripRows">
                  <div class="ops-form" *ngFor="let fo of stripRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Strip</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_strip_obj">
                          <div class="column-operation">
                            <p>
                              strip a value or a word or a character form left right or both
                              <br>
                              Comma separated keys in double quote
                              <span style="background-color: #ddd;"
                                id="copy_{{i}}_{{operation}}">"TableData","right","\n"</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-cleaning#bkmrk-strip">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.stripRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input matInput cols="100" rows="8" [formControlName]="operation"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()" required />
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_substring_fb" *ngIf="issubstringFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/NNt-SEijOvc?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="substringRows">
                  <div class="ops-form" *ngFor="let fo of substringRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - SubString</label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_substring_obj">
                          <div class="column-operation">
                            <p>
                              String will be cropped according to given value
                              <br>
                              Comma separated key-value pair where key is keyname and value is the cropping value
                              <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">"email":"[-1]"</span>
                              &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-cleaning#bkmrk-substring">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.substringRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_round_fb" *ngIf="isroundFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/C4ADKLQfGlg?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="roundRows">
                  <div class="ops-form" *ngFor="let fo of roundRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Round </label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_round_obj">
                          <div class="column-operation">
                            <div [ngSwitch]="operation">
                              <div *ngSwitchCase="'round_keys'">
                                <p>
                                  Keys which needed to be roundoff.
                                  <br>
                                  Comma separated list of keys in double quotes
                                  <span style="background-color: #ddd;"
                                    id="copy_{{i}}_{{operation}}">"float_value","int_value"</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-round">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.roundRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                              <div *ngSwitchCase="'decimal_key_number'">
                                <p>
                                  Decimal places till which a number needs to roundoff.
                                  <br>
                                  Pass the number
                                  <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">2</span> &nbsp;
                                  <span style="font-style: italic;">Refer</span>
                                  <a style="text-decoration: none; font-style: italic;" target="_blank"
                                    href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-round">
                                    here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                    (click)="copyDescMessage(operation, i, this.roundRows())">swap_vert</mat-icon>
                                </p>
                              </div>
                            </div>
                          </div>
                          <mat-form-field appearance="outline" class="textarea-suffix"
                            *ngIf="operation != 'decimal_key_number'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <mat-form-field appearance="outline" class="input-suffix"
                            *ngIf="operation == 'decimal_key_number'">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              (keydown)="validateSleetTime($event)" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_sleeptime_fb" *ngIf="issleepFromEnabled" style="margin-bottom: 120px;">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/KCo6cP6AEB0?rel=0" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="sleepRows">
                  <div class="ops-form" *ngFor="let fo of sleepRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Sleep Time </label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_sleeptime_obj">
                          <div class="column-operation">
                            <p>
                              It gives a pause to the operation according to the Sleep time value
                              <br>
                              Enter value in seconds
                              <span style="background-color: #ddd;" id="copy_{{i}}_{{operation}}">120</span> &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-pipeline-controls#bkmrk-sleep-time">
                                here</a>
                              <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                (click)="copyDescMessage(operation, i, this.sleepRows())">swap_vert</mat-icon>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" class="input-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <input type="text" matInput [formControlName]="operation" id="copy1_{{i}}_{{operation}}"
                              (keydown)="validateSleetTime($event)" (keydown.enter)="$event.preventDefault()" required>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_pycode_fb" *ngIf="ispycodeFromEnabled">
                <mat-card-content class="m-body-append-video">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/Rb9rdfKCap0?si=40MyT-SzZBwFldaQ" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="pycodeRows">
                  <div class="ops-form" *ngFor="let fo of pycodeRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Python </label>
                        <div class="ops-form-body">
                          <div class="column-operation">
                            <p>
                              Python code in string which we need to execute.
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/data-pipeline-controls#bkmrk-python-operation">
                                here</a>
                            </p>
                          </div>

                          <div class="data-btn-py">
                            <div class="data-btn" *ngIf="spinnerOperationPycodeApiShow == false">
                              <button mat-raised-button type="button" class="btn-test"
                                *ngIf="spinnerOperationPycodeApi == false"
                                (click)="checkTokenSessionBeforeTestPycodeApi(pycodeRows().controls[i].value,i)">Run</button>
                            </div>

                            <div class="data-btn" *ngIf="spinnerOperationPycodeApiShow == true">
                              <button mat-raised-button type="button" id="ib_create_source_dl_test_btn"
                                class="btn-test btn-cancel" (click)="cancelPycodeApiSpinner()">Cancel</button>
                            </div>

                            <div class="loader-container" style="padding: 4px 18px"
                              *ngIf="spinnerOperationPycodeApi == true">
                              <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                            </div>
                          </div>


                          <div class="res-container">
                            <div class="res-header">
                              <span class="res-header">Pycode</span>
                            </div>
                          </div>
                          <div class="mat-section" style="padding: 0;">
                            <div class="m-body-script" style="border:1px groove;border-radius: 5px;">
                              <!-- <ngx-monaco-editor formControlName="pycode" [options]="editorTargetOptions2"
                                (init)="editorInit($event)">
                              </ngx-monaco-editor> -->
                              <ngx-codemirror formControlName="pycode" #pycodeEditor
                                [options]="codeMirrorEditorOptions_python">
                              </ngx-codemirror>
                            </div>
                          </div>
                          <div class="res-container">
                            <div class="res-header">
                              <span class="res-header">Response</span>
                              <span *ngIf="fo.value.status">
                                <span class="res-status" *ngIf="fo.value.status">Status:
                                  <strong>{{fo.value.status}}</strong></span>
                              </span>
                            </div>
                          </div>
                          <div class="mat-section" style="padding: 0;">
                            <div class="m-body-script" style="border:1px groove;border-radius: 5px;">
                              <!-- <ngx-monaco-editor formControlName="response" [options]="editorPycodeOption"
                                (init)="pycodeResponseeditorInit($event)">
                              </ngx-monaco-editor> -->
                              <ngx-codemirror formControlName="response" #pyresponseEditor
                                [options]="codeMirrorEditorOptions">
                              </ngx-codemirror>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              <form class="ai-ops" [formGroup]="bizdata_ops_aiops_fb" *ngIf="isaiopsFromEnabled">
                <div formArrayName="aiopsRows">
                  <div class="ops-form" *ngFor="let fo of aiopsRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                          <div class="ops-form-body ai-ops-content" style="width: 100%;" >
                          <div class="aiops-heading-container">
                            <h1 class="heading-aiops">AI Data Transformation</h1>
                            <p class="description-aiops">Process data with ease—just type in plain English</p>
                          </div>
                          <div  class="aiops-chat-inpt-container" #chatInputContainer>
                            <textarea #chatInput class="textarea-cls" formControlName="question"(keydown.enter)="$event.preventDefault()"  (keydown.enter)="testAiOpsApi(aiopsRows().controls[i].value,i)" (input)="adjustTextareaHeight($event)" id="ai_ops_input"></textarea>
                            <div class="bottom-buttons">
                              <button (click)="testAiOpsApi(aiopsRows().controls[i].value,i)" class="input-btns send-button-aiops" style="margin-bottom: 3px; margin-right: 10px;"
                              [ngClass]="{'default-btn-aiops': aiopsRows().controls[i].value.question.length==0 || aiopsRows().controls[i].value.isgenerating, 'active-btn-aiops': aiopsRows().controls[i].value.question.length>0 && !(aiopsRows().controls[i].value.isgenerating)}">
                                <mat-icon matSuffix>arrow_upward</mat-icon>
                              </button>
                            </div>
                          </div>
                          <div class="result-container-aiops">
                              <div formArrayName="messages" class="chat-messages-aiops" #chatMessage>
                                <div *ngFor="let control of getai_ops_messages(i); let j=index">
                                  <ng-container [formGroupName]="j">
                                    <div class="user-msg-cont-aiops">
                                      <div class="user-message-aiops">{{ control.value.user }}</div></div>
                                      <div style="display: flex; flex-direction: row;">
                                        <span *ngIf="control.value.loading_aiops" class="loading-text">Transforming<span class="dot-flash">.</span></span>
                                      </div>
                                      <div class="ai-message-aiops" *ngIf="!control.value.loading_aiops">
                                        <div class="ai-header-aiops">
                                          <span class="copy-icon-aiops" (click)="copyToClipboardAiops(control.value.ai,j)">
                                            <ion-icon *ngIf="copiedIndexAiops !== j" name="copy-outline"></ion-icon>
                                            <ion-icon *ngIf="copiedIndexAiops === j" name="checkmark-outline">copied</ion-icon>
                                          </span>
                                        </div>
                                        <div class="ai-content">
                                        <pre *ngIf="!control.value.loading_aiops" class="json-output-aiops" [innerHTML]="control.value.ai"></pre>
                                        </div>
                                      </div>
                                  </ng-container>
                                </div>
                              </div>
                          </div>
                        </div>  
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_filter_fb" *ngIf="isfilterFromEnabled">
                <div formArrayName="filterRows">
                  <div class="ops-form" *ngFor="let fo of filterRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Filter </label>
                        <div class="ops-form-body" *ngFor="let operation of bizdata_ops_filter_obj">
                           <p>
                              A condition which will be used to filter the data Give the condition like this For example:
                                <span id="copy_{{i}}_{{operation}}" style="background-color: #ddd;">data['Order Status']=='pending'</span>
                                <span style="font-style: italic;"> Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/filter-operation-use-cases#bkmrk-page-title">
                                  here</a>
                                  <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                  (click)="copyDescMessage(operation, i, this.filterRows())">swap_vert</mat-icon>
                            </p>
                          <mat-form-field appearance="outline" class="textarea-suffix">
                            <mat-label class="bold-label">{{operation.replaceAll("_", " ") | titlecase}}</mat-label>
                            <textarea matInput cols="100" rows="8" [formControlName]="operation"  class="txtAlign"
                              id="copy1_{{i}}_{{operation}}" (keydown.enter)="$event.preventDefault()"
                              required></textarea>
                            <mat-icon (click)="copyInputMessage(operation,i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_filterends_fb" *ngIf="isfilterEndsFromEnabled">
                <div formArrayName="filterEndsRows">
                  <div class="ops-form" *ngFor="let fo of filterEndsRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Filter Ends </label>
                        <p>This Operations end the filter for a given streaming pipeline</p>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_jdbcoutput_fb" *ngIf="isjdbcoutputFromEnabled">
                <mat-card-content class="m-body-append-video" style="margin-top:65px !important">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/SVpHlJy_XU0?si=3Aos1UI7NPdq48v7" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="jdbcoutputRows">
                  <div class="ops-form" *ngFor="let fo of jdbcoutputRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Database | Warehouse | Lakehouse </label>
                        <div class="ops-form-body">
                          <div class="m-body">
                            <mat-card class="m-card data-target">
                              <div class="m-body">
                                <div>
                                  <p>
                                    Select the Storage Name from dropdown in which you want to insert your data.
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="fill">
                                  <mat-label>Select Storage Name</mat-label>
                                  <mat-select #opsStorageNameDropdown formControlName="storage_name"
                                    (selectionChange)="onChangeStorageNameJDBCO($event,i )" panelClass="custom-overlay-panel" 
                                    (openedChange)="onDropdownOpened($event, opsStorageNameDropdown)" required>
                                    <mat-option *ngFor="let obj of storageNameJDBCOList" [value]="obj">
                                      {{ obj.storage_name }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <div>
                                  <p>
                                    Select the version from the dropdown you want to use for the Storage Name
                                    selected.
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="fill">
                                  <mat-label>Select Version</mat-label>
                                  <mat-select #opsStorageVersionDropdown formControlName="db_version"
                                    (selectionChange)="onChangeDlVersionJDBCO($event,i )" panelClass="custom-overlay-panel" 
                                    (openedChange)="onDropdownOpened($event, opsStorageVersionDropdown)" required>
                                    <mat-option *ngFor="let obj of fo.value.db_version_list" [value]="obj">
                                      {{ obj.dbversion }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                                <div>
                                  <p>
                                    Pass the Host IP Address for connecting to the selected Storage Name.
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="outline">
                                  <mat-label>Host IP</mat-label>
                                  <input type="text" formControlName="host_ip" matInput placeholder="Host IP"
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                                <div>
                                  <p>
                                    Pass the Port Number for connection.
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="outline">
                                  <mat-label>Port Number</mat-label>
                                  <input type="text" formControlName="port_number" matInput
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                                <div>
                                  <p>
                                    Give the Schema Name in which the table is present.
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="outline">
                                  <mat-label>Schema Name</mat-label>
                                  <input type="text" formControlName="schema_name" matInput
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                                <div>
                                  <p>
                                    Pass the username for making the connection.
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="outline">
                                  <mat-label>User Name</mat-label>
                                  <input type="text" formControlName="username" matInput
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                                <div>
                                  <p>
                                    Pass the password for connecting.
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="outline">
                                  <mat-label>Password</mat-label>
                                  <input type="password" formControlName="password" matInput
                                    (keydown.enter)="$event.preventDefault()" required>
                                </mat-form-field>
                                <div>
                                  <p>
                                    If you want to insert the data in batches, Provide the keyname in which the
                                    batched data is present.
                                    <span style="background-color: #ddd;">batched_data</span> &nbsp;
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="outline">
                                  <mat-label>Order Set of Values (Tuple Key)</mat-label>
                                  <input type="text" formControlName="tuple_key" matInput
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                                <div>
                                  <p>
                                    Pass the batch size of the Insertion of data.
                                    <span style="font-style: italic;">Refer</span>
                                    <a style="text-decoration: none; font-style: italic;" target="_blank"
                                      href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                      here</a>
                                  </p>
                                </div>
                                <mat-form-field appearance="outline">
                                  <mat-label>Batch Size</mat-label>
                                  <input type="text" formControlName="batch_size" matInput
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>


                                <div class="res-container" style="margin:0">
                                  <div>
                                    <p>
                                      Pass the query which you want to run Pass the query inside double quotes.
                                      <span style="background-color: #ddd;">"Insert into tablename
                                        (first_name,last_name) values (?,?)","first_name","last_name"</span> &nbsp;
                                      <span style="font-style: italic;">Refer</span>
                                      <a style="text-decoration: none; font-style: italic;" target="_blank"
                                        href="https://help.bizdata360.com/books/ezintegrations/page/data-orchestration#bkmrk-sleep-time">
                                        here</a>
                                    </p>
                                  </div>
                                  <div class="res-header-sql"
                                    style="overflow: hidden; padding: 3px; box-sizing: border-box; width: 100%;">
                                    <p style="float: left;margin-top: 10px;">SQL Statement
                                      <br>
                                      <span class="query-content">Insert the data into database with mapping of columns
                                        from incoming dataset</span>
                                      <!-- <span style="font-style: italic;">Refer</span>
                                <a style="text-decoration: none; font-style: italic;" target="_blank"
                                  href="https://help.bizdata360.com/books/ezintegrations/page/data-transformation#bkmrk-lower-case">
                                  here</a> -->
                                      <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                                        (click)="copySourceDescMessage(sqlhint,this.jdbcoutputRows(),i)">swap_vert</mat-icon>
                                    </p>
                                    <div class="res-status-sql" *ngIf="spinnerOperationDatabaseShow == false">
                                      <button mat-raised-button type="button" class="btn-test"
                                        *ngIf="spinnerOperationDatabase == false"
                                        (click)="checkTokenSessionBeforeTestJdbc(jdbcoutputRows().controls[i].value,i)">Test</button>
                                    </div>

                                    <div class="res-status-sql" *ngIf="spinnerOperationDatabaseShow == true">
                                      <button mat-raised-button type="button" class="btn-test btn-cancel"
                                        (click)="cancelOperationDatabaseSpinner()">Cancel</button>
                                    </div>

                                    <div class="loader-container" style="padding: 4px 18px"
                                      *ngIf="spinnerOperationDatabase == true">
                                      <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                                    </div>
                                  </div>
                                </div>
                                <div class="mat-section" style="padding: 0;">
                                  <div class="m-body-script" style="border:1px groove;border-radius: 5px">
                                    <!-- <ngx-monaco-editor formControlName="query" [options]="editorPycodeOption"
                                      (init)="pycodeResponseeditorInit($event)">
                                    </ngx-monaco-editor> -->
                                    <ngx-codemirror formControlName="query" #queryEditor
                                      [options]="codeMirrorEditorOptions_sql">
                                    </ngx-codemirror>
                                    <!-- <mat-hint align="start" class="hint-start">
                                      <span class="hint-label"> Note: SQL Statement to be passed with 3 double quotes,
                                      </span>
                                      <span>e.g: """Insert into table_name (column1,column2) values
                                        (?,?)""","column1","column2"</span>
                                    </mat-hint> -->
                                  </div>
                                </div>
                                <div class="res-container">
                                  <div class="res-header">
                                    <span class="res-header">Response</span>
                                    <span *ngIf="fo.value.status">
                                      <span class="res-status" *ngIf="fo.value.status">Status:
                                        <strong>{{fo.value.status}}</strong></span>
                                    </span>
                                  </div>
                                </div>
                                <div class="mat-section" style="padding: 0">
                                  <div class="m-body-script"
                                    style="border:1px groove;border-radius: 5px;position: relative;">
                                    <!-- <ngx-monaco-editor formControlName="response" [options]="editorPycodeOption"
                                      (init)="jdbcResponseeditorInit($event)">
                                    </ngx-monaco-editor> -->
                                    <json-editor formControlName="response" [options]="editorSourceOptions"
                                    #queryresponseEditor>
                                  </json-editor>
                                    <mat-icon style="position: absolute;
                                      top: 9px;
                                      right: 16px;
                                  " (click)="copyResponse(jdbcoutputRows().controls[i].value.response)">
                                      content_copy
                                    </mat-icon>
                                  </div>
                                </div>
                              </div>
                            </mat-card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_docunderstanding_fb" *ngIf="isDocunderstandingFromEnabled">
                <mat-card-content class="m-body-append-video" style="margin-top:65px !important">
                  <div class="about-views-video">
                    <iframe src="https://www.youtube.com/embed/UEimX1tPXCQ?si=Vt5jYERXKUUHnb93" frameborder="0"
                      allowfullscreen></iframe>
                  </div>
                </mat-card-content>
                <div formArrayName="docunderstandingRows">
                  <div class="ops-form" *ngFor="let fo of docunderstandingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Document Understanding </label>
                        <div class="ops-form-body" style="width:100%">
                          <div>
                            <p>
                              Key Name which holds the complete data &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-document-understandi">
                                here</a>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" style="width:600px" class="input-suffix">
                            <mat-label class="bold-label">Processing Text</mat-label>
                            <input type="text" matInput formControlName="text_key" placeholder="['processed_text']"
                              id="copy1_{{i}}_text_key" required>
                            <mat-icon (click)="copyInputMessage('text_key',i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <div>
                            <p>
                              Key Name which holds the understanding data &nbsp;
                              <span style="font-style: italic;">Refer</span>
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                                href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-document-understandi">
                                here</a>
                            </p>
                          </div>
                          <mat-form-field appearance="outline" style="width:600px" class="input-suffix">
                            <mat-label class="bold-label">Understanding Key</mat-label>
                            <input type="text" matInput formControlName="output_key" id="copy1_{{i}}_output_key"
                              required>
                            <mat-icon (click)="copyInputMessage('output_key',i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <div class="views-options-data-group">
                            <div class="mat-section-restAPI">
                              <div class="m-body">
                                <div class="data-options-wrapper">
                                  <div>
                                    <p>
                                      Ask questions to your Data &nbsp;
                                      <span style="font-style: italic;">Refer</span>
                                      <a style="text-decoration: none; font-style: italic;" target="_blank"
                                        href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-document-understandi">
                                        here</a>
                                    </p>
                                  </div>
                                  <div formArrayName="questions" class="data-options-grid-question"
                                    *ngFor="let params of docunderstandingOperationRow(i).controls;let j = index">
                                    <ng-container [formGroupName]="j">
                                      <mat-form-field appearance="outline">
                                        <input type="text" matInput formControlName="docunderstanding_question"
                                          placeholder="Question?" required>
                                      </mat-form-field>

                                      <mat-form-field appearance="outline">
                                        <input type="text" matInput formControlName="docunderstanding_attribute"
                                          placeholder="Attribute?" required>
                                      </mat-form-field>

                                      <div class="btn-view">
                                        <mat-icon class="icon" (click)="addDocunderstandingQuestion(i)">
                                          add
                                        </mat-icon>
                                      </div>
                                      <div class="btn-view">
                                        <mat-icon class="icon" (click)="removeDocunderstandingQuestion(i,j)">
                                          remove
                                        </mat-icon>
                                      </div>
                                    </ng-container>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <form [formGroup]="bizdata_ops_imgunderstanding_fb" *ngIf="isImgunderstandingFromEnabled">
                <div formArrayName="imgunderstandingRows">
                  <div class="ops-form" *ngFor="let fo of imgunderstandingRows().controls; let i=index">
                    <div *ngIf="fo.value.id == selectedOperationId">
                      <div [formGroupName]="i">
                        <label class="ops-lab">Operations Property - Image Understanding </label>
                        <div class="ops-form-body" style="width:100%">
                          <p>Key Name which holds the complete image data.For Example:
                            <span  style="background-color: #ddd;" >['image_0']</span> Refer 
                            <a style="text-decoration: none; font-style: italic;" target="_blank"
                            href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-parameter-%3A-processi-0">
                           here</a>
                          </p>
                          <mat-form-field appearance="outline" style="width:600px" class="input-suffix">
                            <mat-label class="bold-label">Processing Image</mat-label>
                            <input type="text" matInput formControlName="img_key" placeholder="['processed_text']"
                              id="copy1_{{i}}_img_key" required>
                            <mat-icon (click)="copyInputMessage('img_key',i)" matSuffix>content_copy</mat-icon>
                          </mat-form-field>
                          <div class="views-options-data-group">
                            <div class="mat-section-restAPI">
                              <div class="m-body">
                                <div class="data-options-wrapper">
                                  <div formArrayName="questions" class="data-options-grid-question"
                                    *ngFor="let params of imgunderstandingOperationRow(i).controls;let j = index">
                                    <!-- <div > -->
                                    <ng-container [formGroupName]="j">
                                      <div>
                                        <p>Ask questions to your Data. For Example
                                          <span  style="background-color: #ddd;" >What is the name of State?</span> Refer 
                                          <a style="text-decoration: none; font-style: italic;" target="_blank"
                                          href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-parameter-%3A-processi-0">
                                          here </a>
                                          </p>
                                        <mat-form-field appearance="outline">
                                          <input type="text" matInput formControlName="imgunderstanding_question"
                                            placeholder="Question?" required>
                                        </mat-form-field>
                                      </div>

                                     <div  class="image_attribute">
                                      <mat-form-field appearance="outline">
                                        <input type="text" matInput formControlName="imgunderstanding_attribute"
                                          placeholder="Attribute?" required>
                                      </mat-form-field>
                                     </div>

                                      <div class="btn-view" style=" position: relative;
                                      top: 51px;
                                      right: 160px;">
                                        <mat-icon class="icon" (click)="addImgunderstandingQuestion(i)">
                                          add
                                        </mat-icon>
                                      </div>
                                      <div class="btn-view" style=" position: relative;
                                      top: 51px;
                                      right: 160px;">
                                        <mat-icon class="icon" (click)="removeImgunderstandingQuestion(i,j)">
                                          remove
                                        </mat-icon>
                                      </div>
                                    </ng-container>
                                    <!-- </div> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="img-understanding">
                              <p>Key Name which holds the understanding data. For Example:
                                <span style="background-color: #ddd;">Answers</span> Refer 
                              <a style="text-decoration: none; font-style: italic;" target="_blank"
                              href="https://help.bizdata360.com/books/ezintegrations/page/deep-learning#bkmrk-parameter-%3A-processi-0">
                            here</a>
                            </p>
                              <mat-form-field appearance="outline" style="width:600px">
                                <mat-label class="bold-label">Understanding Key</mat-label>
                                <input type="text" matInput formControlName="output_key" required placeholder="understanding
                                ">
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>

              <!-- <p style="display: block">{{row | json}} </p>
                <p style="display: block">{{blocks[i] | json}}</p> -->

              <!-- <div class="timeline">
                  <ng-container *ngFor="let row of newBlocks;let i=index">
                    <div class="row" cdkDropList #blocksList="cdkDropList" [cdkDropListData]="{blockArr: blocks}"  (cdkDropListDropped)="destinationDropped($event)" [ngClass]="{right: i % 2 === 0, left: i % 2 !== 0}">
                      <div class="circle" *ngFor="let col of newBlocks[i]; let j = index" cdkDrag [cdkDragData]="col">
                          {{ col.title }}
                          <button (click)="removeItem(col.id)">X</button>
                      </div>
                    </div>
                  </ng-container>
                </div> -->

              <!-- <div class="operations-sec">
                  <span class="operations-sec-header">You want to Apply Coversions on the Field to Integer, Float,
                    Date Etc. ?</span>
                  <mat-slide-toggle class="example-margin" [color]="color" [checked]="checked" [disabled]="disabled">
                  </mat-slide-toggle>
                </div>
                <div class="operations-sec">
                  <span class="operations-sec-header">You want to convert String to JSON or XML to JSON ?</span>
                  <mat-slide-toggle class="example-margin" [color]="color" [checked]="checked" [disabled]="disabled">
                  </mat-slide-toggle>
                </div>
                <div class="operations-sec">
                  <span class="operations-sec-header">You want to add New Field</span>
                  <mat-slide-toggle class="example-margin" [color]="color" [checked]="checked" [disabled]="disabled">
                  </mat-slide-toggle>
                </div> -->

              <!-- <div class="operations-sec">
                  <mat-divider></mat-divider>
                  <div class="operations-type">
                    <div class="op-type">
                      <mat-form-field class="op-type-select" appearance="fill">
                        <mat-label>Select Operation Type</mat-label>
                        <mat-select>
                          <mat-option *ngFor="let d of sourceColoumns" [value]="d.obj_name">
                            {{ d.obj_name }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="op-params-bx">
                      <div class="op-params" id="param-{{i}}" *ngFor="let parms of operationParam;let i = index;">
                        <mat-form-field appearance="fill">
                          <mat-label>Parameter</mat-label>
                          <input type="text" matInput />
                          <mat-icon matSuffix (click)="deleteParam(i)">clear</mat-icon>
                        </mat-form-field>
                      </div>
                      <button mat-raised-button (click)="addOpParam()">Add</button>
                    </div>
                  </div>
                </div> -->
            </mat-card-content>
          </mat-card>
          <div class="action-btn-section">
            <button mat-stroked-button matStepperPrevious class="previous">
              <mat-icon matSuffix>west</mat-icon>Previous
            </button>
            <button mat-stroked-button matStepperNext class="next">
              Next<mat-icon matSuffix>east</mat-icon>
            </button>
          </div>
          <!-- </form> -->
        </mat-step>

        <mat-step [stepControl]="dataTarget" [completed]="false">
          <form [formGroup]="dataTarget">
            <ng-template matStepLabel>Data Target</ng-template>
            <mat-card class="m-card source">
              <mat-card-title class="m-title">
                <span class="m-header">Select Target Type</span>
              </mat-card-title>
              <div class="m-body">
                <mat-form-field class="data-column" appearance="outline">
                  <mat-label>Target Type</mat-label>
                  <!-- <input type="text" formControlName="bridge_target_type" matInput placeholder="Target Type" required> -->
                  <mat-select #targetApiTypeDropdown formControlName="bridge_target_type"
                    (selectionChange)="OnChangeBridgeTargetType($event,'')" panelClass="custom-overlay-panel" 
                    (openedChange)="onDropdownOpened($event, targetApiTypeDropdown)" id="ib_update_target_type">
                    <mat-option *ngFor="let obj of bridgeTargetType" [value]="obj" selected>{{obj.value}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </div>
            </mat-card>
            <mat-card class="m-card data-target" *ngIf="bridge_target_type == 1">
              <mat-card-title class="m-title">
                <span class="m-header">What is your Data Target?</span>
                <span class="sub-content">Please specify or select the Data Target from Catalog</span>
              </mat-card-title>
              <div class="m-body">
                <!-- <p *ngIf="bridgeTargetCatalogType.length == 0" style="margin: 30px 0">No target found.<a href="javascript:void(0)" [routerLink]="['/baseapp/api-catalog/create']"  >Please add your target</a></p> -->
                <mat-form-field class="data-column" appearance="outline" #formFieldTarget (click)="onDropdownOpened(true, targetProductNameDropdown)">
                  <mat-label>Search by target name</mat-label>
                  <input type="text" placeholder="Search by target name" formControlName="bridge_target" matInput
                    id="ib_update_target_search_target_name" [matAutocomplete]="auto"
                    (keydown.enter)="$event.preventDefault()" #targetProductNameDropdown="matAutocompleteTrigger" required />
                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="OnChangeBridgeTarget($event)"
                    id="ib_update_target_create-new">
                    <mat-option class="create-new" [value]="createNew">Create New</mat-option>
                    <mat-optgroup *ngFor="let brand of bridgeTarget$ | async" [label]="brand.brand_name"
                      id="ib_update_target_brandProd">
                      <mat-option *ngFor="let product of brand.products" [value]="product">
                        {{product}}
                      </mat-option>
                    </mat-optgroup>
                  </mat-autocomplete>
                  <button type="button" mat-button matSuffix aria-label="Search"
                    id="ib_update_target_search_product_btn">
                    <mat-icon>search</mat-icon>
                  </button>
                  <button type="button" mat-button *ngIf="enableDataTargetClearIcon" matSuffix aria-label="Clear"
                    id="ib_update_target_clear_product_btn" (click)="clearDataTarget()">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <!-- <mat-select formControlName="bridge_target" (selectionChange)="OnChangeBridgeTarget($event)">
                    <mat-option *ngFor="let obj of bridgeTargetCatalogType" [value]="obj.product_name">{{obj.product_name}}</mat-option>
                  </mat-select> -->
                </mat-form-field>

                <div class="column-content">
                  <mat-icon matSuffix>info</mat-icon>
                  <p>
                    Not sure on Data Target? Please checkout the
                    <a style="text-decoration: none;" target="_blank" id="ib_update_target_market"
                      href="#/baseapp/marketplace">Marketplace</a> or
                    <a style="text-decoration: none;" href="javascript:void(0);" (click)="dataSourceModal('target')">
                      Add from Cart
                    </a>
                  </p>
                </div>

                <mat-form-field style="margin-top: 15px;" appearance="outline" *ngIf="isNewTarget">
                  <mat-label>Enter Target Name</mat-label>
                  <input type="text" formControlName="new_bridge_target" matInput placeholder="Target name"
                    id="ib_update_target_enter_target_name" (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>

                <mat-form-field appearance="outline" *ngIf="isNewTarget">
                  <mat-label>Enter Business Object</mat-label>
                  <input type="text" formControlName="new_bridge_target_business_object" matInput
                    id="ib_update_target_enter_businessObj" placeholder="Business object"
                    (keydown.enter)="$event.preventDefault()" required>
                </mat-form-field>

                <!-- <mat-form-field class="target-businessObj" appearance="fill" *ngIf="!isNewTarget">
                  <mat-label>Select Business Object</mat-label>
                  <mat-select formControlName="bridge_target_business_object"
                    (selectionChange)="onChangeBusinessObjectSource($event)">
                    <mat-option *ngFor="let obj of bridgeTargetBusinessObject" [value]="obj">
                      {{ obj.business_obj }}
                    </mat-option>
                  </mat-select>
                </mat-form-field> -->

                <mat-form-field class="data-column" appearance="outline" #formFieldTarget *ngIf="!isNewTarget">
                  <mat-label>Search by business object</mat-label>
                  <!-- <input type="text" matInput placeholder="Search by business object"
                    id="ib_update_target_search_businessObj" formControlName="bridge_target_business_object"
                    [matAutocomplete]="autoTBO" (keydown.enter)="$event.preventDefault()" required /> -->
                  <mat-select #targetBusinessObjectDropdown formControlName="bridge_target_business_object"
                     (selectionChange)="onChangeBusinessObjectTarget($event)"
                    id="ib_update_source_change_businessObj" panelClass="custom-overlay-panel" 
                    (openedChange)="onDropdownOpened($event, targetBusinessObjectDropdown)" [compareWith]="compareBusinessObjects">
                    <mat-option *ngFor="let tbo of bridgeTargetBusinessObject$ | async" [value]="tbo">
                      {{tbo.business_obj}}
                    </mat-option>
                  </mat-select>
                  <button type="button" mat-button *ngIf="enableTargetBusinessObjectClearIcon"
                    id="ib_update_target_clear_businessObj_btn" aria-label="Clear" matSuffix
                    (click)="clearTargetBusinessObject()">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </mat-card>

            <mat-card class="postman-integration-target-update" *ngIf="bridge_target_type == 1">
              <app-postmanui 
                [apiCatalogFormType]="'target'" [catalogueId]="targetCatalogueId"
                [updateIntBridgeData]="updateIntBridgeTargetData">
              </app-postmanui>
            </mat-card>

            <!-- <mat-card class="m-card system" *ngIf="bridge_target_type == 1">

              <form [formGroup]="environmentTargetForm">
                <div class="views-content-env" style="grid-template-columns: 100%;">
                  <div class="views-content-env-data">
                    <div class="add-environment-button" style="text-align: right;">
                      <p>{{environmentTargetForm.value.selected_environment}}</p>
                    </div>
                    <div class="add-environment-button">
                      <mat-icon class="icon" (click)="openTargetEnvironment(true)">
                        add
                      </mat-icon>
                    </div>
                    <div class="exit-environment">
                      <mat-icon class="icon" (click)="exitTargetEnvironment()">
                        move_down
                      </mat-icon>
                    </div>
                    <div class="env-settings">
                      <div class="env-settings-wrapper" (click)="toggleTargetMenu()">
                        <mat-icon matTooltip="Environment Settings" matTooltipPosition="above">settings</mat-icon>
                        <mat-select class="env-settings-select"
                          formControlName="bridge_endpoint_selected_environments_name"
                          (selectionChange)="onTargetEnvironmentChange($event)">
                          <mat-option value="No Environment">No Environment</mat-option>
                          <mat-option *ngFor="let tab of selectedTargetEnvTabs" [value]="tab">
                            {{ tab }}
                          </mat-option>
                        </mat-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="m-body" *ngIf="showTargetEnvironmentTab">
                  <div class="env-container">
                    <div class="env-header">
                      <span class="env-header">Environment Setting</span>
                    </div>
                  </div>
                  <div class="environment-tab-group">
                    <div formArrayName="bridge_endpoint_environments_raw">
                      <div *ngFor="let environments of bridgeTargetEnvironments().controls; let i = index">
                        <div [formGroupName]="i">
                          <ng-container *ngIf="i === currentTargetDisplayedEnvIndex">
                            <div class="environment-tab" style="grid-template-columns: 600px auto;">
                              <div class="environment-name">
                                <mat-form-field class="environment-name-field" appearance="outline">
                                  <mat-label>Environment Name</mat-label>
                                  <input matInput placeholder="Environment Name" type="text" formControlName="env_name">
                                </mat-form-field>
                              </div>
                              <div class="environment-icon" style="margin-left: 10px;">
                                <span class="environment-icon-flotter">
                                  <mat-icon class="icon" (click)="confirmTargetSaveEnv(environments.value.env_name,i)">
                                    save
                                  </mat-icon>
                                  <mat-icon class="icon" (click)="confirmTargetDelete(environments.value.env_name,i)">
                                    delete
                                  </mat-icon>
                                </span>
                              </div>
                            </div>
                            <div class="environment-variable-container">
                              <div class="environment-variable-tabs">
                                <div formArrayName="env_vars">
                                  <ng-container *ngFor="let env of envTargetData(i).controls; let envIndex = index">
                                    <div [formGroupName]="envIndex">
                                      <div class="data-options-wrapper-environment">
                                        <mat-form-field appearance="outline">
                                          <mat-label>Variable</mat-label>
                                          <input type="text" placeholder="Variable" matInput formControlName="variable">
                                        </mat-form-field>
                                        <mat-form-field class="mat-dropdown" appearance="outline">
                                          <mat-label>Type</mat-label>
                                          <mat-select placeholder="Type" formControlName="type"
                                            (selectionChange)="envTargetChangeType($event,envIndex,i)">
                                            <mat-option *ngFor="let type of environmentType" [value]="type.value">{{
                                              type.viewValue }}</mat-option>
                                          </mat-select>
                                        </mat-form-field>
                                        <mat-form-field appearance="outline">
                                          <mat-label>Value</mat-label>
                                          <input [type]="env.value.valueType" [id]="'environmentValue-' + envIndex"
                                            placeholder="Value" matInput formControlName="value">
                                          <mat-icon *ngIf="env.value.type === 'password'" matSuffix
                                            (click)="toggleTargetPassword(i, envIndex)">
                                            {{ env.value.valueType == 'password' ? 'visibility_off' : 'visibility'
                                            }}
                                          </mat-icon>
                                        </mat-form-field>
                                        <div class="btn-view">
                                          <mat-icon class="icon" (click)="addTargetEnvironmentsTab(i)">
                                            add
                                          </mat-icon>
                                        </div>
                                        <div class="btn-view">
                                          <mat-icon class="icon" (click)="removeTargetEnvironmentsTab(i, envIndex)">
                                            remove
                                          </mat-icon>
                                        </div>
                                      </div>
                                    </div>
                                  </ng-container>
                                </div>
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
              
              <div class="m-body" *ngIf="!showTargetEnvironmentTab">
                <div class="views-content-data">
                  <div class="data-options">
                    <mat-form-field class="data-options-dropdown" appearance="outline">
                      <mat-select formControlName="bridge_target_endpoint_method" id="ib_update_target_request_method">
                        <mat-option *ngFor="let options of methodList" [value]="options" class="optionsList">
                          {{ options.method }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="data-url">
                    <mat-form-field class="data-url" appearance="outline" style="display: none;">
                      <input type="text" matInput placeholder="Request URL" id="ib_update_target_request_url"
                        formControlName="bridge_target_endpoint_url" (keydown.enter)="$event.preventDefault()">
                    </mat-form-field>
                      <div class="contentDiv" id="contentDivTarget" contenteditable="true" placeholder="Request URL"
                      (keyup)="onKeyupTEPUrl($event)">{{endpoint_target_url}}</div>
                  </div>

                  <div class="data-btn" *ngIf="spinnerTargetShow == false">
                    <button mat-raised-button type="button" class="btn-test" id="ib_update_target_endpoint_test_api_btn"
                      *ngIf="spinnerTarget == false" (click)="checkTokenSessionBeforeTestTargetApi()">Test</button>
                  </div>

                  <div class="data-btn" *ngIf="spinnerTargetShow == true">
                    <button mat-raised-button type="button" id="ib_update_target_endpoint_test_api_btn" class="btn-test"
                      (click)="cancelTargetSpinner()">Cancel</button>
                  </div>

                  <div class="loader-container" style="padding: 12px" *ngIf="spinnerTarget == true">
                    <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                  </div>
                </div>

                <mat-tab-group animationDuration="0ms" class="views-options-data-group"
                 (selectedTabChange)="targetPostmanTabChange($event)">
                  <mat-tab label="Params">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_target_endpoint_params_raw"
                            *ngFor="let params of bridgeTargetParams?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                              <mat-form-field appearance="outline" style="display: none;">
                                <input type="text" formControlName="bridge_target_paramKey" matInput placeholder="Key"
                                  id="ib_update_target_endpoint_params_key{{i}}"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                              <div class="contentDivInputContParams">
                                <div class="contentParams" id="contentDiv_target_params_key{{i}}" placeholder="Key" contenteditable="true"
                                (keyup)="onKeyupTEPParamsKey($event,i)">{{params_target_key[i]}}</div>
                                </div>
                              <mat-form-field appearance="outline" style="display: none;">
                                <input type="text" formControlName="bridge_target_paramValue" matInput
                                  id="ib_update_target_endpoint_params_value{{i}}" placeholder="Value"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                              <div class="contentDivInputContParams">
                                <div class="contentParams" id="contentDiv_target_params_value{{i}}" placeholder="Value" contenteditable="true"
                                (keyup)="onKeyupTEPParamsValue($event,i)">{{params_target_value[i]}}</div>
                                </div>
                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_target_paramDescription" matInput
                                  id="ib_update_target_endpoint_params_desc{{i}}" placeholder="Description"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="addTargetParams(i)"
                                  id="ib_update_target_endpoint_params_add{{i}}">
                                  add
                                </mat-icon>
                              </div>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="removeTargetParams(i)"
                                  id="ib_update_target_endpoint_params_remove{{i}}">
                                  remove
                                </mat-icon>
                              </div>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Authorization">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="authentication-view">
                          <div class="view-options-drop">
                            <mat-form-field class="mat-dropdown" appearance="outline">
                              <mat-label>Select Type</mat-label>
                              <mat-select formControlName="bridge_target_endpoint_authentication_type"
                                id="ib_update_target_authentication_type"
                                (selectionChange)="onChangeTargetAuthenticationtype($event)">
                                <mat-option *ngFor="let type of authenticationTargetTypeOptions" [value]="type">
                                  {{ type.type }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div class="view-body">
                            <ng-container *ngIf="selectTargetType == 3">
                              <div class="view-options">
                                <mat-form-field appearance="outline">
                                  <mat-label>Token</mat-label>
                                  <input type="text" matInput placeholder="Token"
                                    id="ib_update_target_authentication_token"
                                    formControlName="bridge_target_authentication_token"
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectTargetType == 4">
                              <div class="view-options">
                                <mat-form-field appearance="outline" style="display: none;">
                                  <mat-label>Username</mat-label>
                                  <input [type]="datatargetusername ? 'password' : 'text'" matInput placeholder="Username"
                                    id="ib_update_target_authentication_username"
                                    formControlName="bridge_target_authentication_username"
                                    (keydown.enter)="$event.preventDefault()">
                                  <mat-icon matSuffix (click)="datatargetusername = !datatargetusername">{{datatargetusername ?
                                    'visibility_off' : 'visibility'}}</mat-icon>
                                </mat-form-field>
                                <mat-label>Username *</mat-label>
                                <div class="contAiner">
                                  <div id="contentDevTargetAuthUser" placeholder="Username" contenteditable="true"
                                    (keyup)="onKeyupTEPAuthUser($event)" (click)="onKeyupTEPAuthUser($event)">{{target_authUser}}</div>
                                  <mat-icon class="buttOn" matSuffix
                                    (click)="toggleAuthPassword('contentDevTargetAuthUser','target_user')">{{datatargetusername ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </div>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline" style="display: none;">
                                  <mat-label>Password</mat-label>
                                  <input [type]="datatargetpassword ? 'password' : 'text'" matInput placeholder="Password"
                                    id="ib_update_target_authentication_password"
                                    formControlName="bridge_target_authentication_password"
                                    (keydown.enter)="$event.preventDefault()">
                                  <mat-icon matSuffix (click)="targetpassword = !targetpassword">{{datatargetpassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </mat-form-field>
                                <mat-label>Password *</mat-label>
                                <div class="contAiner">
                                  <div id="contentDevTargetAuthPassword" placeholder="Password" contenteditable="true"
                                    (keyup)="onKeyupTEPAuthPassword($event)" (click)="onKeyupTEPAuthPassword($event)">{{target_authPassword}}</div>
                                  <mat-icon class="buttOn" matSuffix
                                    (click)="toggleAuthPassword('contentDevTargetAuthPassword','target_password')">{{datatargetpassword ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </div>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="selectTargetType == 6">
                              <div class="view-options-drop">
                                <mat-form-field appearance="outline">
                                  <mat-label>Refresh Token Method</mat-label>
                                  <mat-select formControlName="bridge_target_oauth_refresh_token_endpoint_method"
                                    id="ib_update_target_authentication_method">
                                    <mat-option *ngFor="let options of methodList" [value]="options">
                                      {{ options.method }}
                                    </mat-option>
                                  </mat-select>
                                </mat-form-field>
                              </div>
                              <div class="view-options">
                                <mat-form-field appearance="outline" style="display: none;">
                                  <mat-label>Refresh Token URL</mat-label>
                                  <input type="text" matInput placeholder="Refresh Token URL"
                                    id="ib_update_target_authentication_url"
                                    formControlName="bridge_target_oauth_refresh_token_endpoint_url"
                                    (keydown.enter)="$event.preventDefault()">
                                </mat-form-field>
                                <div class="contentDivInputContParams" id="contentDivTargetAuth">
                                  <div class="contentParams" id="contentDevTargetAuth" contenteditable="true" placeholder="Refresh Token Endpoint URL*"
                                  (keyup)="onKeyupTEPAuth($event)" (click)="onKeyupTEPAuth($event)">{{target_auth}}</div>
                                  </div>
                              </div>
                              <div class="view-options-auth">
                                <mat-label>Refresh Token Endpoint Header</mat-label>
                                <ngx-codemirror class="codemirror-color" formControlName="bridge_target_oauth_refresh_token_endpoint_header"
                                  id="ib_update_target_authentication_header" #targetrefreshTokenHeaderScriptEditor
                                  [options]="authorizationScriptEditorOptions">
                                </ngx-codemirror>
                              </div>
                              <div class="view-options-auth">
                                <mat-label>Refresh Token Endpoint Params</mat-label>
                                <ngx-codemirror class="codemirror-color" formControlName="bridge_target_oauth_refresh_token_endpoint_params"
                                  id="ib_update_target_authentication_params" #targetrefreshTokenParamScriptEditor
                                  [options]="authorizationScriptEditorOptions">
                                </ngx-codemirror>
                              </div>
                              <div class="view-options-auth">
                                <mat-label>Refresh Token Endpoint Body</mat-label>
                                <ngx-codemirror class="codemirror-color" formControlName="bridge_target_oauth_refresh_token_endpoint_body"
                                  id="ib_update_target_authentication_body" #targetrefreshTokenBodyScriptEditor
                                  [options]="authorizationScriptEditorOptions">
                                </ngx-codemirror>
                              </div>
                            </ng-container>

                          </div>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Headers">
                    <div class="mat-section">
                      <div class="m-body">
                        <div class="data-options-wrapper">
                          <div class="data-options-grid" formArrayName="bridge_target_endpoint_headers"
                            *ngFor="let headers of bridgeTargetHeaders?.controls;let i = index">
                            <ng-container [formGroupName]="i">
                                <div class="dataTargetheadersKey autocomplete-container">
                                  <div #contentEditableDataTargetHeaderKey  id="contentDevTargetHeaderKey{{i}}"
                                    contenteditable="true" placeholder="Key" class="contentEditable"  (keyup)="onKeyupTEPHeaderKey($event,i)"
                                    (input)="onDataTargetHeaderKeyInput($event, i)" (focus)="onDataTargetHeaderKeyFocus(i)"
                                    (blur)="hideDataTargetHeaderKeyAutocomplete(i)"><span *ngIf="headers_target_key[i]!=null && headers_target_key[i].length>0">{{headers_target_key[i]}}</span>
                                  </div>
                                  <div #autocompleteDataTargetHeaderKey class="autocomplete-dropdown"
                                    *ngIf="filteredDataTargetHeaderKey[i]?.length">
                                    <div class="autocomplete-item" *ngFor="let key of filteredDataTargetHeaderKey[i]"
                                      (mousedown)="onDataTargetHeaderKeyOptionSelected(key.header_key, i)">
                                      {{ key.header_key }}
                                    </div>
                                  </div>
                                </div>
                                <div class="dataTargetHeadersValue autocomplete-container">
                                  <div #contentEditableDataTargetHeaderValue  id="contentDevTargetHeaderValue{{i}}"
                                    contenteditable="true" placeholder="Value" class="contentEditable"  (keyup)="onKeyupTEPHeaderValue($event,i)"
                                    (input)="onDataTargetHeaderValueInput($event, i)" (focus)="onDataTargetHeaderValueFocus(i)"
                                    (blur)="hideDataTargetHeaderValueAutocomplete(i)"><span *ngIf="headers_target_value[i]!=null && headers_target_value[i].length>0">{{headers_target_value[i]}}</span>
                                  </div>
                                  <div #autocompleteDataTargetHeaderValue class="autocomplete-dropdown"
                                    *ngIf="filteredDataTargetHeaderValue[i]?.length">
                                    <div class="autocomplete-item" *ngFor="let value of filteredDataTargetHeaderValue[i]"
                                      (mousedown)="onDataTargetHeaderValueOptionSelected(value.header_value, i)">
                                      {{ value.header_value }}
                                    </div>
                                  </div>
                                </div>
                              <mat-form-field appearance="outline">
                                <input type="text" formControlName="bridge_target_headerDescription" matInput
                                  id="ib_update_target_endpoint_header_desc{{i}}" placeholder="Description"
                                  (keydown.enter)="$event.preventDefault()">
                              </mat-form-field>

                              <div class="btn-view">
                                <mat-icon class="icon" (click)="addTargetHeaders(i)"
                                  id="ib_update_target_endpoint_header_add{{i}}">
                                  add
                                </mat-icon>
                              </div>
                              <div class="btn-view">
                                <mat-icon class="icon" (click)="removeTargetHeader(i)"
                                  id="ib_update_target_endpoint_header_remove{{i}}">
                                  remove
                                </mat-icon>
                              </div>
                            </ng-container>
                          </div>
                        </div>

                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Body">
                    <div class="mat-section">
                      <div style="width: 25%;">
                        <mat-form-field class="mat-dropdown" appearance="outline">
                          <mat-label>Select Type</mat-label>
                          <mat-select formControlName="bridge_target_body_type"
                            id="ib_update_target_endpoint_body_type">
                            <mat-option *ngFor="let type of bodyTypeOptions" [value]="type.type">
                              {{ type.type }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="m-body">
                        <ngx-codemirror formControlName="bridge_target_endpoint_body_raw"
                          id="ib_update_target_endpoint_body_raw" #bodyTargetEditor [options]="codeMirrorEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                  <mat-tab label="Pre-request Script">
                    <div class="mat-section">
                      <div class="m-body-script">
                        <ngx-codemirror class="codemirror-color" formControlName="pre_request_script"
                          id="ib_update_target_endpoint_pre_request_script" #targetPreRequestScriptEditor
                          [options]="preRequestScriptEditorOptions">
                        </ngx-codemirror>
                      </div>
                    </div>
                  </mat-tab>
                </mat-tab-group>

                <div class="res-container">
                  <div class="res-header">
                    <h3 style="margin:0">Response Params</h3>
                    <span class="res-header">
                      <mat-radio-group formControlName="response_type">
                        <mat-radio-button value="text">Text</mat-radio-button>
                        <mat-radio-button value="content">Content</mat-radio-button>
                        <mat-radio-button value="json">JSON</mat-radio-button>
                      </mat-radio-group>
                    </span>
                  </div>
                  <div class="res-header">
                    <span class="res-header">Response</span>
                    <span *ngIf="bridgeTargetResponse?.bizdata_dataset">
                      <span class="res-status"
                        *ngIf="bridgeTargetResponse?.bizdata_dataset.bizdata_dataset_status">Status:
                        <strong>{{bridgeTargetResponse?.bizdata_dataset.bizdata_dataset_status}}</strong></span>
                    </span>
                  </div>
                  <div class="res-body">
                    <div class="error-block" *ngIf="bridgeTargetResponse?.error == 2; else tr">
                      <h5>Could not send request</h5>
                      <span>Error: {{bridgeTargetResponse.message}}</span>
                    </div>
                    <ng-template #tr>
                      <div style=" position: relative;">
                      <json-editor formControlName="bridge_target_response" id="ib_update_target_endpoint_response"
                        [options]="editorTargetOptions">
                      </json-editor>
                      <mat-icon style="cursor: pointer;position: absolute; top: 5px; right: 5px"
                      (click)="copyResponse(dataTarget.controls.bridge_target_response.value)">
                      content_copy
                    </mat-icon>
                    </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </mat-card> -->
            <mat-card class="m-card system" *ngIf="bridge_target_type == 2">
              <div class="ops-form-body">

                <mat-card class="m-card data-source">
                  <div class="m-body">

                    <div class="data-btn">
                      <label class="ops-lab-data-target">Storage Details</label>
                    </div>
                    <mat-form-field appearance="fill">
                      <mat-label>Select Storage Name</mat-label>
                      <mat-select #targetStorageNameDropdown formControlName="storage_name" id="ib_update_target_storage_name"
                        (selectionChange)="onChangeDataTargetStorageNameJDBCO($event)" panelClass="custom-overlay-panel" 
                        (openedChange)="onDropdownOpened($event, targetStorageNameDropdown)" required>
                        <mat-option *ngFor="let obj of storageNameJDBCOList" [value]="obj">
                          {{ obj.storage_name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="fill">
                      <mat-label>Select Version</mat-label>
                      <mat-select #targetStorageVersionDropdown formControlName="db_version" id="ib_update_target_dbVersion"
                        (selectionChange)="onChangeDataTargetDlVersionJDBCO($event)" panelClass="custom-overlay-panel" 
                        (openedChange)="onDropdownOpened($event, targetStorageVersionDropdown)" required>
                        <mat-option *ngFor="let obj of dataTarget_db_version_list" [value]="obj">
                          {{ obj.dbversion }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Host IP</mat-label>
                      <input type="text" formControlName="host_ip" id="ib_update_target_host" matInput
                        placeholder="Host IP" (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Port Number</mat-label>
                      <input type="text" formControlName="port_number" id="ib_update_target_port" matInput
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Schema Name</mat-label>
                      <input type="text" formControlName="schema_name" id="ib_update_target_schema" matInput
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>User Name</mat-label>
                      <input type="text" formControlName="username" id="ib_update_target_db_username" matInput
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                      <mat-label>Password</mat-label>
                      <input type="password" formControlName="password" id="ib_update_target_db_password" matInput
                        (keydown.enter)="$event.preventDefault()" required>
                    </mat-form-field>
                    <mat-form-field appearance="outline" style="margin-bottom: 40px;">
                      <mat-label>Order Set of Values (Tuple Key)</mat-label>
                      <input type="text" formControlName="tuple_key" id="ib_update_target_tuple" matInput
                        (keydown.enter)="$event.preventDefault()">
                      <mat-hint align="start" class="hint-start" style="font-size: 15px;">
                        <span class="hint-label">Note: The tuple key should be written inside square brackets, enclosed
                          in single quotes</span><br>
                        <span>Example: ['tuple key']</span>
                      </mat-hint>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Batch Size</mat-label>
                      <input type="text" formControlName="batch_size" id="ib_update_target_batch" matInput
                        (keydown.enter)="$event.preventDefault()">
                    </mat-form-field>
                    <mat-card class="mat-section1" style="border:1px groove;border-radius: 5px;">
                      <div class="res-header-sql">
                        <div style="float: left;margin-top: 10px;">SQL Statement
                          <div style="float: left;">
                            <span class="query-content">Insert the data into database with mapping of columns from
                              incoming dataset
                            </span>
                            <mat-icon name="swap_vert" class="autfill-icon" matTooltip="Copy Description"
                              (click)="copySourceDescMessage(sqlhint,dataTarget)">swap_vert</mat-icon>
                          </div>
                        </div>
                        <div class="res-status-sql" *ngIf="spinnerTargetDatabaseShow == false">
                          <button mat-raised-button type="button" id="ib_create_target_db_test_btn"
                            class="btn-test execute" *ngIf="spinnerTargetDatabase == false"
                            (click)="checkTokenSessionBeforeDataTargetJdbc()">Execute</button>
                        </div>

                        <div class="res-status-sql" *ngIf="spinnerTargetDatabaseShow == true">
                          <button mat-raised-button type="button" id="ib_create_target_db_test_btn execute"
                            class="btn-test execute" (click)="cancelTargetDatabaseSpinner()">Cancel</button>
                        </div>

                        <div class="loader-container" style="padding: 4px 18px" *ngIf="spinnerTargetDatabase == true">
                          <mat-spinner class="btn-spinner" diameter="30"></mat-spinner>
                        </div>
                      </div>
                      <div class="m-body-script">
                        <!-- <ngx-monaco-editor formControlName="query" [options]="editorPycodeOption"
                          (init)="pycodeResponseeditorInit($event)">
                        </ngx-monaco-editor> -->
                        <ngx-codemirror formControlName="query" id="ib_update_target_db_query" #queryEditor
                          [options]="codeMirrorEditorOptions_sql">
                        </ngx-codemirror>
                        <!-- <mat-hint align="start" class="hint-start">
                          <span class="hint-label"> Note: SQL Statement to be passed with 3 double quotes,</span><br>
                          <span>e.g: """Insert into table_name
                            (column1,column2) values (?,?)""","column1","column2"</span>
                        </mat-hint> -->
                      </div>
                    </mat-card>
                    <div class="res-container">
                      <div class="res-header">
                        <span class="res-header">Response</span>
                        <span *ngIf="data_target_status">
                          <span class="res-status" *ngIf="data_target_status">Status:
                            <strong>{{data_target_status}}</strong></span>
                        </span>
                      </div>
                    </div>
                        <!-- <ngx-monaco-editor formControlName="response" [options]="editorPycodeOption"
                          (init)="jdbcResponseeditorInit($event)">
                        </ngx-monaco-editor> -->
                        <!-- <ngx-codemirror formControlName="response" id="ib_update_target_db_response"
                          #queryresponseEditor [options]="codeMirrorEditorOptions">
                        </ngx-codemirror> -->
                        <div style=" display: flex;  align-items:flex-start; position: relative;">
                          <json-editor style="flex:1" formControlName="response" [options]="editorSourceOptions"
                            id="ib_create_target_db_response">
                          </json-editor>
                          <mat-icon style="cursor: pointer;  position: absolute; top: 5px; right: 5px;"
                            (click)="copyResponse(dataTarget.controls.response.value)">
                            content_copy
                          </mat-icon>
                        </div>
                  </div>
                </mat-card>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_target_type == 3">
              <div class="ops-form-body">
                <mat-card class="m-card data-source">
                  <div class="m-body">
                    <mat-form-field class="target-businessObj" appearance="fill">
                      <mat-label>Data Lake Version</mat-label>
                      <!-- <input matInput formControlName="version" type="text"> -->
                      <mat-select #targetDlVersionDropdown formControlName="version" id="ib_update_target_dlVersion"
                        (selectionChange)="onChangeDTGetDlversion($event)" panelClass="custom-overlay-panel" 
                        (openedChange)="onDropdownOpened($event, targetDlVersionDropdown)" required>
                        <mat-option *ngFor="let version of targetVerisonListDL" [value]="version">
                          {{ version.dlversion }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <div style="display: grid;grid-template-columns: 15% 85%;grid-column-gap: 2px;">
                      <div>
                        <p style="margin-top:20px !important">
                          <span style="background: #ddd;">bizintel360-</span>
                        </p>
                      </div>
                      <div>
                        <mat-form-field appearance="outline" style="width: 55%;">
                          <mat-label class="bold-label">Index / Table Name</mat-label>
                          <input type="text" matInput formControlName="index_name" [matAutocomplete]="autoTarget"  id="ib_update_target_index_name"
                            (keydown)="bridgenameCheck($event)" (keydown.enter)="$event.preventDefault()" required>
                            <mat-autocomplete #autoTarget="matAutocomplete" [displayWith]="displayIndexName">

                              <mat-option *ngFor="let option of filteredTargetOptions|async" [value]="option">
                                {{ option }}
                              </mat-option>

                          </mat-autocomplete>
                        </mat-form-field>
                      </div>
                    </div>
                    <mat-form-field class="target-businessObj" appearance="fill">
                      <mat-label>Action Type</mat-label>
                      <mat-select #targetDlActionTypeDropdown formControlName="action_type" id="ib_update_target_action_type"
                        (selectionChange)="changeActionTypeList()" panelClass="custom-overlay-panel" 
                        (openedChange)="onDropdownOpened($event, targetDlActionTypeDropdown)">
                        <mat-option *ngFor="let type of actionTypeListDLO" [value]="type.actionTypevalue">
                          {{ type.actionTypeTitle }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline"
                      *ngIf="datatarget_action_type == 'upsert' || datatarget_action_type == 'update' || datatarget_action_type == 'delete'">
                      <mat-label class="bold-label">Primary Key</mat-label>
                      <input type="text" matInput formControlName="primary_key" id="ib_update_target_primary_key"
                        (keydown.enter)="$event.preventDefault()">
                    </mat-form-field>
                    <mat-form-field class="target-businessObj" appearance="fill">
                      <mat-label>Ingestion Type</mat-label>
                      <mat-select #targetDlIngestionTypeDropdown formControlName="indexing_type" id="ib_update_target_index_type" 
                        panelClass="custom-overlay-panel" (openedChange)="onDropdownOpened($event, targetDlIngestionTypeDropdown)">
                        <mat-option *ngFor="let type of indexingTypeListDLO" [value]="type.indexTypevalue">
                          {{ type.indexTypeTitle }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </mat-card>
              </div>
            </mat-card>
            <mat-card class="m-card system" *ngIf="bridge_target_type == 4">

              <!-- <label class="ops-lab">Operations Property - Email</label> -->
              <div class="ops-form-body">


                <mat-tab-group class="views-options-data-group-email" fitInkBarToContent mat-stretch-tabs="false"
                  mat-align-tabs="start" animationDuration="0ms" [(selectedIndex)]="indexSelectionEmailTarget">
                  <mat-tab label="Compose">
                    <mat-card class="m-card data-source">
                      <div class="m-body">
                        <!-- <mat-form-field appearance="outline">
                          <mat-label class="bold-label">To</mat-label>
                          <input type="text" matInput formControlName="to" id="ib_update_target_email_to"
                            (keydown.enter)="$event.preventDefault()">
                        </mat-form-field> -->
                        <mat-form-field class="email-list">
                          <mat-label>To</mat-label>
                          <mat-chip-grid #chipGridTargetTo aria-label="Enter emails">
                            <mat-chip-row *ngFor="let email of emailsTarTo" (removed)="removeEmailTarTo(email)"
                              [editable]="true" (edited)="editEmailTarTo(email, $event)"
                              [aria-description]="'press enter to edit ' + email">
                              {{email}}
                              <button matChipRemove [attr.aria-label]="'removeEmail ' + email">
                                <mat-icon>cancel</mat-icon>
                              </button>
                            </mat-chip-row>
                            <input placeholder="New email..." [matChipInputFor]="chipGridTargetTo" formControlName="to"
                              id="ib_update_target_email_to" [matChipInputSeparatorKeyCodes]="separatorKeysCodesTarTo"
                              [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addEmailTarTo($event)">
                          </mat-chip-grid>
                        </mat-form-field>
                        <!-- <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Cc</mat-label>
                          <input type="text" matInput formControlName="cc" id="ib_update_target_email_cc"
                            (keydown.enter)="$event.preventDefault()">
                        </mat-form-field> -->
                        <mat-form-field class="email-list">
                          <mat-label>Cc</mat-label>
                          <mat-chip-grid #chipGridTargetCc aria-label="Enter emails">
                            <mat-chip-row *ngFor="let email of emailsTarCc" (removed)="removeEmailTarCc(email)"
                              [editable]="true" (edited)="editEmailTarCc(email, $event)"
                              [aria-description]="'press enter to edit ' + email">
                              {{email}}
                              <button matChipRemove [attr.aria-label]="'removeEmail ' + email">
                                <mat-icon>cancel</mat-icon>
                              </button>
                            </mat-chip-row>
                            <input placeholder="New email..." [matChipInputFor]="chipGridTargetCc" formControlName="cc"
                              id="ib_create_target_email_cc" [matChipInputSeparatorKeyCodes]="separatorKeysCodesTarCc"
                              [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addEmailTarCc($event)">
                          </mat-chip-grid>
                        </mat-form-field>
                        <!-- <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Bcc</mat-label>
                          <input type="text" matInput formControlName="bcc" id="ib_update_target_email_bcc"
                            (keydown.enter)="$event.preventDefault()">
                        </mat-form-field> -->
                        <mat-form-field class="email-list">
                          <mat-label>Bcc</mat-label>
                          <mat-chip-grid #chipGridTargetBcc aria-label="Enter emails">
                            <mat-chip-row *ngFor="let email of emailsTarBcc" (removed)="removeEmailTarBcc(email)"
                              [editable]="true" (edited)="editEmailTarBcc(email, $event)"
                              [aria-description]="'press enter to edit ' + email">
                              {{email}}
                              <button matChipRemove [attr.aria-label]="'removeEmail ' + email">
                                <mat-icon>cancel</mat-icon>
                              </button>
                            </mat-chip-row>
                            <input placeholder="New email..." [matChipInputFor]="chipGridTargetBcc"
                              formControlName="bcc" id="ib_create_target_email_bcc"
                              [matChipInputSeparatorKeyCodes]="separatorKeysCodesTarBcc"
                              [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addEmailTarBcc($event)">
                          </mat-chip-grid>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Subject</mat-label>
                          <input type="text" matInput formControlName="subject" id="ib_update_target_email_sub"
                            (keydown.enter)="$event.preventDefault()">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Source Key</mat-label>
                          <input type="text" matInput formControlName="source_key" id="ib_update_target_email_sKey"
                            (keydown.enter)="$event.preventDefault()">
                        </mat-form-field>
                        <div class="mat-form-field">
                          <ckeditor formControlName="body" [config]="ckEditorConfig" id="ib_update_target_email_body">
                          </ckeditor>
                        </div>
                      </div>
                    </mat-card>
                  </mat-tab>
                  <mat-tab label="Attachment" style="margin-left:5px">
                    <mat-card class="m-card data-source">
                      <div class="m-body">
                        <div class="image-xe profile-image">
                          <div class="file-upload">
                            <p style="color: #000000; padding: 10px 0;">
                              <span>
                                Is Attachment ?
                              </span>
                              <mat-slide-toggle style="text-align:right;" id="ib_update_target_email_attach_toggle"
                                [checked]="isEmailCheked" (change)="isAttachmentToggleDT($event)"></mat-slide-toggle>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="m-body" *ngIf="targetAttachment == 'yes'"><!-- *ngIf="attachment == 'yes'" -->
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">File Name</mat-label>
                          <input type="text" matInput formControlName="file_name" id="ib_update_target_email_file"
                            (keydown.enter)="$event.preventDefault()">
                        </mat-form-field>
                      </div>
                    </mat-card>
                  </mat-tab>
                  <mat-tab label="Settings" style="margin-right:5px">

                    <mat-card class="m-card data-source">
                      <div class="m-body">
                        <div class="data-btn">
                          <button mat-raised-button type="button" class="btn-test" id="ib_update_target_email_test_btn"
                            (click)="checkTokenSessionBeforeTestEmailApiDT(dataTarget.value)">Test</button>
                        </div>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">From</mat-label>
                          <input type="text" matInput formControlName="From" required id="ib_update_target_email_from"
                            (keydown.enter)="$event.preventDefault()">
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Password</mat-label>
                          <input type="password" matInput formControlName="email_password"
                            id="ib_update_target_email_password" (keydown.enter)="$event.preventDefault()" required>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Mail Server</mat-label>
                          <input type="text" matInput formControlName="mailserver" id="ib_update_target_email_mServer"
                            (keydown.enter)="$event.preventDefault()" required>
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                          <mat-label class="bold-label">Port Number</mat-label>
                          <input type="number" (keypress)="portEmailChange($event)" matInput formControlName="email_port_number"
                            id="ib_update_target_email_port" (keydown.enter)="$event.preventDefault()">
                        </mat-form-field>
                      </div>
                    </mat-card>
                  </mat-tab>
                </mat-tab-group>


              </div>

            </mat-card>
            <div class="action-btn-section">
              <button mat-stroked-button matStepperPrevious class="previous" id="ib_update_target_prev_btn">
                <mat-icon matSuffix>west</mat-icon>Previous
              </button>
              <button mat-stroked-button matStepperNext class="next" id="ib_update_target_next_btn">
                Next<mat-icon matSuffix>east</mat-icon>
              </button>
            </div>
          </form>
        </mat-step>

        <!-- <mat-step [stepControl]="mapping">
          <form [formGroup]="mapping">
            <ng-template matStepLabel>Mapping</ng-template>
            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Visual Mapping</span>
              </mat-card-title>
              <div *ngIf = "bubbleshow" class="reset" style="margin-left: -125px;margin-top: 60px;">
                <span style="float: right;margin-top: -12px;font-size: 18px;cursor: pointer;" (click) = "closebubble()">&times;</span>
                <p>Click reset to original mapping</p>
                <button mat-raised-button style="float: right;" (click) = "closebubble()">Got It</button>
              </div>
              <div *ngIf = "sourcetotarget" class="map" style="margin-left: -133px;margin-top: 92px;">
                <span style="float: right;margin-top: -12px;font-size: 18px;cursor: pointer;" (click) = "closesourcetotarget()">&times;</span>
                <p>Map Source data with Target data</p>
                <button mat-raised-button style="float: right;" (click) = "closesourcetotarget()">Got It</button>
              </div>
              <div class="m-body">
                <button mat-raised-button class="btn" (click)="resetMapping()">Rest to Original Mapping</button>
                <div class="mapping" *ngIf="isMappingActive">
                  <table class="mapping-column">
                    <tr>
                      <th>Source Column</th>
                    </tr>
                    <div style="max-height: 535px;overflow-y: auto;overflow-x: hidden;">
                    <tr *ngFor="let element of bridgeSourceResponseMapping; let i=index">
                      <td (click)="pickSourceColumn(element, i)" [class.selected-source]="element.selected">{{element.source_column}} <span style="color: #3a94d9;font-size: 15px;">[{{element.type}}]</span></td>
                    </tr>
                  </div>
                  </table>
                  <table mat-table [dataSource]="bridgeSourceResponseMapping" class="m-table source-table mat-elevation-z8">
                    <ng-container matColumnDef="source">
                      <th mat-header-cell *matHeaderCellDef> Source Column </th>
                      <td mat-cell *matCellDef="let element;" (click)="pickSourceColumn(element)" [class.hidden]="element.isDeleted == true"> {{element.key}} </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedSourceColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedSourceColumns;"></tr>
                  </table> -->

        <!-- <div cdkDropListGroup>
                    <div class="example-container">
                      <h2>Source Column</h2>
                      <div
                        cdkDropList
                        [cdkDropListData]="bridgeSourceResponseMapping"
                        class="example-list"
                        (cdkDropListDropped)="drop($event)">
                        <div class="example-box" *ngFor="let item of bridgeSourceResponseMapping" cdkDrag>{{item.key}}</div>
                      </div>
                    </div>

                    <div class="example-container">
                      <h2>Target Column</h2>
                      <div
                        cdkDropList
                        [cdkDropListData]="bridgeTargetResponseMapping"
                        class="example-list"
                        (cdkDropListDropped)="drop($event)">
                        <div class="example-box" *ngFor="let item of bridgeTargetResponseMapping" cdkDrag>{{item.key}}</div>
                      </div>
                    </div>
                  </div> -->

        <!-- <table class="mapping-column">
                    <tr>
                      <th>Target Column</th>
                      <th>Mapping Column</th>
                    </tr>
                    <div style="max-height: 535px;overflow-y: auto;overflow-x: hidden;">
                    <tr *ngFor="let element of bridgeTargetResponseMapping; let i=index">
                      <td>{{element.target_column}} <span style="color: #3a94d9;font-size: 15px;">[{{element.type}}]</span></td>
                      <td (click)="mapToTargetColumn(element)">
                        <mat-chip-list *ngIf="element.isMapped" #chipList aria-label="mapping">
                        <mat-chip [color]="matChipColor">
                          {{element.mapping_source_column}}
                          <button class="mat-chip" matChipRemove (click)="unmapSource(element)">
                            <mat-icon>cancel</mat-icon>
                          </button>
                        </mat-chip>
                      </mat-chip-list></td>
                    </tr>
                    </div>
                  </table> -->

        <!-- <table mat-table [dataSource]="bridgeTargetResponseMapping" class="m-table target-table mat-elevation-z8">
                    <ng-container matColumnDef="target">
                      <th mat-header-cell *matHeaderCellDef> Target Column </th>
                      <td mat-cell *matCellDef="let element"> {{element.key}} </td>
                    </ng-container>

                    <ng-container matColumnDef="mapping">
                      <th mat-header-cell *matHeaderCellDef> Mapping Column </th>
                      <td mat-cell *matCellDef="let element;" (click)="mapToTargetColumn(element)">
                        <mat-chip-list *ngIf="element.mapping != ''" #chipList aria-label="mapping">
                          <mat-chip [color]="matChipColor">
                            {{element.mapping}}
                            <button matChipRemove (click)="unmapSource(element)">
                              <mat-icon>cancel</mat-icon>
                            </button>
                          </mat-chip>
                        </mat-chip-list>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedTargetColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedTargetColumns;"></tr>
                  </table> -->
        <!-- </div>
              </div>
            </mat-card>
            <div class="action-btn-section">
              <button mat-stroked-button matStepperPrevious class="previous">
                <mat-icon matSuffix>west</mat-icon>Previous
              </button>
              <button mat-stroked-button matStepperNext class="next">
                Next<mat-icon matSuffix>east</mat-icon>
              </button>
            </div>
          </form>
        </mat-step>  -->

        <mat-step [stepControl]="summary" [completed]="false">
          <form [formGroup]="summary">
            <ng-template matStepLabel>Summary</ng-template>
            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Integration Bridge</span>
              </mat-card-title>
              <div class="m-body">
                <mat-form-field appearance="fill">
                  <mat-label>Integration Bridge Name</mat-label>
                  <input type="text" matInput placeholder="" id="ib_update_summary_bridge_name"
                  (keydown)="bridgenameCheck($event)"  formControlName="bridge_name" (keydown.enter)="$event.preventDefault()" required [readonly]="!isRename">
                </mat-form-field>
              </div>
              <div class="m-body">
                <mat-form-field appearance="outline">
                  <mat-label>Description</mat-label>
                  <textarea formControlName="bridge_description" style="height: 150px;" placeholder="Description"
                    id="ib_update_summary_description" matInput
                    required></textarea>
                </mat-form-field>
              </div>
            </mat-card>

            <mat-card *ngIf="bridge_source_type != 4" class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Schedule</span>
              </mat-card-title>
              <div>
                <mat-label style="font-weight: 500;">Timer Type</mat-label>
              </div>
              <div class="timer grid">
                <!-- <div> -->
                <span>Interval</span>
                <!-- </div> -->
                <div>
                  <mat-slide-toggle formControlName="timertype" id="ib_update_summary_timer_toggle"
                    [checked]="scheduleval" (change)="onchangetimertype()">
                  </mat-slide-toggle>
                </div>
                <!-- <div> -->
                <span>Schedule</span>
                <!-- </div> -->
              </div>
              <div class="timer">
                <mat-form-field appearance="fill" *ngIf="timertypeval == 'interval'">
                  <mat-label>Interval(in seconds)</mat-label>
                  <input type="number" matInput formControlName="interval" min="1" id="ib_update_summary_interval"
                    (keyup)="intervalChange($event)" (keydown.enter)="$event.preventDefault()">
                  <mat-error *ngIf="summary.get('interval').hasError('pattern')"
                    (keydown.enter)="$event.preventDefault()">
                    Minimum Value Should Be One!
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="fill" *ngIf="timertypeval == 'schedule'">
                  <mat-label>Schedule</mat-label>
                  <!-- (click)="openSchedular()" (keydown.enter)="$event.preventDefault()" -->
                  <input type="text" matInput formControlName="schedule" id="ib_update_summary_schedule"
                     (keydown.enter)="$event.preventDefault()">
                  <mat-error *ngIf="summary.get('schedule').hasError('pattern')">
                    Schedule does not allows negative values!
                  </mat-error>
                </mat-form-field>
                <button type="button" mat-button matSuffix aria-label="Search" (click)="openSchedular()" *ngIf="timertypeval == 'schedule'" style="height: 58px;margin-top: -16px;">
                  <mat-icon style="font-size: 2.125rem;height: 2.125rem;width: 2.125rem;margin-top:-10px">timer</mat-icon>
                  </button>
                <br>
                <mat-form-field class="time-zone" appearance="fill" *ngIf="timertypeval == 'schedule'">
                  <mat-label> Time Zone </mat-label>
                  <input type="text" placeholder="Search by country name" aria-label="Time Zone" matInput
                    formControlName="time_zone" [matAutocomplete]="autoTimeZone"
                    (keydown.enter)="$event.preventDefault()">
                  <mat-autocomplete #autoTimeZone="matAutocomplete" (optionSelected)="onChangeTimeZone($event)"
                    [displayWith]="displayFnTimeZone">
                    <mat-option *ngFor="let timezone of timezones$ | async" [value]="timezone">
                      {{ timezone.timezone }}
                    </mat-option>
                  </mat-autocomplete>
                  <button type="button" mat-button matSuffix aria-label="Search" id="time_zone_clear_btn">
                    <mat-icon>search</mat-icon>
                  </button>
                  <button type="button" mat-button id="time_zone_clear_btn" *ngIf="enableTimeZoneClearIcon" matSuffix
                    aria-label="Clear" (click)="clearTimeZone()">
                    <mat-icon>clear</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </mat-card>

            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Event Email</span>
                <span class="sub-content">Triggers Email on Start and Stop Action of Integration Bridge</span>
              </mat-card-title>
              <div class="timer grid">
                <mat-label style="font-weight: 500;">To</mat-label>
              </div>
              <mat-form-field class="email-list">
                <mat-label>Emails</mat-label>
                <mat-chip-grid #chipGrid aria-label="Enter mails">
                  <mat-chip-row *ngFor="let email of emails" (removed)="removeEmail(email)" [editable]="true"
                    (edited)="editEmail(email, $event)" [aria-description]="'press enter to edit ' + email">
                    {{email}}
                    <button matChipRemove [attr.aria-label]="'removeEmail ' + email">
                      <mat-icon>cancel</mat-icon>
                    </button>
                  </mat-chip-row>
                  <input placeholder="New email..." [matChipInputFor]="chipGrid"
                    [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur"
                    (matChipInputTokenEnd)="addEmail($event)" formControlName="alert_emails">
                </mat-chip-grid>
              </mat-form-field>
            </mat-card>

            <mat-card class="m-card data-target" [formGroup]="summary">
              <mat-card-title class="m-title">
                <span class="m-header">Advanced Settings</span>
              </mat-card-title>

              <div class="advance-toggle">
                <mat-slide-toggle formControlName="toggle" [checked]="showAdvancedSettings"
                  (change)="toggleAdvancedSettings()">
                </mat-slide-toggle>
                  <span *ngIf="showAdvancedSettings" style="color: red; padding: 20px;">Disable Advanced Settings</span>
                  <span *ngIf="!showAdvancedSettings" style="color: red; padding: 20px;">Enable Advanced Settings</span>
              </div>

              <br>
              <div *ngIf="showAdvancedSettings">
                <div>
                  <mat-label style="font-weight: 500; color: red;">
                    This section is for Advanced Users who understand Cloud Computing and Streaming Techs
                  </mat-label>
                </div>
                <br>
                <div style="height: 90px;">
                  <mat-form-field appearance="fill" style="width: 600px;">
                    <mat-label>Each Worker Capacity</mat-label>
                    <input type="number" matInput formControlName="sbs" min="1" (keyup)="advanceSettingSBS($event)"
                      (keydown.enter)="$event.preventDefault()">
                    <mat-error *ngIf="summary.get('sbs')?.hasError('min') || summary.get('sbs')?.hasError('max')"
                      (keydown.enter)="$event.preventDefault()">
                      Minimum value should be 1.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field class="mat-dropdown" appearance="outline" style="width: 600px;">
                    <mat-label>Number of Workers (workers needed for data transportation)</mat-label>
                    <mat-select placeholder="Number of Workers" formControlName="now">
                      <mat-option value="1">1</mat-option>
                      <mat-option value="2">2</mat-option>
                      <mat-option value="4">4</mat-option>
                      <mat-option value="6">6</mat-option>
                      <mat-option value="8">8</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div style="height: 90px;">
                  <mat-form-field appearance="fill" style="width: 600px;">
                    <mat-label>Source Response Wait Time</mat-label>
                    <input type="number" formControlName="srwt" min="4000" max="10000"
                      (keyup)="advanceSettingSRWT($event)" (keydown.enter)="$event.preventDefault()" matInput>
                    <mat-error *ngIf="summary.controls.srwt.errors?.outOfRange"
                      (keydown.enter)="$event.preventDefault()">
                      Minimum value should be 4000 and Maximum value should be 10000.
                    </mat-error>
                  </mat-form-field>
                </div>

                <div style="height: 90px;">
                  <mat-form-field appearance="fill" style="width: 600px;">
                    <mat-label>Log Size (in kb)</mat-label>
                    <input type="number" matInput formControlName="logsize" min="20" step="10" (keyup)="advanceSettingLogSize($event)"
                      (keydown.enter)="$event.preventDefault()">
                    <mat-error *ngIf="summary.get('logsize')?.hasError('min')"
                      (keydown.enter)="$event.preventDefault()">
                      Minimum value should be 20kb.
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </mat-card>

            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Summary</span>
                <span class="sub-content">Based on your information you provided here is your summary. Please confirm
                  that the details in each steps are correct to proceed</span>
              </mat-card-title>
              <mat-card-content class="mc-content">
                <div class="form-container">
                  <div class="list-info" *ngIf="bridge_source_type == 1">
                    <span>Data Source</span>
                    <span>{{isNewSource? dataSource.value.new_bridge_source: dataSource.value.bridge_source}}</span>
                  </div>
                  <div class="list-info" *ngIf="bridge_source_type != 1">
                    <span>Data Source</span>
                    <span>{{source_name_for_webSocket}}</span>
                  </div>
                  <div class="list-info" *ngIf="bridge_source_type == 1">
                    <span>Source Business Object</span>
                    <span>{{isNewSource? dataSource.value.new_bridge_source_business_object:
                      dataSource.value.bridge_source_business_object?.business_obj}}</span>
                  </div>
                  <!-- <div class="list-info" *ngIf="bridge_source_type != 1">
                    <span>Source Business Object</span>
                    <span>{{bridge_summary_source_bobj}}</span>
                  </div> -->
                  <div class="list-info" *ngIf="bridge_target_type == 1">
                    <span>Data Target</span>
                    <span>{{isNewTarget? dataTarget.value.new_bridge_target: dataTarget.value.bridge_target}}</span>
                  </div>
                  <div class="list-info" *ngIf="bridge_target_type != 1">
                    <span>Data Target</span>
                    <span>{{bridge_summary_target_name}}</span>
                  </div>
                  <div class="list-info" *ngIf="bridge_target_type == 1">
                    <span>Target Business Object</span>
                    <span>{{isNewTarget? dataTarget.value.new_bridge_target_business_object:
                      dataTarget.value.bridge_target_business_object?.business_obj}}</span>
                  </div>
                  <!-- <div class="list-info" *ngIf="bridge_target_type != 1">
                    <span>Target Business Object</span>
                    <span>{{bridge_summary_target_bobj}}</span>
                  </div> -->
                </div>
              </mat-card-content>
            </mat-card>

            <mat-card class="m-card data-target">
              <mat-card-title class="m-title">
                <span class="m-header">Additional Information</span>
              </mat-card-title>
              <mat-card-content class="mc-content">
                <div class="form-container">
                  <div class="list-info">
                    <span>Created By</span>
                    <span>{{integrationObj?.created_by}}</span>
                  </div>
                  <div class="list-info" *ngIf="integrationObj?.updated_by">
                    <span>Updated By</span>
                    <span>{{integrationObj?.updated_by}}</span>
                  </div>
                  <div class="list-info">
                    <span>Created Date</span>
                    <span>{{integrationObj?.created_date | date: 'medium'}}</span>
                  </div>
                  <div class="list-info" *ngIf="integrationObj?.updated_date">
                    <span>Updated Date</span>
                    <span>{{integrationObj?.updated_date | date: 'medium'}}</span>
                  </div>
                  <div class="list-info">
                    <span>Created IP Address</span>
                    <span>{{integrationObj?.created_ip_address}}</span>
                  </div>
                  <div class="list-info" >
                    <span>Updated IP Address</span>
                    <span>{{integrationObj?.updated_ip_address}}</span>
                  </div>
                  <!-- <div class="btn-signup-grid">
                    <button mat-raised-button type="submit" routerLink="/baseapp/integration"class="btn btn-signup">Go Back</button>
                  </div> -->
                  <div class="m-body">
                    <div class="btn-signup-grid">
                      <button mat-raised-button class="btn" id="ib_update_summary_cancel"
                        routerLink="/baseapp/integration">Cancel</button>
                      <button mat-raised-button type="submit" class="btn btn-signup" id="ib_update_summary_submit"
                        (click)="submit()" [disabled]="submitted">Update</button>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </form>
        </mat-step>
      </mat-stepper>
      <div class="about-frame" style="margin-top: 167px">
        <app-about-page *ngIf="hide1024"></app-about-page>
        <div *ngIf="isPreviewRequestShow" style="margin-top: 20px" id="postman-preview">
          <mat-card class="preview-card">
            <mat-card-title class="preview-title">
              <div class="res-header">
                <span class="res-header preview-header">Preview Request</span>
                <span class="res-status">
                  <mat-icon style="cursor: pointer;" (click)="copyResponse(copyPreviewDataSource ? copyPreviewDataSource : copyPreviewData)">
                    content_copy
                  </mat-icon>
                </span>
              </div>
            </mat-card-title>
            <mat-card-content class="preview-body">
              <p>Method : {{items[selectedIndex==0?'source':'target'][4]?.requestMethod}}</p>
              <p>Request URL : <span style="color: rgb(62, 62, 250);">{{items[selectedIndex==0?'source':'target'][4]?.requestUrl}}</span></p>
              <div *ngFor="let item of items[selectedIndex==0?'source':'target'];let index = index">
                <ng-container *ngIf="index<4">
                  <div class="column-content" (click)="showSubItem(index)">
                    <mat-icon *ngIf="visibleIndex !== index" matSuffix>arrow_forward</mat-icon>
                    <mat-icon *ngIf="visibleIndex === index" matSuffix>arrow_downward</mat-icon>
                    <p>
                      {{item.name}}
                    </p>
                  </div>
                  <div *ngIf="visibleIndex === index" class="preview-subheader" style="margin-left:35px;">
                    <span *ngFor="let subItem of item.subItems" let index=index>
                      <span *ngIf="item?.name == 'Request Header'">
                        <p>{{subItem.headerKey}} : <span style="color: rgb(62, 62, 250);">{{subItem.headerValue}}</span>
                        </p>
                      </span>
                      <span *ngIf="item?.name == 'Request Params'">
                        <p>{{subItem.paramKey}} : <span style="color: rgb(62, 62, 250);">{{subItem.paramValue}}</span>
                        </p>
                      </span>
                      <span *ngIf="item?.name == 'Request Body'">
                        <div class="preview-script-border">
                          <ngx-codemirror [(ngModel)]="subItem.requestBody" (keydown.enter)="$event.preventDefault()"
                            #previewPostmanEditor [options]="previewPostmanCodeMirrorEditor">
                          </ngx-codemirror>
                        </div>
                      </span>
                      <span *ngIf="item?.name == 'Pre Request Script'">
                        <div class="preview-script-border">
                          <ngx-codemirror [(ngModel)]="subItem.preRequestScript"
                            (keydown.enter)="$event.preventDefault()" #previewPostmanEditor
                            [options]="previewPostmanCodeMirrorEditor">
                          </ngx-codemirror>
                        </div>
                      </span>
                    </span>
                  </div>
                </ng-container>
              </div>
            </mat-card-content>
          </mat-card>
          <!-- <app-postman-preview [postmanPreviewData]="postmanPreviewData"></app-postman-preview> -->
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</ion-content>
<ion-footer *ngIf="showConsole">
  <ion-progress-bar *ngIf="loader" type="indeterminate" color="danger" style="z-index:3 !important;"></ion-progress-bar>
  <ion-toolbar (click)="showBottomSheet()"
    style="height: 25px; --min-height: 27px; border-top:1px solid #999 ;--background: #bae0fc; --color: black;">
    <ion-buttons slot="start">
      <div style="display: flex;">
        <mat-icon class="icon terminal"
          style="padding: 0px 5px;width: 30px;vertical-align: baseline; font-size: 18px">terminal</mat-icon>
        <ion-text style="font-size: 12px;margin: 0px 6px;vertical-align: super;">Console</ion-text>
      </div>
    </ion-buttons>
    <div style="float:right;">
      <span style="cursor: pointer;" (click)="cancelconsole($event)"><ion-icon slot="start" name="close-circle-outline" style="font-size:16px !important; margin-top: 3px !important; margin-right: 2px !important;pointer-events: none !important;"></ion-icon></span>
    <button (click)="cancelconsole($event)" class="console-cancel-button">Cancel</button></div>
  </ion-toolbar>
</ion-footer>
<div id="dummyFocusElement" tabindex="10" style="opacity: 0; position: absolute; pointer-events: none;"></div>